// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-11-03T23:01:16.078Z
// Property: Highland Park Apartment Homes (ID: 6767906449167600)
// Collections: 27 amenities, 8 floorplans (live), 49 photos, 68 POIs, 4 reviews, 7 virtual tours, 6 office hours, 17 faqs
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5767906449162465",
  "multihub_property_id": "6767906449167600",
  "property_external_id": "1124102",
  "property_zillow_url": null,
  "property_apartments_url": "https://www.apartments.com/highland-park-apartment-homes-overland-park-ks/pcmsysr/",
  "property_google_business_url": "https://www.google.com/maps/place/Highland+Park+Apartment+Homes/@38.940512,-94.7074708,890m/data=!3m2!1e3!4b1!4m6!3m5!1s0x87c0ecbd8a9d0297:0x94baa04d2b0664b6!8m2!3d38.940512!4d-94.7074708!16s%2Fg%2F1tdvf2r0?entry=ttu&g_ep=EgoyMDI2MDkxNS4wIKXMDSoASAFQAw%3D%3D",
  "property_linkedin_url": null,
  "property_hubspot_id": null,
  "property_crm_software": "RentCafe",
  "property_pm_software": "Yardi",
  "property_pm_info": "1124102 p1099054",
  "property_status": null,
  "property_slug": "highland-park-apartment-homes",
  "property_name": "Highland Park Apartment Homes",
  "property_website_url": "https://www.highlandparkaptskc.com/",
  "property_domain": "https://www.highlandparkaptskc.com/",
  "property_address": "10334 Goddard St",
  "property_full_address": "10334 Goddard St, Overland Park, KS 66214",
  "property_address_1": "10334 Goddard St",
  "property_address_2": null,
  "property_address_city": "Overland Park",
  "property_address_state": "KS",
  "property_address_zip_full": null,
  "property_address_zip": "66214",
  "property_address_country": "US",
  "property_address_county": "Johnson County",
  "property_neighborhood_address": "Lincoln Highlands",
  "property_address_latitude": "38.9406483",
  "property_address_longitude": "-94.7075682",
  "property_email": "rentcafe.hp@pricekc.com",
  "property_phone": "(913) 347-5377",
  "property_call_tracking_phone": "913-347-5377",
  "property_company_name": "Price Brothers",
  "property_company_url": "https://www.pricebrotherskc.com/",
  "agency_contacts": null,
  "property_type": null,
  "property_short_description": "<p><strong>Renovated comfort in Lincoln Highlands.</strong> Discover one- and two-bedroom apartment homes with in-home laundry, walk-in closets, private outdoor space, and access to polished community amenities—then explore available layouts or schedule a closer look.</p>",
  "property_long_description": "<p>Welcome home to Highland Park Apartment Homes, where refreshed interiors, everyday comforts, and exciting community amenities come together in Overland Park, KS.</p><p>Discover one- and two-bedroom apartments featuring comfortable layouts, thoughtful finishes, and the convenience of in-home washers and dryers. Spend sunny afternoons relaxing by one of two swimming pools, stay active in the 24-hour fitness center, or enjoy a friendly game on the tennis, basketball, or sand volleyball courts.</p><p>With shopping, dining, parks, and major roadways nearby, Highland Park brings together the comforts you love and the convenience you need in a place you’ll love coming home to.</p><p>Ready to find your place at Highland Park? Explore our <a href=\"/floor-plans\">floor plans</a>, take a <a href=\"/virtual-tours\">virtual tour</a>, or <a href=\"/schedule-a-tour\">schedule a visit</a> to experience the community for yourself.</p>",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167600/01a01026-55d1-72ec-b85e-f6160b816461.webp",
  "property_featured_image_media": {
    "alt_text": "Modern white kitchen with quartz countertops and stainless steel appliances.",
    "public_id": "01a01026-55d1-72ec-b85e-f6160b816461",
    "storage_key": "property/6767906449167600/01a01026-55d1-72ec-b85e-f6160b816461.webp",
    "width": 800,
    "height": 600
  },
  "property_featured_video": null,
  "property_featured_video_media": null,
  "property_total_units": "432",
  "property_year_built": "1988",
  "property_year_renovated": null,
  "property_walk_score": null,
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": "94.67592592592592",
  "property_admin_fee": null,
  "property_application_fee": null,
  "property_fees_deposit_info": "Deposit: $175-275",
  "property_ispetfriendly": true,
  "property_allows_cats": true,
  "property_allows_dogs": true,
  "property_upfront_pet_fee": "300",
  "property_pet_deposit": "0",
  "property_monthly_pet_rent": "25",
  "property_max_pets": "2",
  "property_max_pet_weight_limit": "0",
  "property_pet_restrictions": "Restricted Breeds: Aggressive dog breeds including, but not limited to, Pit Bull, American Staffordshire Terrier, Rottweiler, German Shepherd, Malamute, Doberman Pinscher, Chow, Great Dane, Saint Bernard, Akita, Wolf Hybrid, and any mixed breed that includes the aforementioned, are specifically prohibited and Landlord has discretion to limit other breeds. Inherently dangerous or exotic, feral or wild animals are prohibited.",
  "property_pet_policy_description": "The non-refundable fee is $300 for 1 pet, and $500 for 2 pets.",
  "property_petpolicy_info": "https://www.pricebrotherskc.com/petroyaltyclub/",
  "property_online_leasing_url": "https://highlandparkaptskc.securecafeapplicant.com/onlineleasing/content3/access/highland-park0/floorplans",
  "property_resident_portal_url": "https://highlandparkaptskc.securecafe.com/residentservices/highland-park0/userlogin.aspx",
  "property_apply_now_url": "https://highlandparkaptskc.securecafeapplicant.com/onlineleasing/content3/access/highland-park0/login",
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167600/019fc97b-8852-763d-a96f-50c7a33651a3.webp",
  "property_primary_logo_media": {
    "alt_text": "Highland Park Apartment Homes logo",
    "public_id": "019fc97b-8852-763d-a96f-50c7a33651a3",
    "storage_key": "property/6767906449167600/019fc97b-8852-763d-a96f-50c7a33651a3.webp",
    "width": 975,
    "height": 225
  },
  "property_secondary_logo": null,
  "property_secondary_logo_media": null,
  "property_icon": null,
  "property_icon_media": null,
  "property_fav_icon": null,
  "property_fav_icon_media": null,
  "property_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167600/019fc97b-8852-763d-a96f-50c7a33651a3.webp",
  "property_mono_white_logo_media": {
    "alt_text": "Highland Park Apartment Homes logo",
    "public_id": "019fc97b-8852-763d-a96f-50c7a33651a3",
    "storage_key": "property/6767906449167600/019fc97b-8852-763d-a96f-50c7a33651a3.webp",
    "width": 975,
    "height": 225
  },
  "property_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167600/019fc97c-676c-7648-b37d-43f946774794.webp",
  "property_mono_black_logo_media": {
    "alt_text": null,
    "public_id": "019fc97c-676c-7648-b37d-43f946774794",
    "storage_key": "property/6767906449167600/019fc97c-676c-7648-b37d-43f946774794.webp",
    "width": 975,
    "height": 225
  },
  "property_company_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162465/01a0d9b7-62d2-753a-a137-bd690ff6733b.webp",
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162465/019ff682-589f-76db-bc7c-d7916fa7e182.webp",
  "property_company_logo_media": null,
  "property_company_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162465/019ff68a-de80-741a-9687-3e84c8c517e3.webp",
  "property_company_mono_black_logo_media": null,
  "property_company_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162465/019ff682-589f-76db-bc7c-d7916fa7e182.webp",
  "property_company_mono_white_logo_media": null,
  "property_primary_color": "#006850",
  "property_secondary_color": "#E6AE4F",
  "property_font_color": null,
  "property_color_4": "#B41F2A",
  "property_color_3": "#B45B27",
  "property_color_5": "#740F1C",
  "property_color_6": null,
  "property_color_7": null,
  "property_color_8": null,
  "property_bedrooms_range": "1 - 2",
  "property_bedrooms_min": "1",
  "property_bedrooms_max": "2",
  "property_bathrooms_range": "1 - 2",
  "property_bathrooms_min": "1",
  "property_bathrooms_max": "2",
  "property_sqft_range": "540 - 972",
  "property_sqft_min": "540",
  "property_sqft_max": "972",
  "property_price_range": "1242 - 4783",
  "property_price_min": "1242",
  "property_price_max": "4783",
  "property_available_units": 23,
  "property_facebook_url": "https://www.facebook.com/HighlandParkAptsKC",
  "property_instagram_url": "https://www.instagram.com/highlandparkaptskc/",
  "property_twitter_url": null,
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJlwKdir3swIcRtmQGK02gupQ",
  "property_youtube_url": "https://www.youtube.com/user/Pricebrothersmgt",
  "property_yelp_url": null,
  "property_tiktok_url": null,
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": "Welcome to Highland Park Apartment Homes",
  "property_home_romance_title": "Embrace Comfort and Connection in Your New Apartment Home",
  "property_home_amenities_blurb": "<p>Life at Highland Park goes beyond your front door. Spend warm afternoons lounging by one of our two swimming pools, fit in a workout at the 24-hour fitness center, or find your flow in the yoga room. Enjoy a little friendly competition on the tennis, basketball, and sand volleyball courts, or unwind in the renovated clubhouse with comfortable gathering spaces. With planned resident events, on-call maintenance, and everyday conveniences close to home, Highland Park gives you more ways to make the most of your day.</p>",
  "property_home_floorplans_blurb": "<p>Find a space that feels like yours at Highland Park Apartment Homes. Our one- and two-bedroom apartments offer everyday conveniences like an in-home washer and dryer, ceiling fans in the bedrooms, and a private patio or balcony with extra storage. Looking for a few extra touches? Select homes feature quartz countertops, stainless steel appliances, tile backsplashes, plank flooring, vaulted ceilings, fireplaces, and sunrooms. With Classic and Luxury Finish options available, you can explore the features and style that fit what you’re looking for.</p>",
  "property_home_gallery_blurb": "<p><strong>Picture Highland Park in Overland Park.</strong> Preview bright kitchens with crisp cabinetry, polished finishes, fireplaces, built-ins, sunrooms, balconies, and smart storage. Then look beyond the apartment interiors to poolside seating, a refreshed clubhouse lounge, a 24-hour fitness center with yoga room, and outdoor courts that bring extra energy to the community. Browse the full gallery to see the details up close.</p>",
  "property_home_neighborhood_blurb": "<p>Enjoy the convenience of having more of Overland Park within easy reach. Located near 103rd Street, Highland Park Apartment Homes puts shopping, dining, parks, and everyday essentials close to home. Explore nearby destinations like Oak Park Mall, spend an afternoon at Meadowbrook Park, or discover local art at the Nerman Museum of Contemporary Art. With convenient access to Highway 69 and I-435, getting around Johnson County and the greater Kansas City area is simple, too. Whether you’re heading out for errands, meeting friends for dinner, or planning your next weekend adventure, Highland Park keeps you connected to more of what you love.</p>",
  "property_home_reviews_blurb": "<p><strong>Residents have plenty to praise at Highland Park.</strong> Reviews often call out the friendly office team, responsive maintenance, and an Overland Park location described as “unbeatable.” Inside the apartments, everyday favorites include in-home laundry, dishwashers, fireplaces, high ceilings, spacious layouts, and balconies. Read the reviews, then see what makes Highland Park feel easy to call home.</p>",
  "property_neighborhood_blurb": "<p>Highland Park Apartment Homes is located at 10334 Goddard Street near 103rd Street in Overland Park, KS, with Highway 69 and I-435 nearby for commutes across Johnson County and the Kansas City metro. Oak Park Mall is a short drive away for shopping and dining.</p><p>Looking for a place to eat near Highland Park? Our team recommends Garozzo’s for Italian, Rosati’s Pizza for a casual night in, Stockyards Brewing for craft beer, and Entity Lounge for a night out. Grab coffee at Brew Haha Coffeehouse, bowl a few frames at Lucky Strike Overland Park, and finish with ice cream at The Golden Scoop.</p><p>For time outdoors, Meadowbrook Park and Thomas S. Stoll Memorial Park offer trails and green space. The Nerman Museum of Contemporary Art at Johnson County Community College is nearby for an afternoon of local art.</p>",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "<p>Highland Park Apartment Homes is one of the few Overland Park apartment communities with two swimming pools, each with tanning lounges. Residents also have a 24-hour fitness center with a yoga room and free weights, a clubhouse with a kitchen and seating, and tennis, basketball, and sand volleyball courts. The fitness center and clubhouse were both renovated in 2025.</p><p>Inside, every apartment has an in-home washer and dryer, ceiling fans in the bedrooms, and a private patio or balcony with extra storage. Select homes add quartz countertops, stainless steel appliances, tile backsplashes, plank flooring, vaulted ceilings, a fireplace, or a sunroom.</p><p><a href=\"/schedule-a-tour\">Schedule a tour</a> to see it all in person.</p>",
  "property_applynow_blurb": "<p><strong>Start your application at Highland Park.</strong> Choose a renovated one- or two-bedroom apartment with everyday comforts like an in-home washer and dryer, walk-in closet, and private balcony or patio. Explore <a href=\"/floor-plans\">available floor plans</a>, then apply online when you’re ready to make this Overland Park community home.</p>",
  "property_contactus_blurb": "<p>Have questions? We’re here to help! Whether you’re exploring <a href=\"/floor-plans\">floor plans</a>, checking apartment availability, learning more about our <a href=\"/pet-policy\">pet policy</a>, or getting ready to <a href=\"/schedule-a-tour\">schedule a tour</a>, the Highland Park Apartment Homes leasing team would love to hear from you.</p><p>Give us a call, send us a message, or stop by our leasing office. We’re happy to help you explore your options and find a place to call home.</p>",
  "property_faqs_blurb": "<p><strong>Questions about Highland Park?</strong> Start here for quick answers about the community, leasing, apartment features, and everyday life in this renovated Overland Park setting. If you need anything more specific, the leasing team is happy to help you plan a closer look.</p>",
  "property_floorplans_blurb": "<p>Highland Park Apartment Homes offers eight one- and two-bedroom floor plans in Overland Park, KS, ranging from 540 to 1,056 square feet. Looking for a 2 bedroom apartment in Overland Park? Highland Park’s two-bedroom layouts give you room for a home office, guest room, or roommate.</p><p>Every apartment includes an in-home washer and dryer, ceiling fans in the bedrooms, and a private patio or balcony with extra storage. Choose a Classic Finish home, or upgrade to a Luxury Finish home with quartz countertops, stainless steel appliances, white cabinetry, tile backsplashes, and plank flooring. Select homes add vaulted ceilings, a fireplace, a sunroom, or a walk-in shower.</p><p>Compare pricing and availability above, or take a <a href=\"/virtual-tours\">virtual tour</a> to find your favorite.</p>",
  "property_gallery_blurb": "<p>Take a closer look at life at Highland Park Apartment Homes. From refreshed apartment interiors to inviting community amenities, our photo gallery gives you a glimpse of what makes our Overland Park community feel like home.</p><p>Picture yourself enjoying coffee on your private patio or balcony, spending a sunny afternoon by one of the two swimming pools, or fitting in a workout at the 24-hour fitness center. Explore our Classic and Luxury Finish apartment interiors, renovated clubhouse, landscaped grounds, and outdoor recreation spaces to discover everything waiting for you at Highland Park.</p><p>Like what you see? Take a <a href=\"/virtual-tours\">virtual tour</a> or <a href=\"/schedule-a-tour\">schedule a visit</a> to experience your next home in person.</p>",
  "property_interactivemap_blurb": "<p>Finding your next apartment just got easier! Explore Highland Park Apartment Homes with our interactive property map and discover available apartments in Overland Park, KS.</p><p>Browse the community, compare apartment locations, and find the <a href=\"/floor-plans\">floor plan</a> and features that fit what you’re looking for. Filter available homes by bedrooms, bathrooms, square footage, pricing, and move-in date to narrow down your options.</p><p>Once you’ve found your favorite, review the details and start your application online. Have questions or want to see an apartment in person? Our <a href=\"/contact-us\">leasing team</a> is here to help you take the next step.</p>",
  "property_pets_blurb": "<p>Highland Park Apartment Homes offers pet-friendly apartments in Overland Park, KS, and welcomes dogs and cats. Up to two pets are allowed per apartment, and every pet owner joins the <a href=\"https://www.pricebrotherskc.com/petroyaltyclub/\" target=\"_blank\">Price Brothers Pet Royalty Club</a> with the one-time pet fee, which includes discounts at local pet businesses.</p><p>Have questions about your pet? The Highland Park <a href=\"/contact-us\">leasing team</a> is happy to help before you apply.</p><h2>Pet Policy</h2><ul><li>Dogs and cats welcome</li><li>Maximum of two pets per apartment</li><li>Monthly pet rent: $25 per pet</li><li>One-time non-refundable pet fee: $300 for one pet, $500 for two pets</li><li>Breed restrictions apply. Please contact the leasing office for the full list.</li></ul>",
  "property_referafriend_blurb": "<p><strong>Share renovated comfort in Overland Park.</strong> Love the in-home washer and dryer, walk-in closets, private outdoor space, sparkling pools, and refreshed fitness center? Refer a friend to Highland Park Apartment Homes and invite them to find their own one- or two-bedroom home here.</p>",
  "property_residentaccess_blurb": "<p><strong>Resident Access at Highland Park.</strong><br>Pay rent, submit maintenance requests, and manage your account with ease—so you can get back to the renovated comfort, thoughtful apartment details, and polished community spaces that make everyday living here feel effortless.</p>",
  "property_reviews_blurb": "<p><strong>Hear what residents appreciate most.</strong> As you browse reviews for Highland Park Apartment Homes, you’ll see recurring praise for the friendly office team, responsive maintenance, and a location residents call “unbeatable!”</p><p>Reviews also highlight the everyday comfort of apartment features like in-home laundry, dishwashers, fireplaces, high ceilings, roomy living spaces, and balconies. Longtime residents mention smooth moves between layouts, organized service, and a community they were happy to call home for years. See what residents are saying, then picture your own routine at Highland Park.</p>",
  "property_created_at": "1785791678126",
  "property_scheduletour_blurb": "<p>Ready to experience Highland Park Apartment Homes for yourself? We’d love to show you around! Schedule a tour of our apartments in Overland Park, KS, and discover the refreshed interiors, inviting community amenities, and everyday conveniences that make Highland Park a place to call home.</p><p>Explore the community with our leasing team, take a closer look at our two swimming pools, renovated clubhouse, and fitness center, and get answers to your questions about floor plans, pricing, and availability. Prefer to explore from home? Our interactive <a href=\"/virtual-tours\">360° virtual tours</a> make it easy to get started whenever it’s convenient for you.</p><p>Find a time that works for you and take the next step toward your new home at Highland Park!</p><h2>Guided Tours</h2><p>Please check in at the leasing office five minutes before your appointment and bring a valid government-issued photo ID.</p>",
  "property_thankyou_blurb": "<p><strong>Thank you—we’ve received your inquiry.</strong> The Highland Park leasing team will follow up soon. In the meantime, picture renovated comfort in Lincoln Highlands, with one- and two-bedroom layouts, in-home washer and dryer, private outdoor space, and polished community amenities near 103rd Street and Highway 69.</p>",
  "property_virtualtours_blurb": null,
  "property_copyright": "2026 All Rights Reserved. Highland Park Apartment Homes",
  "property_seo_title_home": "Overland Park Apartments: Highland Park Apartment Homes",
  "property_seo_description_home": "Highland Park Apartment Homes offers renovated 1- and 2-bedroom apartments in Overland Park, KS, with two pools, a 24-hour gym, and pet-friendly living.",
  "property_seo_title_floorplans": "1 & 2 Bed Apartments | Highland Park Apartment Homes",
  "property_seo_description_floorplans": "Compare 1- and 2-bedroom apartments in Overland Park, KS at Highland Park Apartment Homes. Eight layouts from 540 to 1,056 sq. ft. View availability today.",
  "property_seo_title_amenities": "Luxury Amenities | Highland Park Apartment Homes",
  "property_seo_description_amenities": "Highland Park Apartment Homes offers two pools, a 24-hour fitness center, tennis and volleyball courts, and in-home laundry in Overland Park, KS.",
  "property_seo_title_gallery": "Photos | Highland Park Apartment Homes, Overland Park",
  "property_seo_description_gallery": "View photos of Highland Park Apartment Homes in Overland Park, KS. See renovated interiors, two swimming pools, the fitness center, clubhouse, and more.",
  "property_seo_title_virtualtours": "Virtual Tours | Highland Park Apartment Homes Apartments",
  "property_seo_description_virtualtours": "Explore Highland Park Apartment Homes in Overland Park, KS! Take a virtual tour and imagine your life in our spacious one and two-bedroom apartments!",
  "property_seo_title_interactivemap": "Interactive Map | Highland Park Apartment Homes",
  "property_seo_description_interactivemap": "Use the Highland Park Apartment Homes interactive map to find available apartments in Overland Park, KS. Filter by bedrooms, price, and move-in date.",
  "property_seo_title_neighborhood": "Johnson County, KS | Highland Park Apartment Homes",
  "property_seo_description_neighborhood": "Highland Park Apartment Homes is minutes from JCCC, Oak Park Mall, and Overland Park Regional Medical Center, with easy access to Highway 69 and I-435.",
  "property_seo_title_contact": "Contact | Highland Park Apartment Homes, Overland Park",
  "property_seo_description_contact": "Contact Highland Park Apartment Homes at 10334 Goddard, Overland Park, KS 66214. Call (913) 347-5377 or send a message to our leasing team today.",
  "property_seo_title_faqs": "FAQs | Apartments in Overland Park, KS",
  "property_seo_description_faqs": "Uncover answers to your burning questions at Highland Park Apartment Homes! Enjoy luxurious amenities in Overland Park, KS. Your new home awaits!",
  "property_seo_title_reviews": "Resident Reviews | Apartments in Overland Park, KS",
  "property_seo_description_reviews": "Check out why residents love Highland Park Apartment Homes! Experience comfort, convenience, and community in Overland Park, KS. Your ideal home awaits!",
  "property_seo_title_applynow": "Apply Now | Apartments in Overland Park, KS",
  "property_seo_description_applynow": "Elevate your lifestyle at Highland Park Apartments! Enjoy spacious floor plans, top amenities, and a vibrant community. Lease online today!",
  "property_seo_title_residentaccess": "Resident Access | Highland Park Apartment Homes",
  "property_seo_description_residentaccess": "Unlock your Highland Park experience in Overland Park, KS! Log in to streamline rent payments, maintenance requests, and connect with your community today.",
  "property_seo_title_referafriend": "Refer A Friend | Highland Park Apartment Homes",
  "property_seo_description_referafriend": "Invite friends to share the charm of Highland Park Apartment Homes in Overland Park, KS. Great friends make great neighbors—refer someone today!",
  "property_seo_title_scheduletour": "Schedule a Tour | Highland Park Apartment Homes",
  "property_seo_description_scheduletour": "Schedule a guided or 360° tour of Highland Park Apartment Homes and explore renovated 1- and 2-bedroom apartments in Overland Park, KS. Book online today.",
  "property_seo_title_privacy": "Privacy Policy | Highland Park Apartment Homes",
  "property_seo_description_privacy": "Your privacy matters at Highland Park Apartment Homes. Learn how we safeguard your information in Overland Park, KS. View our privacy policy today!",
  "property_seo_title_accessibility": "Website Accessibility | Highland Park Apartment Homes",
  "property_seo_description_accessibility": "At Highland Park Apartment Homes in Overland Park, KS, we prioritize digital inclusion for a seamless, welcoming online experience.",
  "property_seo_title_sitemap": "Sitemap | Highland Park Apartment Homes",
  "property_seo_description_sitemap": "Navigate your way to your new home at Highland Park Apartment Homes in Overland Park, KS. Check out our sitemap for a seamless living experience!",
  "property_seo_title_thankyou": "Thank You | Highland Park Apartment Homes",
  "property_seo_description_thankyou": "Thank you for your interest in Highland Park Apartments in Overland Park, KS! Our team will reach out soon to assist you with your next home adventure.",
  "property_seo_title_pets": "Pet-Friendly Apartments | Highland Park Apartment Homes",
  "property_seo_description_pets": "Highland Park Apartment Homes welcomes dogs and cats in Overland Park, KS. Review our pet policy, fees, and pet perks, then schedule a tour today.",
  "property_updated_at": "1793742978183",
  "amenities": [
    {
      "id": "ec_28e2d37e9dfa39598b3a4eac",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167600",
      "source": "yardi",
      "external_id": "124088162",
      "title": "Free Weights",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167600/01a01026-62b4-72ed-9cf9-dd5fe29fa026.webp",
      "amenity_image_media": {
        "alt_text": "Dumbbell rack in a gym with hex dumbbells.",
        "public_id": "01a01026-62b4-72ed-9cf9-dd5fe29fa026",
        "storage_key": "property/6767906449167600/01a01026-62b4-72ed-9cf9-dd5fe29fa026.webp",
        "width": 800,
        "height": 1200
      },
      "amenity_image_alt_text": "A set of black TRUE dumbbells are on a rack.",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_131a8fe25c63890c4a4f1a25",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167600",
      "source": "yardi",
      "external_id": "87989783",
      "title": "Tennis Court",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167600/01a01026-61ef-7794-b7c1-9ddc6b9df5cb.webp",
      "amenity_image_media": {
        "alt_text": "Tennis court at the property with surrounding green space and buildings.",
        "public_id": "01a01026-61ef-7794-b7c1-9ddc6b9df5cb",
        "storage_key": "property/6767906449167600/01a01026-61ef-7794-b7c1-9ddc6b9df5cb.webp",
        "width": 1200,
        "height": 800
      },
      "amenity_image_alt_text": "Walkway leading to fenced tennis courts surrounded by open green space and apartment homes.,Aerial view of fenced tennis courts at Highland Park Apartment Homes.",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_9d299576e7f72b399d4c1dec",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167600",
      "source": "yardi",
      "external_id": "123877939",
      "title": "Clubhouse",
      "amount": "false",
      "description": "Renovated in 2025",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167600/01a01026-7735-7467-a2bc-438b5b52211a.webp",
      "amenity_image_media": {
        "alt_text": "Community dining area with booth seating and tables.",
        "public_id": "01a01026-7735-7467-a2bc-438b5b52211a",
        "storage_key": "property/6767906449167600/01a01026-7735-7467-a2bc-438b5b52211a.webp",
        "width": 3072,
        "height": 2048
      },
      "amenity_image_alt_text": "Common Room at Highland Park Apartment Homes, Overland Park, KS,Clubroom at Highland Park Apartment Homes, Overland Park, Kansas,Fireplace Lounge at Highland Park Apartment Homes, Overland Park, KS, 66214,Kitchen And Dining Area at Highland Park Apartment Homes, Overland Park, KS",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_da05b0451ccdd795f85d4149",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167600",
      "source": "yardi",
      "external_id": "87989784",
      "title": "Two Sparkling Swimming Pools",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167600/01a01026-6516-71fc-b32e-4dff02e505ea.webp",
      "amenity_image_media": {
        "alt_text": "Aerial view of a community pool and clubhouse with surrounding buildings and lush greenery.",
        "public_id": "01a01026-6516-71fc-b32e-4dff02e505ea",
        "storage_key": "property/6767906449167600/01a01026-6516-71fc-b32e-4dff02e505ea.webp",
        "width": 1200,
        "height": 900
      },
      "amenity_image_alt_text": "Drone view of the pool, clubhouse, and surrounding apartment community at Highland Park.,An aerial view of one of two outdoor swimming pools at Highland Park Apartment Homes, Kansas, 66214",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_cb6cb6b89e5ea145732f1617",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167600",
      "source": "yardi",
      "external_id": "87989771",
      "title": "24-Hour Fitness Center with Yoga Room",
      "amount": "false",
      "description": "Renovated in 2025",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167600/01a01026-6ae7-74ba-ac37-8df02ae1277c.webp",
      "amenity_image_media": {
        "alt_text": "LeMond exercise bike and air rower in community gym.",
        "public_id": "01a01026-6ae7-74ba-ac37-8df02ae1277c",
        "storage_key": "property/6767906449167600/01a01026-6ae7-74ba-ac37-8df02ae1277c.webp",
        "width": 3072,
        "height": 2048
      },
      "amenity_image_alt_text": "A close up of a Lemond brand exercise bike. at Highland Park Apartment Homes, Kansas,A close up of a True bike workout machine with a digital screen and handlebars. at Highland Park Apartment Homes, Kansas,A gym with a variety of equipment including treadmills, weights, and exercise machines. at Highland Park Apartment Homes, Overland Park, KS,A gym with a variety of equipment including treadmills, weights, and exercise machines. at Highland Park Apartment Homes, Overland Park, 66214",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_d2639673c0935bb49ec9a8e4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167600",
      "source": "yardi",
      "external_id": "87989773",
      "title": "Carports Available",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167600/01a01026-7252-7288-a8a3-35e4f434eab2.webp",
      "amenity_image_media": {
        "alt_text": "Covered parking spaces for residents with numbered stalls.",
        "public_id": "01a01026-7252-7288-a8a3-35e4f434eab2",
        "storage_key": "property/6767906449167600/01a01026-7252-7288-a8a3-35e4f434eab2.webp",
        "width": 1200,
        "height": 800
      },
      "amenity_image_alt_text": "Covered resident carports at Highland Park Apartment Homes in Overland Park, Kansas.",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_285b755b12ff1eea0eb83334",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167600",
      "source": "yardi",
      "external_id": "123761171",
      "title": "Basketball Court",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167600/01a01026-7267-7071-b719-2d9ca8a216ba.webp",
      "amenity_image_media": {
        "alt_text": "Outdoor basketball court with apartment buildings in the background.",
        "public_id": "01a01026-7267-7071-b719-2d9ca8a216ba",
        "storage_key": "property/6767906449167600/01a01026-7267-7071-b719-2d9ca8a216ba.webp",
        "width": 1200,
        "height": 800
      },
      "amenity_image_alt_text": "Outdoor basketball court at Highland Park Apartment Homes surrounded by landscaped grounds and residential buildings.",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_40c1cc57aba116f23b701a83",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167600",
      "source": "yardi",
      "external_id": "87989781",
      "title": "Sand Volleyball Court",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167600/01a01026-750d-771f-a6e8-5a775408cba6.webp",
      "amenity_image_media": {
        "alt_text": "Sand volleyball court with apartment buildings in the background.",
        "public_id": "01a01026-750d-771f-a6e8-5a775408cba6",
        "storage_key": "property/6767906449167600/01a01026-750d-771f-a6e8-5a775408cba6.webp",
        "width": 1200,
        "height": 800
      },
      "amenity_image_alt_text": "Sand volleyball court at Highland Park Apartment Homes with surrounding residential buildings.",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_a13cddd89261e95dfed0f53c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167600",
      "source": "yardi",
      "external_id": "87989780",
      "title": "Planned Resident Events",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_9593eabd4348659e008908b3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167600",
      "source": "yardi",
      "external_id": "87989778",
      "title": "Maintenance-Free Living",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_dcac391e8e57890f45625ba2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167600",
      "source": "yardi",
      "external_id": "87989779",
      "title": "On-Call Maintenance",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_c85412397e79b6a1ba7d65f3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167600",
      "source": "yardi",
      "external_id": "87989776",
      "title": "Free Notary Services",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_6454c37ab13bd21957209bc7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167600",
      "source": "yardi",
      "external_id": "122755379",
      "title": "Flexible Rent Payment Options Available",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_dba76c2e9b269cc84a42fb03",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167600",
      "source": "yardi",
      "external_id": "87989791",
      "title": "In-Home Washer & Dryer Included",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167600/01a01026-838f-713d-8809-782c8bf0c1bb.webp",
      "amenity_image_media": {
        "alt_text": "Washer and dryer appliances.",
        "public_id": "01a01026-838f-713d-8809-782c8bf0c1bb",
        "storage_key": "property/6767906449167600/01a01026-838f-713d-8809-782c8bf0c1bb.webp",
        "width": 800,
        "height": 600
      },
      "amenity_image_alt_text": "Washer Dryer In Unit at Highland Park Apartment Homes, Kansas, 66214",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_8cb54d518237513ee13746f2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167600",
      "source": "yardi",
      "external_id": "88015339",
      "title": "Stainless Steel Appliances*",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167600/01a01026-8519-760c-bf98-df706b578cbf.webp",
      "amenity_image_media": {
        "alt_text": "Modern kitchen with stainless steel appliances and white cabinetry.",
        "public_id": "01a01026-8519-760c-bf98-df706b578cbf",
        "storage_key": "property/6767906449167600/01a01026-8519-760c-bf98-df706b578cbf.webp",
        "width": 800,
        "height": 600
      },
      "amenity_image_alt_text": "a white kitchen with a stove and a microwave at Highland Park Apartment Homes, Overland Park, 66214",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_a6c4273e3050af5bc6ff359b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167600",
      "source": "yardi",
      "external_id": "87989789",
      "title": "Sunrooms & Glass Enclosed Greenhouses*",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_a59adb61d0ed2522aae09056",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167600",
      "source": "yardi",
      "external_id": "87989788",
      "title": "Private Balconies and Patios with Extra Storage",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_e7b03390129e586c70c670dd",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167600",
      "source": "yardi",
      "external_id": "87989787",
      "title": "Fireplaces*",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167600/01a01026-86b2-72a7-a96d-656829ba29b1.webp",
      "amenity_image_media": {
        "alt_text": "Living room with fireplace and open-concept kitchen and dining area.",
        "public_id": "01a01026-86b2-72a7-a96d-656829ba29b1",
        "storage_key": "property/6767906449167600/01a01026-86b2-72a7-a96d-656829ba29b1.webp",
        "width": 800,
        "height": 600
      },
      "amenity_image_alt_text": "a living room with a fireplace and a couch at Highland Park Apartment Homes, Overland Park, Kansas",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_58ec603348a67120946c55db",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167600",
      "source": "yardi",
      "external_id": "87989785",
      "title": "Ceiling Fan in Bedrooms",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167600/01a01026-8cee-722f-8228-2d7ce85d8204.webp",
      "amenity_image_media": {
        "alt_text": "Bedroom with a king-size bed, ceiling fan, and large windows.",
        "public_id": "01a01026-8cee-722f-8228-2d7ce85d8204",
        "storage_key": "property/6767906449167600/01a01026-8cee-722f-8228-2d7ce85d8204.webp",
        "width": 800,
        "height": 600
      },
      "amenity_image_alt_text": "Comfortable Bedroom at Highland Park Apartment Homes, Overland Park, KS, 66214",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_bf71ecd11b94aa9197e35ec4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167600",
      "source": "yardi",
      "external_id": "121741108",
      "title": "Quartz Countertops*",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167600/01a01026-9773-767b-a7df-19bc8028b24b.webp",
      "amenity_image_media": {
        "alt_text": "Modern kitchen with white cabinets, stainless steel appliances, and a bowl of green pears on the counter.",
        "public_id": "01a01026-9773-767b-a7df-19bc8028b24b",
        "storage_key": "property/6767906449167600/01a01026-9773-767b-a7df-19bc8028b24b.webp",
        "width": 3072,
        "height": 3072
      },
      "amenity_image_alt_text": "A modern kitchen with white cabinets and a stove top oven.",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_323ea98cb4e1c90d9c18f90b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167600",
      "source": "yardi",
      "external_id": "87989790",
      "title": "Vaulted Ceilings*",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_f0f4f2dbbb98e3d3106e1cf1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167600",
      "source": "yardi",
      "external_id": "121741103",
      "title": "White Cabinets*",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167600/01a01026-9710-72dc-81aa-6107b68c5fcc.webp",
      "amenity_image_media": {
        "alt_text": "Modern kitchen with white cabinets, stainless steel appliances, and granite countertops.",
        "public_id": "01a01026-9710-72dc-81aa-6107b68c5fcc",
        "storage_key": "property/6767906449167600/01a01026-9710-72dc-81aa-6107b68c5fcc.webp",
        "width": 3072,
        "height": 3072
      },
      "amenity_image_alt_text": "A kitchen with white cabinets and a black stove top oven.",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_10b3261100c5bf00ba46e3b2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167600",
      "source": "yardi",
      "external_id": "121741106",
      "title": "Tile Backsplash*",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167600/01a01026-9e6d-7088-acfc-046bc1dcb4d7.webp",
      "amenity_image_media": {
        "alt_text": "Modern kitchen with stainless steel refrigerator, dishwasher, white cabinets, and quartz countertops.",
        "public_id": "01a01026-9e6d-7088-acfc-046bc1dcb4d7",
        "storage_key": "property/6767906449167600/01a01026-9e6d-7088-acfc-046bc1dcb4d7.webp",
        "width": 3072,
        "height": 3072
      },
      "amenity_image_alt_text": "A kitchen with a white fridge and a black dishwasher.",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_dd26c931c5ab8571af762ce8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167600",
      "source": "yardi",
      "external_id": "121741109",
      "title": "Plank Flooring*",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167600/01a01026-9844-71ba-95e1-73911c3e6b98.webp",
      "amenity_image_media": {
        "alt_text": "Dining area and kitchen with breakfast bar, stainless steel appliances, and modern decor.",
        "public_id": "01a01026-9844-71ba-95e1-73911c3e6b98",
        "storage_key": "property/6767906449167600/01a01026-9844-71ba-95e1-73911c3e6b98.webp",
        "width": 1200,
        "height": 800
      },
      "amenity_image_alt_text": "A modern kitchen with a dining table set for four.",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_67b6f384aa450d1c7e681e5a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167600",
      "source": "yardi",
      "external_id": "121741117",
      "title": "Microwave*",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167600/01a01026-9710-72dc-81aa-6107b68c5fcc.webp",
      "amenity_image_media": {
        "alt_text": "Modern kitchen with white cabinets, stainless steel appliances, and granite countertops.",
        "public_id": "01a01026-9710-72dc-81aa-6107b68c5fcc",
        "storage_key": "property/6767906449167600/01a01026-9710-72dc-81aa-6107b68c5fcc.webp",
        "width": 3072,
        "height": 3072
      },
      "amenity_image_alt_text": "A kitchen with white cabinets and a black stove top oven.",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_2496b5d163ec1fa72847fcbf",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167600",
      "source": "yardi",
      "external_id": "121741118",
      "title": "Brushed Nickel Fixtures*",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_04d107fcd0a49d1db7e92998",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167600",
      "source": "yardi",
      "external_id": "121741131",
      "title": "Walk-in Shower*",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167600/01a01026-9da8-751a-89a6-ee53a07fbf2f.webp",
      "amenity_image_media": {
        "alt_text": "Modern bathroom with white vanity, sink, toilet, and glass-enclosed shower.",
        "public_id": "01a01026-9da8-751a-89a6-ee53a07fbf2f",
        "storage_key": "property/6767906449167600/01a01026-9da8-751a-89a6-ee53a07fbf2f.webp",
        "width": 1200,
        "height": 800
      },
      "amenity_image_alt_text": "A white bathroom with a toilet, sink, and mirror.",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    }
  ],
  "photo_gallery": [
    {
      "id": "ec_35bdf16c4b86fb3772f73352",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167600",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167600/01a01026-55d1-72ec-b85e-f6160b816461.webp",
      "image_media": {
        "alt_text": "Modern white kitchen with quartz countertops and stainless steel appliances.",
        "public_id": "01a01026-55d1-72ec-b85e-f6160b816461",
        "storage_key": "property/6767906449167600/01a01026-55d1-72ec-b85e-f6160b816461.webp",
        "width": 800,
        "height": 600
      },
      "title": "Apartment",
      "description": "Spacious and bright kitchen featuring white cabinetry, quartz countertops, a stainless steel sink, and modern appliances. Perfect for cooking and entertaining.",
      "link": "false",
      "alt_text": "Modern white kitchen with quartz countertops and stainless steel appliances.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/22-DSC05742.jpg"
    },
    {
      "id": "ec_4026a5286bc4d473257e486c",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167600",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167600/01a01026-d266-7768-b7d9-cd37071222fa.webp",
      "image_media": {
        "alt_text": "Modern kitchen with stainless steel appliances, white cabinetry, and a sleek countertop.",
        "public_id": "01a01026-d266-7768-b7d9-cd37071222fa",
        "storage_key": "property/6767906449167600/01a01026-d266-7768-b7d9-cd37071222fa.webp",
        "width": 800,
        "height": 600
      },
      "title": "Apartment",
      "description": "Step into this beautifully updated kitchen, featuring stainless steel appliances, pristine white cabinetry, and a stylish mosaic backsplash, perfect for any home chef.",
      "link": "false",
      "alt_text": "Modern kitchen with stainless steel appliances, white cabinetry, and a sleek countertop.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/25-DSC05752.jpg"
    },
    {
      "id": "ec_3fb61487141615129dbad1c9",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167600",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167600/01a01026-d218-768d-9499-9e78f1ccadea.webp",
      "image_media": {
        "alt_text": "Modern kitchen with white cabinets, stainless steel appliances including a microwave and refrigerator, and a speckled backsplash.",
        "public_id": "01a01026-d218-768d-9499-9e78f1ccadea",
        "storage_key": "property/6767906449167600/01a01026-d218-768d-9499-9e78f1ccadea.webp",
        "width": 800,
        "height": 600
      },
      "title": "Apartment",
      "description": "Charming kitchen featuring sleek white cabinetry, a microwave above the stove, a refrigerator, and a stylish speckled backsplash for a contemporary feel.",
      "link": "false",
      "alt_text": "Modern kitchen with white cabinets, stainless steel appliances including a microwave and refrigerator, and a speckled backsplash.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/08-DSC05602.jpg"
    },
    {
      "id": "ec_2fc5cc10cdcf2a5d4ed4c8f4",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167600",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167600/01a0b34b-8823-77d2-b6e1-61125088a14f.webp",
      "image_media": {
        "alt_text": "Modern kitchen with white cabinets, quartz countertops, and stainless steel appliances.",
        "public_id": "01a0b34b-8823-77d2-b6e1-61125088a14f",
        "storage_key": "property/6767906449167600/01a0b34b-8823-77d2-b6e1-61125088a14f.webp",
        "width": 3072,
        "height": 2304
      },
      "title": "Apartment",
      "description": "Step into this beautifully updated kitchen featuring sleek white cabinetry, pristine quartz countertops, and state-of-the-art stainless steel appliances, perfect for any home chef.",
      "link": "false",
      "alt_text": "Modern kitchen with white cabinets, quartz countertops, and stainless steel appliances.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/IMG_6158.jpg"
    },
    {
      "id": "ec_baee701e0b0b729bbee3e7ef",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167600",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167600/01a0b34b-882d-77fc-b255-f2a767aae43c.webp",
      "image_media": {
        "alt_text": "View into a spacious living area with a fireplace and built-in shelves.",
        "public_id": "01a0b34b-882d-77fc-b255-f2a767aae43c",
        "storage_key": "property/6767906449167600/01a0b34b-882d-77fc-b255-f2a767aae43c.webp",
        "width": 3072,
        "height": 2304
      },
      "title": "Apartment",
      "description": "Enjoy the open-concept living space, complete with a cozy fireplace and convenient built-in shelving for all your decorative needs.",
      "link": "false",
      "alt_text": "View into a spacious living area with a fireplace and built-in shelves.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/IMG_6146.jpg"
    },
    {
      "id": "ec_74bb6f1aa301d5ebd4de9767",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167600",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167600/01a01026-d32b-735c-95a8-f3307f11fc47.webp",
      "image_media": {
        "alt_text": "Modern apartment living and dining area with kitchen island and bar stools.",
        "public_id": "01a01026-d32b-735c-95a8-f3307f11fc47",
        "storage_key": "property/6767906449167600/01a01026-d32b-735c-95a8-f3307f11fc47.webp",
        "width": 800,
        "height": 600
      },
      "title": "Apartment",
      "description": "Spacious open-concept living and dining area featuring a modern kitchen with an island, bar stools, a cozy living room with a fireplace, and a large window for natural light.",
      "link": "false",
      "alt_text": "Modern apartment living and dining area with kitchen island and bar stools.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/05-DSC05587_final.jpg"
    },
    {
      "id": "ec_6a306b1826fde71ba188b478",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167600",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167600/01a01026-d271-7258-888d-5fc3066b8caa.webp",
      "image_media": {
        "alt_text": "Modern kitchen and dining area with stainless steel appliances and a breakfast bar.",
        "public_id": "01a01026-d271-7258-888d-5fc3066b8caa",
        "storage_key": "property/6767906449167600/01a01026-d271-7258-888d-5fc3066b8caa.webp",
        "width": 800,
        "height": 600
      },
      "title": "Apartment",
      "description": "Enjoy cooking and dining in this stylish apartment kitchen, featuring a breakfast bar, modern appliances, and ample dining space.",
      "link": "false",
      "alt_text": "Modern kitchen and dining area with stainless steel appliances and a breakfast bar.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/03-DSC05572-Edit_final.jpg"
    },
    {
      "id": "ec_f06b6b32ddb6ae4a379abf95",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167600",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167600/01a01026-d1fa-7220-8123-1051ae3d38f0.webp",
      "image_media": {
        "alt_text": "Modern bathroom with a dual vanity, toilet, and a glass-enclosed shower.",
        "public_id": "01a01026-d1fa-7220-8123-1051ae3d38f0",
        "storage_key": "property/6767906449167600/01a01026-d1fa-7220-8123-1051ae3d38f0.webp",
        "width": 800,
        "height": 600
      },
      "title": "Apartment",
      "description": "Experience comfort and style in this modern apartment bathroom, featuring a sleek dual vanity, a convenient toilet, and a spacious glass-enclosed shower.",
      "link": "false",
      "alt_text": "Modern bathroom with a dual vanity, toilet, and a glass-enclosed shower.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/21-DSC05727.jpg"
    },
    {
      "id": "ec_5ad501c531b7b16f080010ca",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167600",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167600/01a01026-da36-7028-88f0-3d91507835b7.webp",
      "image_media": {
        "alt_text": "Bedroom with a king-sized bed, yellow bedding, and a large TV.",
        "public_id": "01a01026-da36-7028-88f0-3d91507835b7",
        "storage_key": "property/6767906449167600/01a01026-da36-7028-88f0-3d91507835b7.webp",
        "width": 800,
        "height": 600
      },
      "title": "Apartment",
      "description": "Spacious bedroom featuring a king-sized bed with comfortable yellow bedding, a modern media console with a large TV, and a walk-in closet.",
      "link": "false",
      "alt_text": "Bedroom with a king-sized bed, yellow bedding, and a large TV.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/09-DSC05617_final.jpg"
    },
    {
      "id": "ec_3308b16735fbce7aacd54507",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167600",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167600/01a01026-dcc9-71cb-9880-b21a0c071236.webp",
      "image_media": {
        "alt_text": "Modern bathroom with a walk-in shower, toilet, and a white vanity with a quartz countertop and silver hardware.",
        "public_id": "01a01026-dcc9-71cb-9880-b21a0c071236",
        "storage_key": "property/6767906449167600/01a01026-dcc9-71cb-9880-b21a0c071236.webp",
        "width": 800,
        "height": 600
      },
      "title": "Apartment",
      "description": "Enjoy a spacious and modern bathroom featuring a sleek walk-in shower, elegant vanity, and ample counter space, perfect for relaxation and daily routines.",
      "link": "false",
      "alt_text": "Modern bathroom with a walk-in shower, toilet, and a white vanity with a quartz countertop and silver hardware.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/11-DSC05642.jpg"
    },
    {
      "id": "ec_37a9c75cff1eaa1149317df7",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167600",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167600/01a01026-ddc7-77e9-bcb4-b6be297265ff.webp",
      "image_media": {
        "alt_text": "Two white washing machines side-by-side with shelves above.",
        "public_id": "01a01026-ddc7-77e9-bcb4-b6be297265ff",
        "storage_key": "property/6767906449167600/01a01026-ddc7-77e9-bcb4-b6be297265ff.webp",
        "width": 800,
        "height": 600
      },
      "title": "Apartment",
      "description": "In-unit laundry area with stacked washer and dryer units and overhead shelving for storage.",
      "link": "false",
      "alt_text": "Two white washing machines side-by-side with shelves above.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/12-DSC05652.jpg"
    },
    {
      "id": "ec_b3e95be2829f710845dc648d",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167600",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167600/01a0b34b-87d1-72df-869f-dfc18390a7ca.webp",
      "image_media": {
        "alt_text": "Stacked washer and dryer unit next to a refrigerator.",
        "public_id": "01a0b34b-87d1-72df-869f-dfc18390a7ca",
        "storage_key": "property/6767906449167600/01a0b34b-87d1-72df-869f-dfc18390a7ca.webp",
        "width": 3072,
        "height": 2304
      },
      "title": "Apartment",
      "description": "Convenient in-unit stacked washer and dryer, perfect for all your laundry needs. Adjacent stainless steel refrigerator.",
      "link": "false",
      "alt_text": "Stacked washer and dryer unit next to a refrigerator.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/IMG_6160.jpg"
    },
    {
      "id": "ec_6c6d00a50ba2fc70d45b6aec",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167600",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167600/019fc97b-9558-70ce-8e34-920bb4939635.webp",
      "image_media": {
        "alt_text": "A furnished living room with a dark leather sofa, a glass coffee table, and two blue accent chairs.",
        "public_id": "019fc97b-9558-70ce-8e34-920bb4939635",
        "storage_key": "property/6767906449167600/019fc97b-9558-70ce-8e34-920bb4939635.webp",
        "width": 1800,
        "height": 1200
      },
      "title": "Apartment",
      "description": "Spacious living room featuring a comfortable leather sofa, accent chairs, and a dining area, perfect for relaxation and entertaining.",
      "link": "false",
      "alt_text": "A furnished living room with a dark leather sofa, a glass coffee table, and two blue accent chairs.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/IMG_2607-HDR.jpg"
    },
    {
      "id": "ec_13d5be2b6b12a6b210394b6f",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167600",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167600/01a01026-e2a1-77ee-9a45-8d2e227b817c.webp",
      "image_media": {
        "alt_text": "Kitchen with white refrigerator, wooden cabinets, and a white electric stove.",
        "public_id": "01a01026-e2a1-77ee-9a45-8d2e227b817c",
        "storage_key": "property/6767906449167600/01a01026-e2a1-77ee-9a45-8d2e227b817c.webp",
        "width": 1500,
        "height": 1000
      },
      "title": "Apartment",
      "description": "This kitchen features classic wooden cabinetry, a white refrigerator, and a white electric stove, offering a functional and timeless cooking space.",
      "link": "false",
      "alt_text": "Kitchen with white refrigerator, wooden cabinets, and a white electric stove.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/IMG_2570-HDR-2.jpg"
    },
    {
      "id": "ec_e4cf52149d36654787c50614",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167600",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167600/01a01026-e3f5-712c-ac22-8174fa3b1d87.webp",
      "image_media": {
        "alt_text": "Aerial view of apartment buildings nestled amongst trees with a highway interchange nearby.",
        "public_id": "01a01026-e3f5-712c-ac22-8174fa3b1d87",
        "storage_key": "property/6767906449167600/01a01026-e3f5-712c-ac22-8174fa3b1d87.webp",
        "width": 800,
        "height": 600
      },
      "title": "Community",
      "description": "Expansive aerial view showcasing apartment complex surrounded by lush greenery, with a major highway visible in the foreground.",
      "link": "false",
      "alt_text": "Aerial view of apartment buildings nestled amongst trees with a highway interchange nearby.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/05-DJI_20240611110439_0147_D.jpg"
    },
    {
      "id": "ec_1bdfab9c67123d6df09e287c",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167600",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167600/01a01026-e682-7339-9360-1018fccb2a02.webp",
      "image_media": {
        "alt_text": "Aerial view of a swimming pool with lounge chairs and umbrellas.",
        "public_id": "01a01026-e682-7339-9360-1018fccb2a02",
        "storage_key": "property/6767906449167600/01a01026-e682-7339-9360-1018fccb2a02.webp",
        "width": 800,
        "height": 600
      },
      "title": "Community",
      "description": "Relax and unwind by our sparkling outdoor swimming pool, complete with comfortable lounge chairs and umbrellas for your enjoyment.",
      "link": "false",
      "alt_text": "Aerial view of a swimming pool with lounge chairs and umbrellas.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/04-DJI_20240611105555_0097_D.jpg"
    },
    {
      "id": "ec_aede56b0316e2fa2071d3b5d",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167600",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167600/01a01026-f629-7418-9ba8-03242dc01296.webp",
      "image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and a brick building in the background at sunset.",
        "public_id": "01a01026-f629-7418-9ba8-03242dc01296",
        "storage_key": "property/6767906449167600/01a01026-f629-7418-9ba8-03242dc01296.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Community",
      "description": "Relax by the sparkling outdoor swimming pool, complete with comfortable lounge chairs and a beautiful sunset view. Enjoy the amenities of our community.",
      "link": "false",
      "alt_text": "Outdoor swimming pool with lounge chairs and a brick building in the background at sunset.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/Highland-Park-017_Photo_Amenities_Pool_Angle-5_Twilight_2026-06-23_Original-Size.jpg"
    },
    {
      "id": "ec_948ed6ed0a7e0b3e70510231",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167600",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167600/01a01026-efb4-776b-8e8f-bc0cda58a832.webp",
      "image_media": {
        "alt_text": "Resort-style swimming pool and clubhouse at sunset.",
        "public_id": "01a01026-efb4-776b-8e8f-bc0cda58a832",
        "storage_key": "property/6767906449167600/01a01026-efb4-776b-8e8f-bc0cda58a832.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Community",
      "description": "Enjoy our beautiful resort-style swimming pool and clubhouse, perfect for relaxing and entertaining.",
      "link": "false",
      "alt_text": "Resort-style swimming pool and clubhouse at sunset.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/Highland-Park-017_Photo_Amenities_Pool_Angle-1_Twilight_2026-06-23_Original-Size.jpg"
    },
    {
      "id": "ec_12527c3caa852bae3e25c911",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167600",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167600/01a01027-001a-72d9-99fc-e8b89011932e.webp",
      "image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and a shaded seating area.",
        "public_id": "01a01027-001a-72d9-99fc-e8b89011932e",
        "storage_key": "property/6767906449167600/01a01027-001a-72d9-99fc-e8b89011932e.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our sparkling swimming pool, complete with comfortable lounge chairs and a covered pavilion for shaded relaxation.",
      "link": "false",
      "alt_text": "Resort-style swimming pool with lounge chairs and a shaded seating area.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/Highland-Park-017_Photo_Amenities_Pool_Angle-2_2026-06-23_Original-Size.jpg"
    },
    {
      "id": "ec_dcec743b7f2a339670966962",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167600",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167600/01a01026-fec1-75d3-aebc-adc9324afcad.webp",
      "image_media": {
        "alt_text": "Small plunge pool with decorative stone wall and lush landscaping.",
        "public_id": "01a01026-fec1-75d3-aebc-adc9324afcad",
        "storage_key": "property/6767906449167600/01a01026-fec1-75d3-aebc-adc9324afcad.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in the community's charming plunge pool, surrounded by beautiful stone accents and vibrant floral arrangements.",
      "link": "false",
      "alt_text": "Small plunge pool with decorative stone wall and lush landscaping.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/Highland-Park-017_Photo_Amenities_Kiddie-Pool_2026-06-23_Original-Size.jpg"
    },
    {
      "id": "ec_d3e8a4d0fb7bc0013be929a2",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167600",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167600/01a01027-049a-761e-9d68-42ebb1c0a196.webp",
      "image_media": {
        "alt_text": "Resort-style swimming pool and lounge area with a brick building in the background.",
        "public_id": "01a01027-049a-761e-9d68-42ebb1c0a196",
        "storage_key": "property/6767906449167600/01a01027-049a-761e-9d68-42ebb1c0a196.webp",
        "width": 1920,
        "height": 1440
      },
      "title": "Community",
      "description": "Enjoy our resort-style swimming pool, perfect for relaxing and soaking up the sun. Adjacent to the pool, you'll find comfortable lounge chairs and a shaded patio area for outdoor dining.",
      "link": "false",
      "alt_text": "Resort-style swimming pool and lounge area with a brick building in the background.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/Highland-Park-017_Photo_Amenities_Pool_Angle-3_2026-06-23_Original-Size.jpg"
    },
    {
      "id": "ec_ebf10d8e9635bed9b4083a30",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167600",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167600/01a01027-1147-74d8-8b07-1da41aadde3a.webp",
      "image_media": {
        "alt_text": "Aerial view of a swimming pool area with lounge chairs, umbrellas, and cabanas.",
        "public_id": "01a01027-1147-74d8-8b07-1da41aadde3a",
        "storage_key": "property/6767906449167600/01a01027-1147-74d8-8b07-1da41aadde3a.webp",
        "width": 1920,
        "height": 1440
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our sparkling outdoor swimming pool, complete with comfortable lounge seating and shaded cabanas for ultimate relaxation.",
      "link": "false",
      "alt_text": "Aerial view of a swimming pool area with lounge chairs, umbrellas, and cabanas.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/Highland-Park-017_Photo_Amenities_Pool_Angle-4_2026-06-23_Original-Size.jpg"
    },
    {
      "id": "ec_281ea1e0ef537d5fe1f4ea79",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167600",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167600/01a01027-1f86-762d-a864-913e9d108dc5.webp",
      "image_media": {
        "alt_text": "Aerial view of the community pool and clubhouse area.",
        "public_id": "01a01027-1f86-762d-a864-913e9d108dc5",
        "storage_key": "property/6767906449167600/01a01027-1f86-762d-a864-913e9d108dc5.webp",
        "width": 1920,
        "height": 1440
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our sparkling outdoor pool or relax in the spa. The beautiful clubhouse offers a perfect gathering space.",
      "link": "false",
      "alt_text": "Aerial view of the community pool and clubhouse area.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/Highland-Park-017_Photo_Drone_Pool_2026-06-23_Original-Size.jpg"
    },
    {
      "id": "ec_7088365ff187b964f5902116",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167600",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167600/01a01027-2ace-714c-89fb-7dcc934d038b.webp",
      "image_media": {
        "alt_text": "Aerial view of a multifamily property featuring buildings, a pool, tennis courts, and ample parking.",
        "public_id": "01a01027-2ace-714c-89fb-7dcc934d038b",
        "storage_key": "property/6767906449167600/01a01027-2ace-714c-89fb-7dcc934d038b.webp",
        "width": 1920,
        "height": 1440
      },
      "title": "Community",
      "description": "Discover resort-style living with our amenities, including a sparkling pool and tennis courts, surrounded by lush landscaping and modern apartment buildings.",
      "link": "false",
      "alt_text": "Aerial view of a multifamily property featuring buildings, a pool, tennis courts, and ample parking.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/Highland-Park-017_Photo_Drone_Community_Highway-Access_2026-06-23_Original-Size.jpg"
    },
    {
      "id": "ec_bb851de95d3935254bc8a27a",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167600",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167600/01a01027-2d9a-7638-8f5a-e70efef36967.webp",
      "image_media": {
        "alt_text": "Highland Park Apartment Homes leasing office sign and building exterior with landscaping.",
        "public_id": "01a01027-2d9a-7638-8f5a-e70efef36967",
        "storage_key": "property/6767906449167600/01a01027-2d9a-7638-8f5a-e70efef36967.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Community",
      "description": "Welcome to Highland Park Apartment Homes. Find our leasing office with this directional sign and enjoy the beautifully maintained grounds.",
      "link": "false",
      "alt_text": "Highland Park Apartment Homes leasing office sign and building exterior with landscaping.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/Highland-Park-017_Photo_Exterior_Leasing-Office-Clubhouse_Monument-Sign_2026-06-23_Original-Size.jpg"
    },
    {
      "id": "ec_513b3f84040ec5c0a7836b44",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167600",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167600/01a01027-3623-71ea-85ff-ad2775393ae1.webp",
      "image_media": {
        "alt_text": "Outdoor basketball court with apartment buildings in the background.",
        "public_id": "01a01027-3623-71ea-85ff-ad2775393ae1",
        "storage_key": "property/6767906449167600/01a01027-3623-71ea-85ff-ad2775393ae1.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Community",
      "description": "Enjoy a game of basketball on the outdoor court, surrounded by lush greenery and the beautiful apartment buildings.",
      "link": "false",
      "alt_text": "Outdoor basketball court with apartment buildings in the background.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/Highland-Park-017_Photo_Amenities_Basketball-Court_2026-06-23_Original-Size.jpg"
    },
    {
      "id": "ec_6878f2f653d6736f11b80e8b",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167600",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167600/01a01027-4481-762c-b6f7-d12fdaf7d1bc.webp",
      "image_media": {
        "alt_text": "Volleyball court with sand and net, adjacent to grassy area and apartment buildings.",
        "public_id": "01a01027-4481-762c-b6f7-d12fdaf7d1bc",
        "storage_key": "property/6767906449167600/01a01027-4481-762c-b6f7-d12fdaf7d1bc.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy a game of volleyball at our sand court, located in a beautiful green space with apartment buildings in the background.",
      "link": "false",
      "alt_text": "Volleyball court with sand and net, adjacent to grassy area and apartment buildings.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/Highland-Park-017_Photo_Amenities_Volleyball-Court_2026-06-23_Original-Size.jpg"
    },
    {
      "id": "ec_3297a8f8ec794cecc59a7055",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167600",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167600/01a01027-5869-771d-b8a2-c0b329235764.webp",
      "image_media": {
        "alt_text": "Tennis courts and swimming pool at apartment complex.",
        "public_id": "01a01027-5869-771d-b8a2-c0b329235764",
        "storage_key": "property/6767906449167600/01a01027-5869-771d-b8a2-c0b329235764.webp",
        "width": 1920,
        "height": 1440
      },
      "title": "Community",
      "description": "Enjoy recreational activities at our apartment complex, featuring well-maintained tennis courts and a refreshing swimming pool.",
      "link": "false",
      "alt_text": "Tennis courts and swimming pool at apartment complex.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/Highland-Park-017_Photo_Amenities_Tennis-Court_2026-06-23_Original-Size.jpg"
    },
    {
      "id": "ec_b203c255aef07def0e7dbc26",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167600",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167600/01a01027-5cce-75af-b638-db7aab46072f.webp",
      "image_media": {
        "alt_text": "Tennis court with a pathway leading to it, surrounded by green grass and trees.",
        "public_id": "01a01027-5cce-75af-b638-db7aab46072f",
        "storage_key": "property/6767906449167600/01a01027-5cce-75af-b638-db7aab46072f.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Community",
      "description": "Enjoy a friendly match on our on-site tennis court, perfect for staying active and having fun.",
      "link": "false",
      "alt_text": "Tennis court with a pathway leading to it, surrounded by green grass and trees.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/Highland-Park-017_Photo_Amenities_Tennis-Court-Entryway_2026-06-23_Original-Size.jpg"
    },
    {
      "id": "ec_417bec7840e6736244b2a98f",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167600",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167600/01a01027-7cc3-729a-a1a1-1d17ed746f1a.webp",
      "image_media": {
        "alt_text": "Outdoor picnic pavilion with a grill and basketball court in the background at sunset.",
        "public_id": "01a01027-7cc3-729a-a1a1-1d17ed746f1a",
        "storage_key": "property/6767906449167600/01a01027-7cc3-729a-a1a1-1d17ed746f1a.webp",
        "width": 3072,
        "height": 2061
      },
      "title": "Community",
      "description": "Enjoy our community's outdoor picnic area, perfect for al fresco dining or gatherings. Features a covered pavilion, picnic table, and grill, with a basketball court nearby for recreation.",
      "link": "false",
      "alt_text": "Outdoor picnic pavilion with a grill and basketball court in the background at sunset.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/Highland-Park-017_Photo_Amenities_Picnic-Table_Twilight_2026-06-23_Original-Size.jpg"
    },
    {
      "id": "ec_293f133764c10aa95241f866",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167600",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167600/01a01027-7037-734c-99e3-76604110728b.webp",
      "image_media": {
        "alt_text": "Exterior of a multifamily apartment building with a central entrance and balconies.",
        "public_id": "01a01027-7037-734c-99e3-76604110728b",
        "storage_key": "property/6767906449167600/01a01027-7037-734c-99e3-76604110728b.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Community",
      "description": "Charming apartment building exterior featuring a well-maintained facade, green landscaping, and inviting balconies. Discover your next home in this beautiful community.",
      "link": "false",
      "alt_text": "Exterior of a multifamily apartment building with a central entrance and balconies.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/Highland-Park-017_Photo_Exterior_Residential-Buildings_Angle-2_2026-06-23_Original-Size.jpg"
    },
    {
      "id": "ec_5a042eb6a65ed1963b859e2e",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167600",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167600/01a01027-6fd6-73c9-ba61-4b76d714c4fa.webp",
      "image_media": {
        "alt_text": "Exterior of a brick apartment building with balconies and green lawn.",
        "public_id": "01a01027-6fd6-73c9-ba61-4b76d714c4fa",
        "storage_key": "property/6767906449167600/01a01027-6fd6-73c9-ba61-4b76d714c4fa.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Community",
      "description": "View of the charming brick apartment building exterior, featuring private balconies and surrounded by a lush, well-maintained lawn and mature trees.",
      "link": "false",
      "alt_text": "Exterior of a brick apartment building with balconies and green lawn.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/Highland-Park-017_Photo_Exterior_Residential-Buildings_Angle-1_2026-06-23_Original-Size.jpg"
    },
    {
      "id": "ec_c8682fc7edc722095e694075",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167600",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167600/01a01027-829c-7398-8bbc-ffed9f1649aa.webp",
      "image_media": {
        "alt_text": "Covered parking spaces with cars and a covered trailer.",
        "public_id": "01a01027-829c-7398-8bbc-ffed9f1649aa",
        "storage_key": "property/6767906449167600/01a01027-829c-7398-8bbc-ffed9f1649aa.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Community",
      "description": "Enjoy the convenience of covered parking at our community, protecting your vehicles from the elements.",
      "link": "false",
      "alt_text": "Covered parking spaces with cars and a covered trailer.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/Highland-Park-017_Photo_Amenities_Carports_2026-06-23_Original-Size.jpg"
    },
    {
      "id": "ec_ad467ca7d9df9e0e67848a45",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167600",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167600/01a01027-7d28-73d7-89ea-5221d6075e9b.webp",
      "image_media": {
        "alt_text": "Fitness center with weight racks, treadmills, and weight machines.",
        "public_id": "01a01027-7d28-73d7-89ea-5221d6075e9b",
        "storage_key": "property/6767906449167600/01a01027-7d28-73d7-89ea-5221d6075e9b.webp",
        "width": 2560,
        "height": 1707
      },
      "title": "Community",
      "description": "Stay active and energized in our state-of-the-art fitness center, featuring a wide selection of cardio and strength training equipment.",
      "link": "false",
      "alt_text": "Fitness center with weight racks, treadmills, and weight machines.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/PriceBros-HighlandPark-19.jpg"
    },
    {
      "id": "ec_23fa8711da6e0ae8e75969ec",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167600",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167600/01a01027-9949-72df-8689-0dfc5855ef91.webp",
      "image_media": {
        "alt_text": "Interior of a well-equipped fitness center with weight machines, free weights, and benches.",
        "public_id": "01a01027-9949-72df-8689-0dfc5855ef91",
        "storage_key": "property/6767906449167600/01a01027-9949-72df-8689-0dfc5855ef91.webp",
        "width": 2560,
        "height": 1707
      },
      "title": "Community",
      "description": "Stay active in our state-of-the-art fitness center, featuring a variety of cardio and strength training equipment for a complete workout.",
      "link": "false",
      "alt_text": "Interior of a well-equipped fitness center with weight machines, free weights, and benches.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/PriceBros-HighlandPark-18.jpg"
    },
    {
      "id": "ec_0ace742164d60b4bbeeb2bf7",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167600",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167600/01a01027-a042-726c-8933-220afcf9fd14.webp",
      "image_media": {
        "alt_text": "Gym with weight machines and cardio equipment, featuring large arched windows overlooking the grounds.",
        "public_id": "01a01027-a042-726c-8933-220afcf9fd14",
        "storage_key": "property/6767906449167600/01a01027-a042-726c-8933-220afcf9fd14.webp",
        "width": 2560,
        "height": 1707
      },
      "title": "Community",
      "description": "Stay active in our fully-equipped fitness center, featuring a variety of weight machines and cardio equipment for a complete workout.",
      "link": "false",
      "alt_text": "Gym with weight machines and cardio equipment, featuring large arched windows overlooking the grounds.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/PriceBros-HighlandPark-17.jpg"
    },
    {
      "id": "ec_12656ea979fdf5167e683f1f",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167600",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167600/01a01027-9d22-7182-9eb3-00a118227014.webp",
      "image_media": {
        "alt_text": "Elliptical machine in a fitness center",
        "public_id": "01a01027-9d22-7182-9eb3-00a118227014",
        "storage_key": "property/6767906449167600/01a01027-9d22-7182-9eb3-00a118227014.webp",
        "width": 2560,
        "height": 1707
      },
      "title": "Community",
      "description": "Stay active in our state-of-the-art fitness center, featuring top-tier cardio equipment like this elliptical.",
      "link": "false",
      "alt_text": "Elliptical machine in a fitness center",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/PriceBros-HighlandPark-21.jpg"
    },
    {
      "id": "ec_e19e2cabfc4d9bb0011743d6",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167600",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167600/01a01027-a61e-740b-ae21-f6a41bcafe0b.webp",
      "image_media": {
        "alt_text": "Close-up of a LeMond exercise bike in a gym.",
        "public_id": "01a01027-a61e-740b-ae21-f6a41bcafe0b",
        "storage_key": "property/6767906449167600/01a01027-a61e-740b-ae21-f6a41bcafe0b.webp",
        "width": 2560,
        "height": 1707
      },
      "title": "Community",
      "description": "Stay active and energized in our state-of-the-art fitness center, equipped with top-tier exercise machines.",
      "link": "false",
      "alt_text": "Close-up of a LeMond exercise bike in a gym.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/PriceBros-HighlandPark-20.jpg"
    },
    {
      "id": "ec_b3f0a751950c52a96041f5d4",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167600",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167600/01a01027-a81f-744d-9683-88edbeba79ae.webp",
      "image_media": {
        "alt_text": "Elegant seating area with modern sofas and a large arched window overlooking a garden.",
        "public_id": "01a01027-a81f-744d-9683-88edbeba79ae",
        "storage_key": "property/6767906449167600/01a01027-a81f-744d-9683-88edbeba79ae.webp",
        "width": 2560,
        "height": 1706
      },
      "title": "Community",
      "description": "Relax and unwind in our stylish resident lounge, featuring comfortable seating and beautiful garden views.",
      "link": "false",
      "alt_text": "Elegant seating area with modern sofas and a large arched window overlooking a garden.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/PriceBros-HighlandPark-01.jpg"
    },
    {
      "id": "ec_f18bb4abbe2116f690d92968",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167600",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167600/01a01027-becf-76cb-b348-ad972ddf80b6.webp",
      "image_media": {
        "alt_text": "Cozy seating area with two large sofas, a coffee table, and decorative artwork.",
        "public_id": "01a01027-becf-76cb-b348-ad972ddf80b6",
        "storage_key": "property/6767906449167600/01a01027-becf-76cb-b348-ad972ddf80b6.webp",
        "width": 2560,
        "height": 1706
      },
      "title": "Community",
      "description": "Relax and unwind in this beautifully designed seating area, perfect for socializing or quiet contemplation. Featuring comfortable sofas and elegant decor.",
      "link": "false",
      "alt_text": "Cozy seating area with two large sofas, a coffee table, and decorative artwork.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/PriceBros-HighlandPark-00.jpg"
    },
    {
      "id": "ec_f2f8bbaa85b7edfa7da6ccae",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167600",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167600/01a01027-bd92-706c-bd2d-55d988b6d4cd.webp",
      "image_media": {
        "alt_text": "Modern living room with plush chairs, a sleek fireplace, and a large TV.",
        "public_id": "01a01027-bd92-706c-bd2d-55d988b6d4cd",
        "storage_key": "property/6767906449167600/01a01027-bd92-706c-bd2d-55d988b6d4cd.webp",
        "width": 2560,
        "height": 1707
      },
      "title": "Apartment",
      "description": "Relax and unwind in this beautifully appointed living room, featuring comfortable seating and a contemporary fireplace.",
      "link": "false",
      "alt_text": "Modern living room with plush chairs, a sleek fireplace, and a large TV.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/PriceBros-HighlandPark-02.jpg"
    },
    {
      "id": "ec_53852605c61dbe525d89f61b",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167600",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167600/01a01027-c2a3-715e-8072-8d95ee8f81db.webp",
      "image_media": {
        "alt_text": "Dining area with modern table and chairs, next to large arched windows overlooking landscaped grounds.",
        "public_id": "01a01027-c2a3-715e-8072-8d95ee8f81db",
        "storage_key": "property/6767906449167600/01a01027-c2a3-715e-8072-8d95ee8f81db.webp",
        "width": 2560,
        "height": 1707
      },
      "title": "Community",
      "description": "Enjoy a casual meal or gathering in this bright dining space, featuring comfortable seating and picturesque views of the community's lush landscaping and architecture.",
      "link": "false",
      "alt_text": "Dining area with modern table and chairs, next to large arched windows overlooking landscaped grounds.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/PriceBros-HighlandPark-04.jpg"
    },
    {
      "id": "ec_a549af7b0aa13d65e37d3500",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167600",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167600/01a01027-c43a-776e-a418-3f1225723a23.webp",
      "image_media": {
        "alt_text": "Community dining area with booths, tables, and chairs, and decorative mirrors on the wall.",
        "public_id": "01a01027-c43a-776e-a418-3f1225723a23",
        "storage_key": "property/6767906449167600/01a01027-c43a-776e-a418-3f1225723a23.webp",
        "width": 2560,
        "height": 1707
      },
      "title": "Community",
      "description": "Enjoy a meal or gather with friends in this stylish community dining area, featuring comfortable booth seating, modern tables, and unique decorative mirrors.",
      "link": "false",
      "alt_text": "Community dining area with booths, tables, and chairs, and decorative mirrors on the wall.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/PriceBros-HighlandPark-03.jpg"
    },
    {
      "id": "ec_e4d1f0ad8491e2cd4646c798",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167600",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167600/01a01027-cc0f-711a-b6d4-86f91bbbbbca.webp",
      "image_media": {
        "alt_text": "Modern seating area with tables and chairs in apartment community lounge.",
        "public_id": "01a01027-cc0f-711a-b6d4-86f91bbbbbca",
        "storage_key": "property/6767906449167600/01a01027-cc0f-711a-b6d4-86f91bbbbbca.webp",
        "width": 2560,
        "height": 1707
      },
      "title": "Community",
      "description": "Relax and socialize in our stylish community lounge, featuring comfortable seating, modern tables, and elegant decor.",
      "link": "false",
      "alt_text": "Modern seating area with tables and chairs in apartment community lounge.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/PriceBros-HighlandPark-08.jpg"
    },
    {
      "id": "ec_5341b36956a9a04febd22b83",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167600",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167600/01a01027-e140-76dc-b833-0103297e9ada.webp",
      "image_media": {
        "alt_text": "Table and chairs in a common area with large arched windows overlooking a pool and courtyard.",
        "public_id": "01a01027-e140-76dc-b833-0103297e9ada",
        "storage_key": "property/6767906449167600/01a01027-e140-76dc-b833-0103297e9ada.webp",
        "width": 2560,
        "height": 1707
      },
      "title": "Community",
      "description": "Enjoy a meal or gather with friends in our beautifully appointed common areas. Large windows offer views of the sparkling pool and lush landscaping.",
      "link": "false",
      "alt_text": "Table and chairs in a common area with large arched windows overlooking a pool and courtyard.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/PriceBros-HighlandPark-05.jpg"
    },
    {
      "id": "ec_4707dacfe996bf540b618652",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167600",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167600/01a01027-e3d4-72ce-9c4d-9e97cc3035f6.webp",
      "image_media": {
        "alt_text": "Dining table with leather chairs by a window with greenery outside",
        "public_id": "01a01027-e3d4-72ce-9c4d-9e97cc3035f6",
        "storage_key": "property/6767906449167600/01a01027-e3d4-72ce-9c4d-9e97cc3035f6.webp",
        "width": 2560,
        "height": 1707
      },
      "title": "Apartment",
      "description": "Elegant dining area featuring a marble-top table and plush leather chairs, with natural light streaming in through large windows showcasing a lush garden view.",
      "link": "false",
      "alt_text": "Dining table with leather chairs by a window with greenery outside",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/PriceBros-HighlandPark-16.jpg"
    },
    {
      "id": "ec_ccdbcc99586c80edf14a2d41",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167600",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167600/01a01027-e903-738f-a2cb-634108880104.webp",
      "image_media": {
        "alt_text": "Modern kitchen with stainless steel appliances, granite countertops, and a decorative island.",
        "public_id": "01a01027-e903-738f-a2cb-634108880104",
        "storage_key": "property/6767906449167600/01a01027-e903-738f-a2cb-634108880104.webp",
        "width": 2560,
        "height": 1707
      },
      "title": "Apartment",
      "description": "Spacious and modern kitchen featuring stainless steel appliances, a sleek granite countertop island with decorative tilework, and ample natural light from large arched windows.",
      "link": "false",
      "alt_text": "Modern kitchen with stainless steel appliances, granite countertops, and a decorative island.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/PriceBros-HighlandPark-07.jpg"
    },
    {
      "id": "ec_f26f301e9e111cf417a96822",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167600",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167600/01a01027-eaed-74bf-8d21-f12c8ef01e2b.webp",
      "image_media": {
        "alt_text": "Modern kitchen with island seating and dining area with large arched window.",
        "public_id": "01a01027-eaed-74bf-8d21-f12c8ef01e2b",
        "storage_key": "property/6767906449167600/01a01027-eaed-74bf-8d21-f12c8ef01e2b.webp",
        "width": 2560,
        "height": 1707
      },
      "title": "Apartment",
      "description": "Discover a chef-inspired kitchen featuring granite countertops, stainless steel appliances, and a breakfast bar. Perfect for entertaining.",
      "link": "false",
      "alt_text": "Modern kitchen with island seating and dining area with large arched window.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/PriceBros-HighlandPark-06.jpg"
    },
    {
      "id": "ec_efd2b60062e04ea56a1a2faf",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167600",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167600/01a01027-f3d6-753f-90e6-306f598206cd.webp",
      "image_media": {
        "alt_text": "The Highland Park Apt. Homes logo on a decorative coaster.",
        "public_id": "01a01027-f3d6-753f-90e6-306f598206cd",
        "storage_key": "property/6767906449167600/01a01027-f3d6-753f-90e6-306f598206cd.webp",
        "width": 2560,
        "height": 1707
      },
      "title": "Logo",
      "description": "Decorative coaster featuring The Highland Park Apt. Homes logo, placed near a potted plant.",
      "link": "false",
      "alt_text": "The Highland Park Apt. Homes logo on a decorative coaster.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/PriceBros-HighlandPark-15.jpg"
    }
  ],
  "neighborhood_pois": [
    {
      "id": "custom_9ae2b1d7-72c8-461d-b61e-40bda4f576a8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167600",
      "source": "custom",
      "poi_name": "Medicine Shoppe",
      "poi_type": "Health and Wellness",
      "poi_address": "10410 Mastin St, Overland Park, KS 66212, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://www.medicineshoppe.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12880670912561996565&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "medicine-shoppe",
      "poi_latitude": "38.9407096",
      "poi_longitude": "-94.7026809",
      "poi_miles_from_property": "0.6",
      "poi_walking_minutes": "14 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 913-492-4998",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167600/019fc97d-cda5-720b-8eb6-2086a7315cca.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc97d-cda5-720b-8eb6-2086a7315cca",
        "storage_key": "property/6767906449167600/019fc97d-cda5-720b-8eb6-2086a7315cca.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJCeurVhnrwIcRFeP2Q_NVwbI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "custom_4b68b815-c2e3-47ce-b7a6-d1821272fa8e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167600",
      "source": "custom",
      "poi_name": "Mastin Discount Liquor",
      "poi_type": "Shopping & Retail",
      "poi_address": "10321 Mastin St, Overland Park, KS 66212, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167600/01a01015-bf46-737b-854e-86031759ffaa.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a01015-bf46-737b-854e-86031759ffaa",
        "storage_key": "property/6767906449167600/01a01015-bf46-737b-854e-86031759ffaa.webp",
        "width": 1280,
        "height": 959
      },
      "poi_business_url": "https://www.facebook.com/MastinDiscountLiquor",
      "poi_directions_map_url": "https://maps.google.com/?cid=10057324958944725205&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "mastin-discount-liquor",
      "poi_latitude": "38.94142739999999",
      "poi_longitude": "-94.7014456",
      "poi_miles_from_property": "0.6",
      "poi_walking_minutes": "13 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 913-766-0002",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167600/019fc97a-ba8a-757e-99d8-7418eed2b097.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc97a-ba8a-757e-99d8-7418eed2b097",
        "storage_key": "property/6767906449167600/019fc97a-ba8a-757e-99d8-7418eed2b097.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJP8WikivrwIcR1QiSoMPLkos",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "liquor_store"
    },
    {
      "id": "custom_5328ea88-e0c5-49d5-b722-9c04d34b99aa",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167600",
      "source": "custom",
      "poi_name": "World Fresh Market",
      "poi_type": "Shopping & Retail",
      "poi_address": "10303 Metcalf Ave, Overland Park, KS 66212, USA",
      "poi_short_description": "Grocery store featuring global fare, from spices to cheeses, as well as a restroom.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167600/019ff6b5-0c12-73d9-95b4-ef1e7dbe30d1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff6b5-0c12-73d9-95b4-ef1e7dbe30d1",
        "storage_key": "property/6767906449167600/019ff6b5-0c12-73d9-95b4-ef1e7dbe30d1.webp",
        "width": 1280,
        "height": 667
      },
      "poi_business_url": "https://www.worldfreshmarketkc.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11278443982537478644&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "world-fresh-market",
      "poi_latitude": "38.9407901",
      "poi_longitude": "-94.6655412",
      "poi_miles_from_property": "2.5",
      "poi_walking_minutes": "55 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 913-361-8534",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167600/019fc97a-ba90-7205-9232-13f4b3e9cf7b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc97a-ba90-7205-9232-13f4b3e9cf7b",
        "storage_key": "property/6767906449167600/019fc97a-ba90-7205-9232-13f4b3e9cf7b.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ2W5CRQDrwIcR9NFJ3gsVhZw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_047e6109-16e7-49ca-be28-edb48b3f969b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167600",
      "source": "custom",
      "poi_name": "Walmart Neighborhood Market",
      "poi_type": "Shopping & Retail",
      "poi_address": "9000 Metcalf Ave, Overland Park, KS 66212, USA",
      "poi_short_description": "Chain retailer with a vast selection including groceries, apparel, home goods & electronics.",
      "poi_long_description": "Chain retailer with a vast selection including groceries, apparel, home goods & electronics.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167600/019fc97d-93d4-716c-b0f2-33e4e4da4249.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc97d-93d4-716c-b0f2-33e4e4da4249",
        "storage_key": "property/6767906449167600/019fc97d-93d4-716c-b0f2-33e4e4da4249.webp",
        "width": 1280,
        "height": 646
      },
      "poi_business_url": "https://www.walmart.com/store/5207-overland-park-ks/?veh=seo_loc",
      "poi_directions_map_url": "https://maps.google.com/?cid=12659740443510836108&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walmart-neighborhood-market",
      "poi_latitude": "38.9657193",
      "poi_longitude": "-94.6687907",
      "poi_miles_from_property": "3.8",
      "poi_walking_minutes": "1 hour 24 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 913-649-4335",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167600/019fc97a-ba90-7205-9232-13f4b3e9cf7b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc97a-ba90-7205-9232-13f4b3e9cf7b",
        "storage_key": "property/6767906449167600/019fc97a-ba90-7205-9232-13f4b3e9cf7b.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJYWyHUZLrwIcRjAsc9NtusK8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_6410fe0f-43c8-45d7-9275-8162f3499d19",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167600",
      "source": "custom",
      "poi_name": "Hy-Vee Grocery Store",
      "poi_type": "Shopping & Retail",
      "poi_address": "8501 W 95th St, Overland Park, KS 66212, USA",
      "poi_short_description": "Supermarket with fresh and organic produce as well as a bakery.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167600/019fc97d-964e-7074-97fa-67a3a14faa37.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc97d-964e-7074-97fa-67a3a14faa37",
        "storage_key": "property/6767906449167600/019fc97d-964e-7074-97fa-67a3a14faa37.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.hy-vee.com/stores/detail.aspx?s=128&utm_source=google&utm_medium=organic&utm_campaign=gmb-listing",
      "poi_directions_map_url": "https://maps.google.com/?cid=11669836886695708453&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "hy-vee-grocery-store",
      "poi_latitude": "38.955555",
      "poi_longitude": "-94.683945",
      "poi_miles_from_property": "2.3",
      "poi_walking_minutes": "51 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 913-894-1983",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167600/019fc97a-ba90-7205-9232-13f4b3e9cf7b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc97a-ba90-7205-9232-13f4b3e9cf7b",
        "storage_key": "property/6767906449167600/019fc97a-ba90-7205-9232-13f4b3e9cf7b.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ7xEOmOzrwIcRJYc_qtGW86E",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_d46ec26b-5101-405b-947a-fcb57f959261",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167600",
      "source": "custom",
      "poi_name": "ALDI",
      "poi_type": "Shopping & Retail",
      "poi_address": "8333 W 95th St, Overland Park, KS 66212, USA",
      "poi_short_description": "Retail chain selling a range of grocery items, meat & dairy.",
      "poi_long_description": "Retail chain selling a range of grocery items, meat & dairy.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167600/019ff6b7-e620-74e3-8e48-eabe826fc05b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff6b7-e620-74e3-8e48-eabe826fc05b",
        "storage_key": "property/6767906449167600/019ff6b7-e620-74e3-8e48-eabe826fc05b.webp",
        "width": 1280,
        "height": 586
      },
      "poi_business_url": "https://info.aldi.us/stores/l/ks/overland-park/8333-w-95th/f319",
      "poi_directions_map_url": "https://maps.google.com/?cid=8904277205991232046&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "aldi",
      "poi_latitude": "38.956629",
      "poi_longitude": "-94.682176",
      "poi_miles_from_property": "2.5",
      "poi_walking_minutes": "54 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 855-955-2534",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167600/019fc97a-ba90-7205-9232-13f4b3e9cf7b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc97a-ba90-7205-9232-13f4b3e9cf7b",
        "storage_key": "property/6767906449167600/019fc97a-ba90-7205-9232-13f4b3e9cf7b.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ_1c74KHrwIcRLhK3JPFYkns",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "supermarket"
    },
    {
      "id": "custom_efee4ac3-a8cd-431d-93b3-c565c7c043f0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167600",
      "source": "custom",
      "poi_name": "Dollar Tree",
      "poi_type": "Shopping & Retail",
      "poi_address": "9024 Metcalf Ave, Overland Park, KS 66212, USA",
      "poi_short_description": "Chain offering a mix of household items, beauty products, food & more at discount prices.",
      "poi_long_description": "Chain offering a mix of household items, beauty products, food & more at discount prices.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167600/019fc97d-9ac8-7749-a698-73573fe3ce67.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc97d-9ac8-7749-a698-73573fe3ce67",
        "storage_key": "property/6767906449167600/019fc97d-9ac8-7749-a698-73573fe3ce67.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://locations.dollartree.com/ks/overland-park/9024-metcalf-ave?utm_source=google&utm_medium=organic&utm_campaign=maps",
      "poi_directions_map_url": "https://maps.google.com/?cid=16267716367956275840&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "dollar-tree",
      "poi_latitude": "38.9657029",
      "poi_longitude": "-94.6701735",
      "poi_miles_from_property": "3.7",
      "poi_walking_minutes": "1 hour 22 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 913-766-2310",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167600/019fc97a-ba8a-757e-99d8-7418eed2b097.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc97a-ba8a-757e-99d8-7418eed2b097",
        "storage_key": "property/6767906449167600/019fc97a-ba8a-757e-99d8-7418eed2b097.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJ_a-O_JLrwIcRgHLXutiJwuE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "discount_store"
    },
    {
      "id": "custom_ebb8c954-8d03-49de-90a8-93d998a4df64",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167600",
      "source": "custom",
      "poi_name": "Oak Park Mall",
      "poi_type": "Shopping & Retail",
      "poi_address": "11149 W 95th St, Overland Park, KS 66214, USA",
      "poi_short_description": "Busy, long-standing indoor shopping destination with 2 levels of popular brands & a food court.",
      "poi_long_description": "Busy, long-standing indoor shopping destination with 2 levels of popular brands & a food court.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167600/019ff6b5-0e6a-7785-85de-e493a015c60c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff6b5-0e6a-7785-85de-e493a015c60c",
        "storage_key": "property/6767906449167600/019ff6b5-0e6a-7785-85de-e493a015c60c.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.shopoakparkmall.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3751688215534709327&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "oak-park-mall",
      "poi_latitude": "38.9530939",
      "poi_longitude": "-94.7196254",
      "poi_miles_from_property": "1.9",
      "poi_walking_minutes": "42 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 913-888-4400",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167600/019fc97a-ba8a-757e-99d8-7418eed2b097.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc97a-ba8a-757e-99d8-7418eed2b097",
        "storage_key": "property/6767906449167600/019fc97a-ba8a-757e-99d8-7418eed2b097.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJzVbG9zXrwIcRTyr3Ao6sEDQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "custom_43765523-44f6-4fa7-9a13-9633ebb92e46",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167600",
      "source": "custom",
      "poi_name": "Target",
      "poi_type": "Shopping & Retail",
      "poi_address": "11501 W 97th St, Overland Park, KS 66214, USA",
      "poi_short_description": "Retail chain offering home goods, clothing, electronics & more, plus exclusive designer collections.",
      "poi_long_description": "Retail chain offering home goods, clothing, electronics & more, plus exclusive designer collections.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167600/019fc97d-943f-70d8-b559-e48aae437e82.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc97d-943f-70d8-b559-e48aae437e82",
        "storage_key": "property/6767906449167600/019fc97d-943f-70d8-b559-e48aae437e82.webp",
        "width": 1280,
        "height": 699
      },
      "poi_business_url": "https://www.target.com/sl/overland-park-west/2043",
      "poi_directions_map_url": "https://maps.google.com/?cid=11588226477518387963&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "target",
      "poi_latitude": "38.95072090000001",
      "poi_longitude": "-94.7195414",
      "poi_miles_from_property": "1.8",
      "poi_walking_minutes": "42 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 913-905-0285",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167600/019fc97a-ba8a-757e-99d8-7418eed2b097.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc97a-ba8a-757e-99d8-7418eed2b097",
        "storage_key": "property/6767906449167600/019fc97a-ba8a-757e-99d8-7418eed2b097.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJ_Vxe5zbrwIcR-3pCkZWm0aA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "department_store"
    },
    {
      "id": "custom_7a54eec0-2fd5-49a3-803c-8021c4b7c469",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167600",
      "source": "custom",
      "poi_name": "Apache Elementary School",
      "poi_type": "Education",
      "poi_address": "8910 Goddard St, Overland Park, KS 66214, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167600/019fc97d-9a1b-757f-865c-248b2fa7512e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc97d-9a1b-757f-865c-248b2fa7512e",
        "storage_key": "property/6767906449167600/019fc97d-9a1b-757f-865c-248b2fa7512e.webp",
        "width": 1280,
        "height": 669
      },
      "poi_business_url": "http://apache.smsd.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13623856567814120774&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "apache-elementary-school",
      "poi_latitude": "38.9661075",
      "poi_longitude": "-94.711302",
      "poi_miles_from_property": "2.4",
      "poi_walking_minutes": "56 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 913-993-1600",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167600/019fc97a-ba7a-7319-be7f-a3b202923e4e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc97a-ba7a-7319-be7f-a3b202923e4e",
        "storage_key": "property/6767906449167600/019fc97a-ba7a-7319-be7f-a3b202923e4e.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJs5KCyVzrwIcRRuVuu12pEb0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_480b2ec7-3b30-45ed-914a-7a43d9e7399c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167600",
      "source": "custom",
      "poi_name": "Oak Park-Carpenter Elementary School",
      "poi_type": "Education",
      "poi_address": "10000 Nieman Rd, Overland Park, KS 66214, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167600/019fc97d-9cd4-72ad-b0f5-796b39a2c7df.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc97d-9cd4-72ad-b0f5-796b39a2c7df",
        "storage_key": "property/6767906449167600/019fc97d-9cd4-72ad-b0f5-796b39a2c7df.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://oakparkcarpenter.smsd.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15083199623749570531&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "oak-park-carpenter-elementary-school",
      "poi_latitude": "38.9458089",
      "poi_longitude": "-94.7145831",
      "poi_miles_from_property": "0.7",
      "poi_walking_minutes": "16 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 913-993-4100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167600/019fc97a-ba7a-7319-be7f-a3b202923e4e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc97a-ba7a-7319-be7f-a3b202923e4e",
        "storage_key": "property/6767906449167600/019fc97a-ba7a-7319-be7f-a3b202923e4e.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ5zGHHzvrwIcR4w_mwSRKUtE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_c192c308-9759-4d00-8372-10f3a215b421",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167600",
      "source": "custom",
      "poi_name": "Comanche Elementary School",
      "poi_type": "Education",
      "poi_address": "8200 Grant Ave, Overland Park, KS 66204, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167600/01a01015-c50c-73c9-ad04-4e08f9df52c3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a01015-c50c-73c9-ad04-4e08f9df52c3",
        "storage_key": "property/6767906449167600/01a01015-c50c-73c9-ad04-4e08f9df52c3.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://comanche.smsd.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=762090537270711352&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "comanche-elementary-school",
      "poi_latitude": "38.9809181",
      "poi_longitude": "-94.696787",
      "poi_miles_from_property": "3.8",
      "poi_walking_minutes": "1 hour 25 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 913-993-2800",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167600/019fc97a-ba7a-7319-be7f-a3b202923e4e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc97a-ba7a-7319-be7f-a3b202923e4e",
        "storage_key": "property/6767906449167600/019fc97a-ba7a-7319-be7f-a3b202923e4e.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ8xiLu5zswIcROBS1UE59kwo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_473d98e9-f0e8-47fb-9b47-a3320da6531b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167600",
      "source": "custom",
      "poi_name": "Westridge Middle School",
      "poi_type": "Education",
      "poi_address": "9300 Nieman Rd, Overland Park, KS 66214, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167600/019fc97d-99ba-75e2-b576-88ba311b5bde.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc97d-99ba-75e2-b576-88ba311b5bde",
        "storage_key": "property/6767906449167600/019fc97d-99ba-75e2-b576-88ba311b5bde.webp",
        "width": 1280,
        "height": 640
      },
      "poi_business_url": "https://westridge.smsd.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=217242892534723488&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "westridge-middle-school",
      "poi_latitude": "38.9590348",
      "poi_longitude": "-94.7157697",
      "poi_miles_from_property": "1.7",
      "poi_walking_minutes": "40 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 913-993-1200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167600/019fc97a-ba7a-7319-be7f-a3b202923e4e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc97a-ba7a-7319-be7f-a3b202923e4e",
        "storage_key": "property/6767906449167600/019fc97a-ba7a-7319-be7f-a3b202923e4e.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJk5xqEUbrwIcRoLOCf0LNAwM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "custom_74f0b00b-89e9-42d8-bc11-f11bc4534bff",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167600",
      "source": "custom",
      "poi_name": "Indian Woods Middle School",
      "poi_type": "Education",
      "poi_address": "9700 Woodson Dr, Overland Park, KS 66207, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167600/01a01015-c0bb-74be-aaec-779f046f34f4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a01015-c0bb-74be-aaec-779f046f34f4",
        "storage_key": "property/6767906449167600/01a01015-c0bb-74be-aaec-779f046f34f4.webp",
        "width": 1280,
        "height": 782
      },
      "poi_business_url": "https://indianwoods.smsd.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11708930099391460908&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "indian-woods-middle-school",
      "poi_latitude": "38.9522694",
      "poi_longitude": "-94.6552064",
      "poi_miles_from_property": "3.8",
      "poi_walking_minutes": "1 hour 24 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 913-993-0600",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167600/019fc97a-ba7a-7319-be7f-a3b202923e4e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc97a-ba7a-7319-be7f-a3b202923e4e",
        "storage_key": "property/6767906449167600/019fc97a-ba7a-7319-be7f-a3b202923e4e.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ4bUrTdvrwIcRLHYbiuN5fqI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "custom_da5abb2d-364c-4470-b147-ee8ca9645813",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167600",
      "source": "custom",
      "poi_name": "Shawnee Mission South High School",
      "poi_type": "Education",
      "poi_address": "5800 W 107th St, Overland Park, KS 66207, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167600/01a01015-c0bb-74be-aaec-7980602afa0d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a01015-c0bb-74be-aaec-7980602afa0d",
        "storage_key": "property/6767906449167600/01a01015-c0bb-74be-aaec-7980602afa0d.webp",
        "width": 1280,
        "height": 742
      },
      "poi_business_url": "https://smsouth.smsd.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3539070587316418831&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "shawnee-mission-south-high-school",
      "poi_latitude": "38.9373596",
      "poi_longitude": "-94.6535918",
      "poi_miles_from_property": "3.7",
      "poi_walking_minutes": "1 hour 22 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 913-993-7500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167600/019fc97a-ba7a-7319-be7f-a3b202923e4e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc97a-ba7a-7319-be7f-a3b202923e4e",
        "storage_key": "property/6767906449167600/019fc97a-ba7a-7319-be7f-a3b202923e4e.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJpYRoydLrwIcRDzkHyPJNHTE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "custom_d1cd5835-312e-4b3a-a72c-adb302000638",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167600",
      "source": "custom",
      "poi_name": "Holy Spirit Catholic School",
      "poi_type": "Education",
      "poi_address": "11300 103rd St, Overland Park, KS 66214, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.hscatholicschool.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2654517182262789910&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "holy-spirit-catholic-school",
      "poi_latitude": "38.9424954",
      "poi_longitude": "-94.7145557",
      "poi_miles_from_property": "0.5",
      "poi_walking_minutes": "12 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 913-492-2582",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167600/019fc97a-ba7a-7319-be7f-a3b202923e4e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc97a-ba7a-7319-be7f-a3b202923e4e",
        "storage_key": "property/6767906449167600/019fc97a-ba7a-7319-be7f-a3b202923e4e.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJlYwyICXrwIcRFsfxIlC91iQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "custom_074205fd-189f-409f-899d-8bc0b772861e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167600",
      "source": "custom",
      "poi_name": "Saint Thomas Aquinas High School",
      "poi_type": "Education",
      "poi_address": "11411 South Pflumm Rd, Overland Park, KS 66210, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167600/019fc97d-a252-754d-83b7-c5c79aca86be.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc97d-a252-754d-83b7-c5c79aca86be",
        "storage_key": "property/6767906449167600/019fc97d-a252-754d-83b7-c5c79aca86be.webp",
        "width": 1280,
        "height": 1280
      },
      "poi_business_url": "http://www.stasaints.net/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4092999226720322010&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "saint-thomas-aquinas-high-school",
      "poi_latitude": "38.9221637",
      "poi_longitude": "-94.740104",
      "poi_miles_from_property": "3.2",
      "poi_walking_minutes": "1 hour 13 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 913-345-1411",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167600/019fc97a-ba7a-7319-be7f-a3b202923e4e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc97a-ba7a-7319-be7f-a3b202923e4e",
        "storage_key": "property/6767906449167600/019fc97a-ba7a-7319-be7f-a3b202923e4e.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJB3eqtiSVwIcR2gGdbhxBzTg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "custom_12552101-1866-4cb2-977d-45b07e403dcb",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167600",
      "source": "custom",
      "poi_name": "Johnson County Community College",
      "poi_type": "Education",
      "poi_address": "12345 College Blvd, Overland Park, KS 66210, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167600/019fc97a-92d8-73ce-a8e6-20f92cc51510.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc97a-92d8-73ce-a8e6-20f92cc51510",
        "storage_key": "property/6767906449167600/019fc97a-92d8-73ce-a8e6-20f92cc51510.webp",
        "width": 960,
        "height": 540
      },
      "poi_business_url": "https://www.jccc.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4939079639992649295&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "johnson-county-community-college",
      "poi_latitude": "38.9237619",
      "poi_longitude": "-94.7303185",
      "poi_miles_from_property": "2.4",
      "poi_walking_minutes": "55 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 913-469-8500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167600/019fc97a-ba7a-7319-be7f-a3b202923e4e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc97a-ba7a-7319-be7f-a3b202923e4e",
        "storage_key": "property/6767906449167600/019fc97a-ba7a-7319-be7f-a3b202923e4e.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJEejhg2TrwIcRT0Ygo8Mii0Q",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_8c8c0188-ceb2-4918-a984-c8732d44647b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167600",
      "source": "custom",
      "poi_name": "University of Kansas Edwards Campus",
      "poi_type": "Education",
      "poi_address": "12600 S Quivira Rd, Overland Park, KS 66213, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167600/019fc97d-a16d-77d8-ac40-3f0791ccc87c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc97d-a16d-77d8-ac40-3f0791ccc87c",
        "storage_key": "property/6767906449167600/019fc97d-a16d-77d8-ac40-3f0791ccc87c.webp",
        "width": 1280,
        "height": 795
      },
      "poi_business_url": "http://edwardscampus.ku.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15421529977661014929&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "university-of-kansas-edwards-campus",
      "poi_latitude": "38.900081",
      "poi_longitude": "-94.7254776",
      "poi_miles_from_property": "3.8",
      "poi_walking_minutes": "1 hour 25 mins",
      "poi_biking_minutes": "40 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 913-897-8400",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167600/019fc97a-ba7a-7319-be7f-a3b202923e4e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc97a-ba7a-7319-be7f-a3b202923e4e",
        "storage_key": "property/6767906449167600/019fc97a-ba7a-7319-be7f-a3b202923e4e.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJcfRKua3qwIcRkcOF085HBNY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_14608c51-22ad-467e-8a52-896e01361266",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167600",
      "source": "custom",
      "poi_name": "AMC Town Center 20",
      "poi_type": "Entertainment",
      "poi_address": "11701 Nall Ave, Leawood, KS 66211, USA",
      "poi_short_description": "Modern cinema equipped with comfy seats, luxury recliners, and a snack bar.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167600/01a01015-c426-74c5-86da-e05160809055.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a01015-c426-74c5-86da-e05160809055",
        "storage_key": "property/6767906449167600/01a01015-c426-74c5-86da-e05160809055.webp",
        "width": 1280,
        "height": 783
      },
      "poi_business_url": "https://www.amctheatres.com/movie-theatres/kansas-city/amc-town-center-20?utm_medium=organic&utm_source=google&utm_campaign=local",
      "poi_directions_map_url": "https://maps.google.com/?cid=2804340900304979407&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "amc-town-center-20",
      "poi_latitude": "38.915838",
      "poi_longitude": "-94.648325",
      "poi_miles_from_property": "5.1",
      "poi_walking_minutes": "1 hour 53 mins",
      "poi_biking_minutes": "34 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 913-498-8696",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167600/019fc97d-cdbb-713b-b9d6-45a6cdfce3b8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc97d-cdbb-713b-b9d6-45a6cdfce3b8",
        "storage_key": "property/6767906449167600/019fc97d-cdbb-713b-b9d6-45a6cdfce3b8.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJ6xgReh_qwIcRzwXH1zAF6yY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "movie_theater"
    },
    {
      "id": "custom_75d00aea-e203-453e-a1b5-cd306807f1ad",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167600",
      "source": "custom",
      "poi_name": "B&B Theatres Overland Park 16",
      "poi_type": "Entertainment",
      "poi_address": "8601 W 135th St, Overland Park, KS 66223, USA",
      "poi_short_description": "Relaxed, contemporary multiscreen theater featuring showings of mainstream films.",
      "poi_long_description": "Relaxed, contemporary multiscreen theater featuring showings of mainstream films.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167600/01a01015-c5bb-727a-9a4c-3b6817cab7a1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a01015-c5bb-727a-9a4c-3b6817cab7a1",
        "storage_key": "property/6767906449167600/01a01015-c5bb-727a-9a4c-3b6817cab7a1.webp",
        "width": 1280,
        "height": 950
      },
      "poi_business_url": "https://www.bbtheatres.com/our-theatres/x0uvh-b-and-b-overland-park-16/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6259761698616561138&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "bb-theatres-overland-park-16",
      "poi_latitude": "38.8812512",
      "poi_longitude": "-94.6835183",
      "poi_miles_from_property": "5.6",
      "poi_walking_minutes": "2 hours 4 mins",
      "poi_biking_minutes": "35 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 913-871-5352",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167600/019fc97d-cdbb-713b-b9d6-45a6cdfce3b8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc97d-cdbb-713b-b9d6-45a6cdfce3b8",
        "storage_key": "property/6767906449167600/019fc97d-cdbb-713b-b9d6-45a6cdfce3b8.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJDWO_qc3BwIcR8s2iaBkk31Y",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "movie_theater"
    },
    {
      "id": "custom_2ba1ed0f-c5d4-41ad-b3ac-19c23757ddfc",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167600",
      "source": "custom",
      "poi_name": "Deanna Rose Children's Farmstead",
      "poi_type": "Entertainment",
      "poi_address": "13800 Switzer Rd, Overland Park, KS 66221, USA",
      "poi_short_description": "Spacious farmstead featuring replicas of life on the prairie, an ice cream parlor & wagon rides.",
      "poi_long_description": "Spacious farmstead featuring replicas of life on the prairie, an ice cream parlor & wagon rides.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167600/019fc97d-a621-7667-a7bb-28c24ea74b89.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc97d-a621-7667-a7bb-28c24ea74b89",
        "storage_key": "property/6767906449167600/019fc97d-a621-7667-a7bb-28c24ea74b89.webp",
        "width": 640,
        "height": 349
      },
      "poi_business_url": "http://www.opkansas.org/things-to-see-and-do/deanna-rose-childrens-farmstead/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7835830010939554497&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "deanna-rose-childrens-farmstead",
      "poi_latitude": "38.877729",
      "poi_longitude": "-94.703345",
      "poi_miles_from_property": "6.3",
      "poi_walking_minutes": "2 hours 19 mins",
      "poi_biking_minutes": "40 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 913-897-2360",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167600/019fc97a-ba7b-7268-a9ee-14f9bd5d82b8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc97a-ba7b-7268-a9ee-14f9bd5d82b8",
        "storage_key": "property/6767906449167600/019fc97a-ba7b-7268-a9ee-14f9bd5d82b8.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJt6IUwjvAwIcRwbplAuF1vmw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_ed23d8ec-ec35-4557-b602-3193dd9f70bc",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167600",
      "source": "custom",
      "poi_name": "Topgolf Overland Park",
      "poi_type": "Entertainment",
      "poi_address": "10611 Nall Ave, Overland Park, KS 66207, USA",
      "poi_short_description": "Sprawling entertainment venue with a high-tech driving range & swanky lounge with drinks & games.",
      "poi_long_description": "Sprawling entertainment venue with a high-tech driving range & swanky lounge with drinks & games.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167600/019fc97a-9980-72ce-a328-47192b1c3b1b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc97a-9980-72ce-a328-47192b1c3b1b",
        "storage_key": "property/6767906449167600/019fc97a-9980-72ce-a328-47192b1c3b1b.webp",
        "width": 1280,
        "height": 884
      },
      "poi_business_url": "https://topgolf.com/us/overland-park/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4737452325202402593&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "topgolf-overland-park",
      "poi_latitude": "38.9364597",
      "poi_longitude": "-94.64818",
      "poi_miles_from_property": "3.7",
      "poi_walking_minutes": "1 hour 22 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 913-562-9713",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167600/019fc97a-ba7b-7268-a9ee-14f9bd5d82b8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc97a-ba7b-7268-a9ee-14f9bd5d82b8",
        "storage_key": "property/6767906449167600/019fc97a-ba7b-7268-a9ee-14f9bd5d82b8.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJibz1RyvqwIcRIZ0JKMrPvkE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_13a8601f-3872-417b-9d25-c1d2a2241bac",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167600",
      "source": "custom",
      "poi_name": "Museum at Prairiefire",
      "poi_type": "Entertainment",
      "poi_address": "5801 W 135th St, Overland Park, KS 66223, USA",
      "poi_short_description": "Bright, uniquely designed museum with changing natural history exhibits on dinosaurs & space.",
      "poi_long_description": "Bright, uniquely designed museum with changing natural history exhibits on dinosaurs & space.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167600/019fc97a-9b3e-7210-83a7-2f5d247e326f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc97a-9b3e-7210-83a7-2f5d247e326f",
        "storage_key": "property/6767906449167600/019fc97a-9b3e-7210-83a7-2f5d247e326f.webp",
        "width": 1170,
        "height": 797
      },
      "poi_business_url": "https://www.visitthemap.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9011883457387750483&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "museum-at-prairiefire",
      "poi_latitude": "38.8819446",
      "poi_longitude": "-94.6520905",
      "poi_miles_from_property": "7.1",
      "poi_walking_minutes": "2 hours 37 mins",
      "poi_biking_minutes": "48 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 913-333-3500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167600/019fc97a-ba7c-7435-a192-0b06c26e5768.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc97a-ba7c-7435-a192-0b06c26e5768",
        "storage_key": "property/6767906449167600/019fc97a-ba7c-7435-a192-0b06c26e5768.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJOdDvHPHBwIcRU-TQ6kGkEH0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_059bc778-3f7b-4da2-ac33-90ec63234666",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167600",
      "source": "custom",
      "poi_name": "Urban Air Trampoline and Adventure Park",
      "poi_type": "Entertainment",
      "poi_address": "14401 Metcalf Ave, Overland Park, KS 66223, USA",
      "poi_short_description": "Large-scale indoor trampoline center hosting open jump, fitness classes, dodgeball & parties.",
      "poi_long_description": "Large-scale indoor trampoline center hosting open jump, fitness classes, dodgeball & parties.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167600/01a01015-c507-76b8-a9d6-c353bd912798.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a01015-c507-76b8-a9d6-c353bd912798",
        "storage_key": "property/6767906449167600/01a01015-c507-76b8-a9d6-c353bd912798.webp",
        "width": 909,
        "height": 1186
      },
      "poi_business_url": "https://www.urbanair.com/kansas-overland-park/?utm_source=gmb&utm_medium=website",
      "poi_directions_map_url": "https://maps.google.com/?cid=11815076256041431885&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "urban-air-trampoline-and-adventure-park",
      "poi_latitude": "38.8673367",
      "poi_longitude": "-94.664787",
      "poi_miles_from_property": "7.4",
      "poi_walking_minutes": "2 hours 45 mins",
      "poi_biking_minutes": "47 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 913-298-0626",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167600/019fc97a-ba7b-7268-a9ee-14f9bd5d82b8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc97a-ba7b-7268-a9ee-14f9bd5d82b8",
        "storage_key": "property/6767906449167600/019fc97a-ba7b-7268-a9ee-14f9bd5d82b8.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ5eXXF5bBwIcRTXOAg0GV96M",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "amusement_park"
    },
    {
      "id": "custom_a1689dcf-69b9-4fa0-89a8-bcaac3ca0fa9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167600",
      "source": "custom",
      "poi_name": "Nerman Museum of Contemporary Art",
      "poi_type": "Entertainment",
      "poi_address": "12345 College Blvd, Overland Park, KS 66210, USA",
      "poi_short_description": "Johnson County Community College's modern-art facility including an auditorium, cafe & classrooms.",
      "poi_long_description": "Johnson County Community College's modern-art facility including an auditorium, cafe & classrooms.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167600/019fc97d-a30e-737d-836f-7d3d7f62c8ab.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc97d-a30e-737d-836f-7d3d7f62c8ab",
        "storage_key": "property/6767906449167600/019fc97d-a30e-737d-836f-7d3d7f62c8ab.webp",
        "width": 1080,
        "height": 830
      },
      "poi_business_url": "http://www.nermanmuseum.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4973184191241098516&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "nerman-museum-of-contemporary-art",
      "poi_latitude": "38.924852",
      "poi_longitude": "-94.726824",
      "poi_miles_from_property": "2.2",
      "poi_walking_minutes": "50 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 913-469-3000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167600/019fc97a-ba7c-7435-a192-0b06c26e5768.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc97a-ba7c-7435-a192-0b06c26e5768",
        "storage_key": "property/6767906449167600/019fc97a-ba7c-7435-a192-0b06c26e5768.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJgVtOx9LqwIcRFJWDQaxMBEU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "art_museum"
    },
    {
      "id": "custom_29ce9f61-f077-4fc8-81c6-a63c411ee3a6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167600",
      "source": "custom",
      "poi_name": "Johnson County Arts And Heritage Center",
      "poi_type": "Entertainment",
      "poi_address": "8788 Metcalf Ave, Overland Park, KS 66212, USA",
      "poi_short_description": "Cultural center featuring the Johnson County Museum, the KidScape experience, and a theater.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167600/019ff6b7-eff8-77af-b921-1d8d673123f8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff6b7-eff8-77af-b921-1d8d673123f8",
        "storage_key": "property/6767906449167600/019ff6b7-eff8-77af-b921-1d8d673123f8.webp",
        "width": 1200,
        "height": 900
      },
      "poi_business_url": "https://www.jcprd.com/327/Arts-Heritage-Center",
      "poi_directions_map_url": "https://maps.google.com/?cid=6564331375929992564&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "johnson-county-arts-and-heritage-center",
      "poi_latitude": "38.9698449",
      "poi_longitude": "-94.6681692",
      "poi_miles_from_property": "4.1",
      "poi_walking_minutes": "1 hour 32 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 913-826-2787",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167600/019fc97a-ba7b-7268-a9ee-14f9bd5d82b8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc97a-ba7b-7268-a9ee-14f9bd5d82b8",
        "storage_key": "property/6767906449167600/019fc97a-ba7b-7268-a9ee-14f9bd5d82b8.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJA2a8po3rwIcRdCVCapswGVs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "cultural_center"
    },
    {
      "id": "custom_82f3f9c8-aaf5-430b-abb9-4c139210edf3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167600",
      "source": "custom",
      "poi_name": "New Theatre & Restaurant",
      "poi_type": "Entertainment",
      "poi_address": "9229 Foster St, Overland Park, KS 66212, USA",
      "poi_short_description": "Dinner-theater venue showcasing Broadway musicals & comedies alongside food & drink.",
      "poi_long_description": "Dinner-theater venue showcasing Broadway musicals & comedies alongside food & drink.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167600/019fc97d-a687-74ef-9ef0-1890c067c548.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc97d-a687-74ef-9ef0-1890c067c548",
        "storage_key": "property/6767906449167600/019fc97d-a687-74ef-9ef0-1890c067c548.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.newtheatre.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13688728751314082407&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "new-theatre--restaurant",
      "poi_latitude": "38.9616203",
      "poi_longitude": "-94.6705932",
      "poi_miles_from_property": "3.4",
      "poi_walking_minutes": "1 hour 15 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 913-649-7469",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167600/019fc97a-ba7b-7268-a9ee-14f9bd5d82b8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc97a-ba7b-7268-a9ee-14f9bd5d82b8",
        "storage_key": "property/6767906449167600/019fc97a-ba7b-7268-a9ee-14f9bd5d82b8.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJoWtUxpbrwIcRZ5rA-EUi-L0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "performing_arts_theater"
    },
    {
      "id": "custom_5df50a9b-d8d8-4348-a985-8b23446ef93c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167600",
      "source": "custom",
      "poi_name": "Overland Park Regional Medical Center",
      "poi_type": "Health and Wellness",
      "poi_address": "10500 Quivira Rd, Overland Park, KS 66215, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167600/019fc97d-aa16-735b-919e-f0f1db7ec632.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc97d-aa16-735b-919e-f0f1db7ec632",
        "storage_key": "property/6767906449167600/019fc97d-aa16-735b-919e-f0f1db7ec632.webp",
        "width": 1280,
        "height": 719
      },
      "poi_business_url": "https://www.hcamidwest.com/locations/overland-park-regional-medical-center?utm_campaign=corp_listings_mgmt&utm_source=google&utm_medium=business_listing",
      "poi_directions_map_url": "https://maps.google.com/?cid=13555409796355494155&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "overland-park-regional-medical-center",
      "poi_latitude": "38.9376197",
      "poi_longitude": "-94.7261812",
      "poi_miles_from_property": "1.4",
      "poi_walking_minutes": "30 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 913-541-5000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167600/019fc97a-ba79-70a6-99cb-f9c074d7c192.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc97a-ba79-70a6-99cb-f9c074d7c192",
        "storage_key": "property/6767906449167600/019fc97a-ba79-70a6-99cb-f9c074d7c192.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJ4cFCWJzAwIcRC5Ge4GN9Hrw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_ab62012d-1e1c-4f1b-aab5-63cbc4441470",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167600",
      "source": "custom",
      "poi_name": "Children's Mercy Kansas",
      "poi_type": "Health and Wellness",
      "poi_address": "5808 W 110th St, Overland Park, KS 66211, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167600/019fc97a-a55e-722d-933e-8306a4f708b4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc97a-a55e-722d-933e-8306a4f708b4",
        "storage_key": "property/6767906449167600/019fc97a-a55e-722d-933e-8306a4f708b4.webp",
        "width": 720,
        "height": 1280
      },
      "poi_business_url": "https://www.childrensmercy.org/Kansas/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8535209985424805612&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "childrens-mercy-kansas",
      "poi_latitude": "38.9299718",
      "poi_longitude": "-94.6522904",
      "poi_miles_from_property": "4.1",
      "poi_walking_minutes": "1 hour 31 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 913-696-8000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167600/019fc97a-ba79-70a6-99cb-f9c074d7c192.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc97a-ba79-70a6-99cb-f9c074d7c192",
        "storage_key": "property/6767906449167600/019fc97a-ba79-70a6-99cb-f9c074d7c192.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJ03Xo8C7qwIcR7M6coEIoc3Y",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_9175a2dc-a50f-49ad-a8f2-b489b6245d2b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167600",
      "source": "custom",
      "poi_name": "CareNow Urgent Care - Overland Park North",
      "poi_type": "Health and Wellness",
      "poi_address": "9507 Antioch Rd, Overland Park, KS 66212, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167600/019fc97d-a9a7-7582-9958-c10aed1da686.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc97d-a9a7-7582-9958-c10aed1da686",
        "storage_key": "property/6767906449167600/019fc97d-a9a7-7582-9958-c10aed1da686.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.carenow.com/locations/kansas-city/overland-park-north?utm_campaign=corp_listings_mgmt&utm_source=google&utm_medium=business_listing",
      "poi_directions_map_url": "https://maps.google.com/?cid=17796506606246617401&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "carenow-urgent-care---overland-park-north",
      "poi_latitude": "38.9558927",
      "poi_longitude": "-94.6859458",
      "poi_miles_from_property": "2.2",
      "poi_walking_minutes": "50 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 913-227-4631",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167600/019fc97a-ba7b-7268-a9ee-14f9bd5d82b8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc97a-ba7b-7268-a9ee-14f9bd5d82b8",
        "storage_key": "property/6767906449167600/019fc97a-ba7b-7268-a9ee-14f9bd5d82b8.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJkZTQ_5_rwIcROeE47Hfk-fY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_clinic"
    },
    {
      "id": "custom_5cc05c32-adec-421d-8008-7c2f7d076475",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167600",
      "source": "custom",
      "poi_name": "Saint Luke's Urgent Care Mission Farms",
      "poi_type": "Health and Wellness",
      "poi_address": "4061 Indian Creek Pkwy Ste 130, Overland Park, KS 66207, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167600/01a01015-c94f-77dc-ae67-5d0ec29ea1d0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a01015-c94f-77dc-ae67-5d0ec29ea1d0",
        "storage_key": "property/6767906449167600/01a01015-c94f-77dc-ae67-5d0ec29ea1d0.webp",
        "width": 1280,
        "height": 790
      },
      "poi_business_url": "http://www.saintlukeskc.org/locations/saint-lukes-urgent-care-mission-farms?utm_source=yext&utm_medium=local_listing&utm_campaign=yext_listing",
      "poi_directions_map_url": "https://maps.google.com/?cid=5669247484462833492&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "saint-lukes-urgent-care-mission-farms",
      "poi_latitude": "38.9340833",
      "poi_longitude": "-94.6315568",
      "poi_miles_from_property": "4.7",
      "poi_walking_minutes": "1 hour 42 mins",
      "poi_biking_minutes": "32 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 913-323-8885",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167600/019fc97a-ba7b-7268-a9ee-14f9bd5d82b8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc97a-ba7b-7268-a9ee-14f9bd5d82b8",
        "storage_key": "property/6767906449167600/019fc97a-ba7b-7268-a9ee-14f9bd5d82b8.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ_Wcf-JzpwIcRVB8v14w2rU4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_clinic"
    },
    {
      "id": "custom_c6579a6a-4012-48cc-bee3-1002163e6643",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167600",
      "source": "custom",
      "poi_name": "CVS Pharmacy",
      "poi_type": "Health and Wellness",
      "poi_address": "11501 W 97th St, Overland Park, KS 66214, USA",
      "poi_short_description": "Drugstore chain selling a variety of beauty & health products, plus some grocery & household items.",
      "poi_long_description": "Drugstore chain selling a variety of beauty & health products, plus some grocery & household items.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167600/019ff6b7-ea78-702b-b1b0-0023a576dae5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff6b7-ea78-702b-b1b0-0023a576dae5",
        "storage_key": "property/6767906449167600/019ff6b7-ea78-702b-b1b0-0023a576dae5.webp",
        "width": 1280,
        "height": 647
      },
      "poi_business_url": "https://www.cvs.com/store-locator/overland-park-ks-pharmacies/11501-w-97th-st-overland-park-ks-66214/storeid=17135?WT.mc_id=LS_GOOGLE_RX_17135",
      "poi_directions_map_url": "https://maps.google.com/?cid=10387190568221470602&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cvs-pharmacy",
      "poi_latitude": "38.95072090000001",
      "poi_longitude": "-94.7195414",
      "poi_miles_from_property": "1.8",
      "poi_walking_minutes": "42 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 913-905-0286",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167600/019fc97d-cda5-720b-8eb6-2086a7315cca.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc97d-cda5-720b-8eb6-2086a7315cca",
        "storage_key": "property/6767906449167600/019fc97d-cda5-720b-8eb6-2086a7315cca.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ_Vxe5zbrwIcRiu8gwcm2JpA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "custom_5dc47ccb-93c9-4fb9-a13e-30fd7d037ca9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167600",
      "source": "custom",
      "poi_name": "CVS",
      "poi_type": "Health and Wellness",
      "poi_address": "7501 Metcalf Ave, Overland Park, KS 66204, USA",
      "poi_short_description": "Drugstore chain selling a variety of beauty & health products, plus some grocery & household items.",
      "poi_long_description": "Drugstore chain selling a variety of beauty & health products, plus some grocery & household items.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167600/019ff6b7-f4f4-746c-8f6a-b87dfccdc7cc.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff6b7-f4f4-746c-8f6a-b87dfccdc7cc",
        "storage_key": "property/6767906449167600/019ff6b7-f4f4-746c-8f6a-b87dfccdc7cc.webp",
        "width": 936,
        "height": 800
      },
      "poi_business_url": "https://www.cvs.com/store-locator/overland-park-ks-pharmacies/7501-metcalf-ave-overland-park-ks-66204/storeid=8602?WT.mc_id=LS_GOOGLE_FS_8602",
      "poi_directions_map_url": "https://maps.google.com/?cid=13819622875502458664&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cvs",
      "poi_latitude": "38.99266",
      "poi_longitude": "-94.66672",
      "poi_miles_from_property": "5.4",
      "poi_walking_minutes": "2 hours 0 mins",
      "poi_biking_minutes": "31 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 913-642-6330",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167600/019fc97a-ba7b-7268-a9ee-14f9bd5d82b8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc97a-ba7b-7268-a9ee-14f9bd5d82b8",
        "storage_key": "property/6767906449167600/019fc97a-ba7b-7268-a9ee-14f9bd5d82b8.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJhdsgvGzswIcRKLcvKMkpyb8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "drugstore"
    },
    {
      "id": "custom_02ca74c0-000d-4d49-bcc7-294d5f6dccc4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167600",
      "source": "custom",
      "poi_name": "Genesis Health Clubs – North Overland Park",
      "poi_type": "Health and Wellness",
      "poi_address": "10351 Barkley St, Overland Park, KS 66212, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167600/019fc97d-b04b-7493-a267-e841efd1463d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc97d-b04b-7493-a267-e841efd1463d",
        "storage_key": "property/6767906449167600/019fc97d-b04b-7493-a267-e841efd1463d.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.genesishealthclubs.com/locations/north-overland-park.html?utm_campaign=search&utm_medium=organic&utm_source=gbp",
      "poi_directions_map_url": "https://maps.google.com/?cid=16405331593319719117&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "genesis-health-clubs--north-overland-park",
      "poi_latitude": "38.9411019",
      "poi_longitude": "-94.6638455",
      "poi_miles_from_property": "2.6",
      "poi_walking_minutes": "56 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 913-648-3561",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167600/019fc97a-ba7b-7268-a9ee-14f9bd5d82b8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc97a-ba7b-7268-a9ee-14f9bd5d82b8",
        "storage_key": "property/6767906449167600/019fc97a-ba7b-7268-a9ee-14f9bd5d82b8.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJk5NgMMrrwIcRzaBQOipyq-M",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_cf193166-2f0f-403c-9d47-c3e3ff2ec7c9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167600",
      "source": "custom",
      "poi_name": "Fitness Factory KC",
      "poi_type": "Health and Wellness",
      "poi_address": "10550 103rd St, Overland Park, KS 66214, USA",
      "poi_short_description": "Spacious gym with state-of-the-art equipment (from Atlantis and Prime) and personal training services - 24/7 access offered.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167600/019ff6b7-f95a-70cc-ac68-19bf6fbf484f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff6b7-f95a-70cc-ac68-19bf6fbf484f",
        "storage_key": "property/6767906449167600/019ff6b7-f95a-70cc-ac68-19bf6fbf484f.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://fitnessfactorykc.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2981365763699520940&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "fitness-factory-kc",
      "poi_latitude": "38.9425637",
      "poi_longitude": "-94.7024734",
      "poi_miles_from_property": "0.6",
      "poi_walking_minutes": "13 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 913-395-9015",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167600/019fc97a-ba7b-7268-a9ee-14f9bd5d82b8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc97a-ba7b-7268-a9ee-14f9bd5d82b8",
        "storage_key": "property/6767906449167600/019fc97a-ba7b-7268-a9ee-14f9bd5d82b8.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJV0c5P_jrwIcRrDXSul3wXyk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_0cd0d279-a4c5-4c72-ab68-d4029fc74d1e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167600",
      "source": "custom",
      "poi_name": "Orangetheory Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "13621 Metcalf Ave, Overland Park, KS 66223, USA",
      "poi_short_description": "Heart rate–based, calorie-burning studio featuring group classes and workouts that can be tracked in real-time.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167600/01a01015-ca1d-706d-845f-61f749609a16.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a01015-ca1d-706d-845f-61f749609a16",
        "storage_key": "property/6767906449167600/01a01015-ca1d-706d-845f-61f749609a16.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.orangetheory.com/en-us/locations/kansas/overland-park/13621-metcalf-ave/?utm_medium=seo&utm_source=gg&utm_term=tombras&utm_campaign=reputationdotcom--National",
      "poi_directions_map_url": "https://maps.google.com/?cid=2517780848240473361&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "orangetheory-fitness",
      "poi_latitude": "38.8814048",
      "poi_longitude": "-94.6672773",
      "poi_miles_from_property": "6.3",
      "poi_walking_minutes": "2 hours 21 mins",
      "poi_biking_minutes": "40 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 913-213-1012",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167600/019fc97a-ba7b-7268-a9ee-14f9bd5d82b8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc97a-ba7b-7268-a9ee-14f9bd5d82b8",
        "storage_key": "property/6767906449167600/019fc97a-ba7b-7268-a9ee-14f9bd5d82b8.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJz2AK5sLBwIcREbWneVf08CI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_d3c1152d-e969-4127-9301-0f212600dd2f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167600",
      "source": "custom",
      "poi_name": "Pure Barre",
      "poi_type": "Health and Wellness",
      "poi_address": "11954 Roe Ave, Overland Park, KS 66209, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167600/01a01015-cb95-75ba-9460-03ffe83a20ed.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a01015-cb95-75ba-9460-03ffe83a20ed",
        "storage_key": "property/6767906449167600/01a01015-cb95-75ba-9460-03ffe83a20ed.webp",
        "width": 480,
        "height": 270
      },
      "poi_business_url": "https://www.purebarre.com/location/overland-park-ks",
      "poi_directions_map_url": "https://maps.google.com/?cid=16022893332392947976&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "pure-barre",
      "poi_latitude": "38.91131960000001",
      "poi_longitude": "-94.6409097",
      "poi_miles_from_property": "5.6",
      "poi_walking_minutes": "2 hours 4 mins",
      "poi_biking_minutes": "37 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 913-954-7954",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167600/019fc97a-ba7b-7268-a9ee-14f9bd5d82b8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc97a-ba7b-7268-a9ee-14f9bd5d82b8",
        "storage_key": "property/6767906449167600/019fc97a-ba7b-7268-a9ee-14f9bd5d82b8.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJR42hS_TpwIcRCLFBx5fAXN4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "health"
    },
    {
      "id": "custom_c3866fe3-6823-484a-9c94-38e0dddb08f4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167600",
      "source": "custom",
      "poi_name": "Bluejacket Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "10101 Bond St, Overland Park, KS 66214, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167600/01a01015-cd3e-77d6-8942-dcf8603a85af.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a01015-cd3e-77d6-8942-dcf8603a85af",
        "storage_key": "property/6767906449167600/01a01015-cd3e-77d6-8942-dcf8603a85af.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://opkansas.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2831659018989769284&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "bluejacket-park",
      "poi_latitude": "38.9461948",
      "poi_longitude": "-94.7166283",
      "poi_miles_from_property": "0.9",
      "poi_walking_minutes": "22 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 913-895-6000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167600/019fc97a-ba8c-729b-a509-4a4184f818f4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc97a-ba8c-729b-a509-4a4184f818f4",
        "storage_key": "property/6767906449167600/019fc97a-ba8c-729b-a509-4a4184f818f4.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ40o3ljrrwIcRRJLq_98STCc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_4fb5b541-4d3d-48b2-a20d-342cf98960ac",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167600",
      "source": "custom",
      "poi_name": "Oak Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "11506 W 106th St, Overland Park, KS 66214, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167600/01a01015-ce66-7126-ac08-4ffccf0e0bf7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a01015-ce66-7126-ac08-4ffccf0e0bf7",
        "storage_key": "property/6767906449167600/01a01015-ce66-7126-ac08-4ffccf0e0bf7.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=8304000677742693745&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "oak-park",
      "poi_latitude": "38.939574",
      "poi_longitude": "-94.72103",
      "poi_miles_from_property": "0.9",
      "poi_walking_minutes": "20 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167600/019fc97a-ba8c-729b-a509-4a4184f818f4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc97a-ba8c-729b-a509-4a4184f818f4",
        "storage_key": "property/6767906449167600/019fc97a-ba8c-729b-a509-4a4184f818f4.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ27uZyy7rwIcRcc10s568PXM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_a6752307-d5a5-4a79-8cb7-c90c76526d6e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167600",
      "source": "custom",
      "poi_name": "Hanover Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "Hanover Park, 9808 W 103rd Terrace, Overland Park, KS 66212, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=7864471159376321135&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "hanover-park",
      "poi_latitude": "38.9422634",
      "poi_longitude": "-94.6958302",
      "poi_miles_from_property": "0.9",
      "poi_walking_minutes": "18 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167600/019fc97a-ba7b-7268-a9ee-14f9bd5d82b8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc97a-ba7b-7268-a9ee-14f9bd5d82b8",
        "storage_key": "property/6767906449167600/019fc97a-ba7b-7268-a9ee-14f9bd5d82b8.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ4aXexATrwIcRbxruCNo2JG0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_31e8a575-d6d8-458b-ad04-cb08170a6437",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167600",
      "source": "custom",
      "poi_name": "Brookridge Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "10100 Lowell Ave, Overland Park, KS 66212, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167600/019fc97d-b62f-746b-942b-3688c00c9ec5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc97d-b62f-746b-942b-3688c00c9ec5",
        "storage_key": "property/6767906449167600/019fc97d-b62f-746b-942b-3688c00c9ec5.webp",
        "width": 348,
        "height": 348
      },
      "poi_business_url": "http://opkansas.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6433772751155709519&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "brookridge-park",
      "poi_latitude": "38.9460029",
      "poi_longitude": "-94.6776548",
      "poi_miles_from_property": "2.1",
      "poi_walking_minutes": "47 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 913-895-6390",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167600/019fc97a-ba8c-729b-a509-4a4184f818f4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc97a-ba8c-729b-a509-4a4184f818f4",
        "storage_key": "property/6767906449167600/019fc97a-ba8c-729b-a509-4a4184f818f4.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ8dBzia_rwIcRT0Y5xjpaSVk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_683cd0be-7484-44c4-8e14-0f0e3a90f085",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167600",
      "source": "custom",
      "poi_name": "Indian Creek Recreation Center",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "10308 Marty St, Overland Park, KS 66212, USA",
      "poi_short_description": "Dog-friendly park with a playground and a small water park, plus tennis courts.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167600/019fc97d-b4cd-746e-8e31-63abe45656e0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc97d-b4cd-746e-8e31-63abe45656e0",
        "storage_key": "property/6767906449167600/019fc97d-b4cd-746e-8e31-63abe45656e0.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.opkansas.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4418406476268149154&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "indian-creek-recreation-center",
      "poi_latitude": "38.9418777",
      "poi_longitude": "-94.6732051",
      "poi_miles_from_property": "2.1",
      "poi_walking_minutes": "44 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 913-895-6390",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167600/019fc97a-ba8c-729b-a509-4a4184f818f4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc97a-ba8c-729b-a509-4a4184f818f4",
        "storage_key": "property/6767906449167600/019fc97a-ba8c-729b-a509-4a4184f818f4.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ4UBzebHrwIcRopk_y0dVUT0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_5758a8d9-72f9-43ae-aee7-18132b1dacad",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167600",
      "source": "custom",
      "poi_name": "Roe Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "10400 Roe Ave, Overland Park, KS 66207, USA",
      "poi_short_description": "40-acre green space boasting a swimming pool, sports courts, a playground & hiking/biking trails.",
      "poi_long_description": "40-acre green space boasting a swimming pool, sports courts, a playground & hiking/biking trails.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167600/019fc97a-aa8c-702e-aabe-8035bbddfa3d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc97a-aa8c-702e-aabe-8035bbddfa3d",
        "storage_key": "property/6767906449167600/019fc97a-aa8c-702e-aabe-8035bbddfa3d.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.opkansas.org/park/roe-park/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5745814544235702059&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "roe-park",
      "poi_latitude": "38.939606",
      "poi_longitude": "-94.6420669",
      "poi_miles_from_property": "4",
      "poi_walking_minutes": "1 hour 26 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 913-895-6390",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167600/019fc97a-ba8c-729b-a509-4a4184f818f4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc97a-ba8c-729b-a509-4a4184f818f4",
        "storage_key": "property/6767906449167600/019fc97a-ba8c-729b-a509-4a4184f818f4.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJHWhkHX_pwIcRKydxpuI7vU8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_1ee9640d-3ef1-4a54-994f-32859c65e15e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167600",
      "source": "custom",
      "poi_name": "Pinehurst East Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "10210 Glenwood St, Overland Park, KS 66212, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167600/019fc97d-b68f-7611-b6db-9bca37977d61.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc97d-b68f-7611-b6db-9bca37977d61",
        "storage_key": "property/6767906449167600/019fc97d-b68f-7611-b6db-9bca37977d61.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://opkansas.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13927669142818851065&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "pinehurst-east-park",
      "poi_latitude": "38.942582",
      "poi_longitude": "-94.662057",
      "poi_miles_from_property": "2.7",
      "poi_walking_minutes": "58 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 913-327-6630",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167600/019fc97a-ba8c-729b-a509-4a4184f818f4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc97a-ba8c-729b-a509-4a4184f818f4",
        "storage_key": "property/6767906449167600/019fc97a-ba8c-729b-a509-4a4184f818f4.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJkSIZacnrwIcR-QjjHksFScE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_217471a7-5072-4856-a12a-e0006ad998df",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167600",
      "source": "custom",
      "poi_name": "James Place Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "6301 Indian Creek Dr, Overland Park, KS 66212, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167600/019fc97d-bd99-75ac-991e-caef05ae1fb6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc97d-bd99-75ac-991e-caef05ae1fb6",
        "storage_key": "property/6767906449167600/019fc97d-bd99-75ac-991e-caef05ae1fb6.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://opkansas.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7199580260294972862&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "james-place-park",
      "poi_latitude": "38.93971690000001",
      "poi_longitude": "-94.6610932",
      "poi_miles_from_property": "2.9",
      "poi_walking_minutes": "1 hour 3 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 913-895-6000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167600/019fc97a-ba8c-729b-a509-4a4184f818f4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc97a-ba8c-729b-a509-4a4184f818f4",
        "storage_key": "property/6767906449167600/019fc97a-ba8c-729b-a509-4a4184f818f4.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJX0y72MvrwIcRvtXLChoM6mM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_525b534a-34f4-45e8-be18-7ccdb8dde35d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167600",
      "source": "custom",
      "poi_name": "Strang Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "West 88th and, Farley St, Overland Park, KS 66212, USA",
      "poi_short_description": "Relaxed playground-surrounded park featuring swings, basketball courts, and tennis courts along with a picnic shelter and a grill.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167600/01a01015-d297-755f-8386-4a66900c6228.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a01015-d297-755f-8386-4a66900c6228",
        "storage_key": "property/6767906449167600/01a01015-d297-755f-8386-4a66900c6228.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.opkansas.org/park/strang-park/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3266416833072127371&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "strang-park",
      "poi_latitude": "38.9679845",
      "poi_longitude": "-94.699823",
      "poi_miles_from_property": "2.6",
      "poi_walking_minutes": "1 hour 0 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 913-895-6000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167600/019fc97a-ba8c-729b-a509-4a4184f818f4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc97a-ba8c-729b-a509-4a4184f818f4",
        "storage_key": "property/6767906449167600/019fc97a-ba8c-729b-a509-4a4184f818f4.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJUYsGCWXrwIcRi92er82kVC0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_3400519b-918c-456b-a92a-3d217469de89",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167600",
      "source": "custom",
      "poi_name": "South Lake Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "7601 W 86th St, Overland Park, KS 66212, USA",
      "poi_short_description": "This 14-acre park features a playground, a trail, a fishing lake, basketball, restrooms & more.",
      "poi_long_description": "This 14-acre park features a playground, a trail, a fishing lake, basketball, restrooms & more.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167600/01a01015-d5be-748e-a84c-94825ab170c8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a01015-d5be-748e-a84c-94825ab170c8",
        "storage_key": "property/6767906449167600/01a01015-d5be-748e-a84c-94825ab170c8.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.opkansas.org/things-to-see-and-do/parks/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9828798773383756620&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "south-lake-park",
      "poi_latitude": "38.9725",
      "poi_longitude": "-94.6738889",
      "poi_miles_from_property": "4",
      "poi_walking_minutes": "1 hour 30 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 913-895-6000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167600/019fc97a-ba8c-729b-a509-4a4184f818f4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc97a-ba8c-729b-a509-4a4184f818f4",
        "storage_key": "property/6767906449167600/019fc97a-ba8c-729b-a509-4a4184f818f4.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJdSu1Ko_rwIcRTHtVwGjoZog",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_4c3270c6-7678-4c45-8ad9-4d90a99c0e3d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167600",
      "source": "custom",
      "poi_name": "Midwest Trust Center",
      "poi_type": "Entertainment",
      "poi_address": "12345 College Blvd, Overland Park, KS 66210, USA",
      "poi_short_description": "Performing-arts center hosting a variety of concerts, dance performances & film screenings.",
      "poi_long_description": "Performing-arts center hosting a variety of concerts, dance performances & film screenings.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167600/019ff6b7-f70b-773a-b0eb-3616bf60992a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff6b7-f70b-773a-b0eb-3616bf60992a",
        "storage_key": "property/6767906449167600/019ff6b7-f70b-773a-b0eb-3616bf60992a.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.jccc.edu/midwest-trust-center/",
      "poi_directions_map_url": "https://maps.google.com/?cid=333406106616415315&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "midwest-trust-center",
      "poi_latitude": "38.9252624",
      "poi_longitude": "-94.7279145",
      "poi_miles_from_property": "2.3",
      "poi_walking_minutes": "51 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 913-469-4445",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167600/019fc97a-ba7b-7268-a9ee-14f9bd5d82b8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc97a-ba7b-7268-a9ee-14f9bd5d82b8",
        "storage_key": "property/6767906449167600/019fc97a-ba7b-7268-a9ee-14f9bd5d82b8.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJgVtOx9LqwIcRU0TRZhZ_oAQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "performing_arts_theater"
    },
    {
      "id": "custom_ee706982-c113-473a-a501-a82412e8af0b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167600",
      "source": "custom",
      "poi_name": "Mission Transit Center",
      "poi_type": "Transportation & Transit",
      "poi_address": "5251 Johnson Dr, Roeland Park, KS 66205, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://ridekc.org/locations/mission_transit_center",
      "poi_directions_map_url": "https://maps.google.com/?cid=14750820283784844061&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "mission-transit-center",
      "poi_latitude": "39.0229186",
      "poi_longitude": "-94.6460432",
      "poi_miles_from_property": "8.3",
      "poi_walking_minutes": "3 hours 3 mins",
      "poi_biking_minutes": "47 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167600/019fc97d-cdb2-72f5-960d-475097a0fa69.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc97d-cdb2-72f5-960d-475097a0fa69",
        "storage_key": "property/6767906449167600/019fc97d-cdb2-72f5-960d-475097a0fa69.webp",
        "width": 138,
        "height": 192
      },
      "poi_google_place_id": "ChIJ0RGVf9XtwIcRHVOfGOVwtcw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "parking_lot"
    },
    {
      "id": "custom_811652bc-f4f4-431e-83fd-acdbac9b8a9b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167600",
      "source": "custom",
      "poi_name": "Aspiria",
      "poi_type": "Major Employers & Offices",
      "poi_address": "6140 Sprint Pkwy STE 125, Overland Park, KS 66211, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167600/01a01015-d6f9-74c5-9142-417edcd76975.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a01015-d6f9-74c5-9142-417edcd76975",
        "storage_key": "property/6767906449167600/01a01015-d6f9-74c5-9142-417edcd76975.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://aspiriakc.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6433786320914474865&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "aspiria",
      "poi_latitude": "38.9169728",
      "poi_longitude": "-94.6568885",
      "poi_miles_from_property": "4.8",
      "poi_walking_minutes": "1 hour 46 mins",
      "poi_biking_minutes": "32 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 913-285-5800",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167600/019fc97a-ba7b-7268-a9ee-14f9bd5d82b8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc97a-ba7b-7268-a9ee-14f9bd5d82b8",
        "storage_key": "property/6767906449167600/019fc97a-ba7b-7268-a9ee-14f9bd5d82b8.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJP0ZxsczrwIcRceffOpJmSVk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_f3db49ea-0622-4efa-a7d1-943acf353935",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167600",
      "source": "custom",
      "poi_name": "Black & Veatch",
      "poi_type": "Major Employers & Offices",
      "poi_address": "11401 Lamar Ave, Overland Park, KS 66211, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167600/019fc97d-c23d-7554-8421-2508ec4c8521.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc97d-c23d-7554-8421-2508ec4c8521",
        "storage_key": "property/6767906449167600/019fc97d-c23d-7554-8421-2508ec4c8521.webp",
        "width": 1280,
        "height": 653
      },
      "poi_business_url": "http://www.bv.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15245877116558125981&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "black--veatch",
      "poi_latitude": "38.9250015",
      "poi_longitude": "-94.6553624",
      "poi_miles_from_property": "4.1",
      "poi_walking_minutes": "1 hour 32 mins",
      "poi_biking_minutes": "30 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 913-458-2000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167600/019fc97a-ba7b-7268-a9ee-14f9bd5d82b8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc97a-ba7b-7268-a9ee-14f9bd5d82b8",
        "storage_key": "property/6767906449167600/019fc97a-ba7b-7268-a9ee-14f9bd5d82b8.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJUyTe2TrqwIcRnSu0HXY8lNM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "consultant"
    },
    {
      "id": "custom_a373dca5-95f9-40f7-b9f8-8e18f0f4442b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167600",
      "source": "custom",
      "poi_name": "Saint Luke's South Hospital",
      "poi_type": "Health and Wellness",
      "poi_address": "12300 Metcalf Ave, Overland Park, KS 66213, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167600/019fc97d-c254-72ec-afe9-0ef8dc76ba70.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc97d-c254-72ec-afe9-0ef8dc76ba70",
        "storage_key": "property/6767906449167600/019fc97d-c254-72ec-afe9-0ef8dc76ba70.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.saintlukeskc.org/locations/saint-lukes-south-hospital?utm_source=local-listing&utm_medium=organic&utm_campaign=website-link",
      "poi_directions_map_url": "https://maps.google.com/?cid=8966224544508452770&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "saint-lukes-south-hospital",
      "poi_latitude": "38.9041982",
      "poi_longitude": "-94.6695167",
      "poi_miles_from_property": "4.8",
      "poi_walking_minutes": "1 hour 46 mins",
      "poi_biking_minutes": "32 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 913-317-7000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167600/019fc97a-ba79-70a6-99cb-f9c074d7c192.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc97a-ba79-70a6-99cb-f9c074d7c192",
        "storage_key": "property/6767906449167600/019fc97a-ba79-70a6-99cb-f9c074d7c192.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJkT2aF3LqwIcRop_Q17dtbnw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "general_hospital"
    },
    {
      "id": "custom_9985de73-9d03-4562-b0e3-4ea9af2f9fe7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167600",
      "source": "custom",
      "poi_name": "AdventHealth South Overland Park Hospital",
      "poi_type": "Health and Wellness",
      "poi_address": "7820 W 165th St, Overland Park, KS 66223, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167600/01a01015-da05-7697-964a-e369d4baf294.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a01015-da05-7697-964a-e369d4baf294",
        "storage_key": "property/6767906449167600/01a01015-da05-7697-964a-e369d4baf294.webp",
        "width": 1280,
        "height": 727
      },
      "poi_business_url": "https://www.adventhealth.com/hospital/adventhealth-south-overland-park",
      "poi_directions_map_url": "https://maps.google.com/?cid=9373271053670540671&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "adventhealth-south-overland-park-hospital",
      "poi_latitude": "38.8328311",
      "poi_longitude": "-94.6805899",
      "poi_miles_from_property": "9.3",
      "poi_walking_minutes": "3 hours 26 mins",
      "poi_biking_minutes": "57 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 913-373-2000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167600/019fc97a-ba79-70a6-99cb-f9c074d7c192.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc97a-ba79-70a6-99cb-f9c074d7c192",
        "storage_key": "property/6767906449167600/019fc97a-ba79-70a6-99cb-f9c074d7c192.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJxQPX-BrBwIcRf-V7kVyMFII",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_77fb03a1-7e20-4539-9f63-8807580543ce",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167600",
      "source": "custom",
      "poi_name": "Overland Park City Hall",
      "poi_type": "Major Employers & Offices",
      "poi_address": "8500 Santa Fe Dr, Overland Park, KS 66212, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167600/019ff6b7-fb2d-765a-bc5d-db132de94171.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff6b7-fb2d-765a-bc5d-db132de94171",
        "storage_key": "property/6767906449167600/019ff6b7-fb2d-765a-bc5d-db132de94171.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.opkansas.org/park/city-hall-park/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10640252352095117489&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "overland-park-city-hall",
      "poi_latitude": "38.97448380000001",
      "poi_longitude": "-94.6854831",
      "poi_miles_from_property": "3.6",
      "poi_walking_minutes": "1 hour 22 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 913-895-6000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167600/01a01015-e2f2-7239-a49c-d68098237b6b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a01015-e2f2-7239-a49c-d68098237b6b",
        "storage_key": "property/6767906449167600/01a01015-e2f2-7239-a49c-d68098237b6b.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJmdh8t4HrwIcRseAkxyPFqZM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_faa7f483-ba1f-40c3-92fc-7588ae6f7064",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167600",
      "source": "custom",
      "poi_name": "Johnson County Administration Building",
      "poi_type": "Major Employers & Offices",
      "poi_address": "111 S Cherry St, Olathe, KS 66061, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167600/01a01015-dac8-7778-aa30-c743fee2f5ee.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a01015-dac8-7778-aa30-c743fee2f5ee",
        "storage_key": "property/6767906449167600/01a01015-dac8-7778-aa30-c743fee2f5ee.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.jocogov.org/contact-us/all-locations/administration-building",
      "poi_directions_map_url": "https://maps.google.com/?cid=15575052816225759890&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "johnson-county-administration-building",
      "poi_latitude": "38.8815028",
      "poi_longitude": "-94.8200342",
      "poi_miles_from_property": "8.8",
      "poi_walking_minutes": "3 hours 19 mins",
      "poi_biking_minutes": "55 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 913-715-7400",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167600/01a01015-e2f2-7239-a49c-d68098237b6b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a01015-e2f2-7239-a49c-d68098237b6b",
        "storage_key": "property/6767906449167600/01a01015-e2f2-7239-a49c-d68098237b6b.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJc9_Fbvq9wIcRknIVJQS0Jdg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "local_government_office"
    },
    {
      "id": "custom_4755fca3-e189-4c73-9cd3-182ba3de7bad",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167600",
      "source": "custom",
      "poi_name": "AdventHealth Shawnee Mission",
      "poi_type": "Health and Wellness",
      "poi_address": "9100 W 74th St, Merriam, KS 66204, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167600/01a01015-daf0-76b5-960e-2aba10f663e1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a01015-daf0-76b5-960e-2aba10f663e1",
        "storage_key": "property/6767906449167600/01a01015-daf0-76b5-960e-2aba10f663e1.webp",
        "width": 720,
        "height": 405
      },
      "poi_business_url": "https://www.adventhealth.com/hospital/adventhealth-shawnee-mission",
      "poi_directions_map_url": "https://maps.google.com/?cid=13000316506480230417&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "adventhealth-shawnee-mission",
      "poi_latitude": "38.9954504",
      "poi_longitude": "-94.6921104",
      "poi_miles_from_property": "4.8",
      "poi_walking_minutes": "1 hour 47 mins",
      "poi_biking_minutes": "31 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 913-676-2000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167600/019fc97a-ba79-70a6-99cb-f9c074d7c192.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc97a-ba79-70a6-99cb-f9c074d7c192",
        "storage_key": "property/6767906449167600/019fc97a-ba79-70a6-99cb-f9c074d7c192.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJDc_MeIvswIcREcBm6PtmarQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_e08c5d9e-109f-45bc-8168-491f4b55c0b9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167600",
      "source": "custom",
      "poi_name": "Mosaic Cafe",
      "poi_type": "Restaurants",
      "poi_address": "11241 W 95th St Unit 27, Overland Park, KS 66214, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "false",
      "poi_directions_map_url": "https://www.google.com/maps/place/?q=place_id:ChIJtUC7LObrwIcRJoVBJPRBzss",
      "poi_item_slug": "mosaic-cafe",
      "poi_latitude": "38.9539657",
      "poi_longitude": "-94.7186033",
      "poi_miles_from_property": "1.1",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "+1 612-232-4354",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167600/019fc97a-ba9d-7688-b856-b4396334c8e2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc97a-ba9d-7688-b856-b4396334c8e2",
        "storage_key": "property/6767906449167600/019fc97a-ba9d-7688-b856-b4396334c8e2.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJtUC7LObrwIcRJoVBJPRBzss",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "cafe"
    },
    {
      "id": "custom_8075bbe1-4319-48c9-a680-f8e1e71b78a0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167600",
      "source": "custom",
      "poi_name": "Palacio Maya Mexican Restaurant",
      "poi_type": "Restaurants",
      "poi_address": "9720 Quivira Rd, Lenexa, KS 66215, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "false",
      "poi_directions_map_url": "https://www.google.com/maps/place/?q=place_id:ChIJWVwGvm7rwIcRzW3gjONvk2g",
      "poi_item_slug": "palacio-maya-mexican-restaurant",
      "poi_latitude": "38.9514617",
      "poi_longitude": "-94.7250447",
      "poi_miles_from_property": "1.2",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "+1 913-242-7724",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167600/019fc97a-ba9d-7688-b856-b4396334c8e2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc97a-ba9d-7688-b856-b4396334c8e2",
        "storage_key": "property/6767906449167600/019fc97a-ba9d-7688-b856-b4396334c8e2.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJWVwGvm7rwIcRzW3gjONvk2g",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "mexican_restaurant"
    },
    {
      "id": "custom_91ef4a4e-23d4-4e13-9601-c2fd9010f9c5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167600",
      "source": "custom",
      "poi_name": "CAVA",
      "poi_type": "Restaurants",
      "poi_address": "11895 W 95th St, Overland Park, KS 66214, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "false",
      "poi_directions_map_url": "https://www.google.com/maps/place/?q=place_id:ChIJySRquj_rwIcRlD9WpxZOqFg",
      "poi_item_slug": "cava",
      "poi_latitude": "38.9561981",
      "poi_longitude": "-94.7227465",
      "poi_miles_from_property": "1.3",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "+1 913-393-9024",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167600/019fc97a-ba9d-7688-b856-b4396334c8e2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc97a-ba9d-7688-b856-b4396334c8e2",
        "storage_key": "property/6767906449167600/019fc97a-ba9d-7688-b856-b4396334c8e2.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJySRquj_rwIcRlD9WpxZOqFg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "mediterranean_restaurant"
    },
    {
      "id": "custom_bc55b00b-9461-4d74-8e90-f1426ca4b0c4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167600",
      "source": "custom",
      "poi_name": "Cheddar's Scratch Kitchen",
      "poi_type": "Restaurants",
      "poi_address": "11865 W 95th St, Overland Park, KS 66214, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "false",
      "poi_directions_map_url": "https://www.google.com/maps/place/?q=place_id:ChIJLeUb7EnrwIcRw2P9gfSe0Nc",
      "poi_item_slug": "cheddars-scratch-kitchen",
      "poi_latitude": "38.95623",
      "poi_longitude": "-94.72209",
      "poi_miles_from_property": "1.3",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "+1 913-599-3111",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167600/019fc97a-ba9d-7688-b856-b4396334c8e2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc97a-ba9d-7688-b856-b4396334c8e2",
        "storage_key": "property/6767906449167600/019fc97a-ba9d-7688-b856-b4396334c8e2.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJLeUb7EnrwIcRw2P9gfSe0Nc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "custom_c445b27f-b63f-41d5-ab2c-9bc08d7bc9af",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167600",
      "source": "custom",
      "poi_name": "Tequila Harry's Mexican Restaurant",
      "poi_type": "Restaurants",
      "poi_address": "11817 College Blvd, Overland Park, KS 66210, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "false",
      "poi_directions_map_url": "https://www.google.com/maps/place/?q=place_id:ChIJfeO33tPqwIcRvkab03Qn0eI",
      "poi_item_slug": "tequila-harrys-mexican-restaurant",
      "poi_latitude": "38.9264548",
      "poi_longitude": "-94.7229557",
      "poi_miles_from_property": "1.3",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "+1 913-469-6644",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167600/019fc97a-ba9d-7688-b856-b4396334c8e2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc97a-ba9d-7688-b856-b4396334c8e2",
        "storage_key": "property/6767906449167600/019fc97a-ba9d-7688-b856-b4396334c8e2.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJfeO33tPqwIcRvkab03Qn0eI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "mexican_restaurant"
    },
    {
      "id": "custom_d3db78ca-8065-4a59-9394-20ef5afcd06e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167600",
      "source": "custom",
      "poi_name": "First Watch",
      "poi_type": "Restaurants",
      "poi_address": "12242 W 95th St, Lenexa, KS 66215, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "false",
      "poi_directions_map_url": "https://www.google.com/maps/place/?q=place_id:ChIJBd2VLtaVwIcR3xf4jDPzHaI",
      "poi_item_slug": "first-watch",
      "poi_latitude": "38.9569045",
      "poi_longitude": "-94.727773",
      "poi_miles_from_property": "1.6",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "+1 913-348-7482",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167600/019fc97a-ba9d-7688-b856-b4396334c8e2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc97a-ba9d-7688-b856-b4396334c8e2",
        "storage_key": "property/6767906449167600/019fc97a-ba9d-7688-b856-b4396334c8e2.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJBd2VLtaVwIcR3xf4jDPzHaI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "breakfast_restaurant"
    },
    {
      "id": "custom_5914a25f-2a4d-48bb-bb98-8125abe7f765",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167600",
      "source": "custom",
      "poi_name": "Tortilla Ranch Mexican Grill",
      "poi_type": "Restaurants",
      "poi_address": "8617 College Blvd, Overland Park, KS 66210, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "false",
      "poi_directions_map_url": "https://www.google.com/maps/place/?q=place_id:ChIJSQdXrlfqwIcRzb8xV6zStTk",
      "poi_item_slug": "tortilla-ranch-mexican-grill",
      "poi_latitude": "38.9268386",
      "poi_longitude": "-94.6843858",
      "poi_miles_from_property": "1.6",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "+1 913-451-5663",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167600/019fc97a-ba9d-7688-b856-b4396334c8e2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc97a-ba9d-7688-b856-b4396334c8e2",
        "storage_key": "property/6767906449167600/019fc97a-ba9d-7688-b856-b4396334c8e2.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJSQdXrlfqwIcRzb8xV6zStTk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "mexican_restaurant"
    },
    {
      "id": "custom_733f1bea-3092-4b70-89de-ec7f78ca09d5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167600",
      "source": "custom",
      "poi_name": "El Fogón Overland Park",
      "poi_type": "Restaurants",
      "poi_address": "10450 Metcalf Ave, Overland Park, KS 66212, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "false",
      "poi_directions_map_url": "https://www.google.com/maps/place/?q=place_id:ChIJYbeFX7TrwIcRcW-2QUZvH90",
      "poi_item_slug": "el-fogon-overland-park",
      "poi_latitude": "38.9387848",
      "poi_longitude": "-94.6695235",
      "poi_miles_from_property": "2.0",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "+1 913-642-1819",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167600/019fc97a-ba9d-7688-b856-b4396334c8e2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc97a-ba9d-7688-b856-b4396334c8e2",
        "storage_key": "property/6767906449167600/019fc97a-ba9d-7688-b856-b4396334c8e2.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJYbeFX7TrwIcRcW-2QUZvH90",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "mexican_restaurant"
    },
    {
      "id": "custom_a33c772c-b427-43c7-ae82-c78dfd9f60ea",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167600",
      "source": "custom",
      "poi_name": "Urban Eats",
      "poi_type": "Restaurants",
      "poi_address": "11832 Quivira Rd, Overland Park, KS 66210, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "false",
      "poi_directions_map_url": "https://www.google.com/maps/place/?q=place_id:ChIJz-36AXXrwIcR4Ho6YG564vo",
      "poi_item_slug": "urban-eats",
      "poi_latitude": "38.91385",
      "poi_longitude": "-94.72429",
      "poi_miles_from_property": "2.1",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "+1 913-400-2610",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167600/019fc97a-ba9d-7688-b856-b4396334c8e2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc97a-ba9d-7688-b856-b4396334c8e2",
        "storage_key": "property/6767906449167600/019fc97a-ba9d-7688-b856-b4396334c8e2.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJz-36AXXrwIcR4Ho6YG564vo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "indian_restaurant"
    },
    {
      "id": "custom_a3ceb1da-4646-40a0-a06f-ce9375db5c36",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167600",
      "source": "custom",
      "poi_name": "Santa Fe Café",
      "poi_type": "Restaurants",
      "poi_address": "9946 W 87th St, Overland Park, KS 66212, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "false",
      "poi_directions_map_url": "https://www.google.com/maps/place/?q=place_id:ChIJMZAArWbrwIcR1yIEQNl_dsQ",
      "poi_item_slug": "santa-fe-cafe",
      "poi_latitude": "38.9716847",
      "poi_longitude": "-94.7024618",
      "poi_miles_from_property": "2.2",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "+1 913-648-5402",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167600/019fc97a-ba9d-7688-b856-b4396334c8e2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc97a-ba9d-7688-b856-b4396334c8e2",
        "storage_key": "property/6767906449167600/019fc97a-ba9d-7688-b856-b4396334c8e2.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJMZAArWbrwIcR1yIEQNl_dsQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "breakfast_restaurant"
    },
    {
      "id": "custom_76661577-a854-42fb-a67a-96a55e0735df",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167600",
      "source": "custom",
      "poi_name": "Kansas City International Airport",
      "poi_type": "Transportation & Transit",
      "poi_address": "1 Kansas City Blvd, Kansas City, MO 64153, USA",
      "poi_short_description": "Airport featuring domestic & global flights plus free WiFi & a variety of eateries.",
      "poi_long_description": "Airport featuring domestic & global flights plus free WiFi & a variety of eateries.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167600/019fc97d-c0ae-76ea-ba47-1b096c58612d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc97d-c0ae-76ea-ba47-1b096c58612d",
        "storage_key": "property/6767906449167600/019fc97d-c0ae-76ea-ba47-1b096c58612d.webp",
        "width": 1280,
        "height": 854
      },
      "poi_business_url": "http://www.flykc.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14109162014977743520&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "kansas-city-international-airport",
      "poi_latitude": "39.3014091",
      "poi_longitude": "-94.7104536",
      "poi_miles_from_property": "36.4",
      "poi_walking_minutes": "13 hours 34 mins",
      "poi_biking_minutes": "3 hours 56 mins",
      "poi_driving_minutes": "33 mins",
      "poi_business_phone": "+1 816-243-5237",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167600/019fc97a-bd12-773e-bb6a-e9fb346d64d1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc97a-bd12-773e-bb6a-e9fb346d64d1",
        "storage_key": "property/6767906449167600/019fc97a-bd12-773e-bb6a-e9fb346d64d1.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJmYfmiAhewIcRoNouXRnQzcM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "international_airport"
    }
  ],
  "office_hours": [
    {
      "id": "ec_50bed117f7ed9d87545502ef",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167600",
      "day": "MON",
      "open_time": "09:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_6f1341c58106be48a194ba7a",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167600",
      "day": "TUE",
      "open_time": "09:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_26c51545b745ddae5cdf6d3b",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167600",
      "day": "WED",
      "open_time": "09:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_b5fd72aa911fe65989f62bcc",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167600",
      "day": "THU",
      "open_time": "09:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_7e7629b837689f73180cbe3d",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167600",
      "day": "FRI",
      "open_time": "09:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_bb436cc82f8555ff4c442a04",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167600",
      "day": "SAT",
      "open_time": "10:00",
      "close_time": "17:00"
    }
  ],
  "reviews": [
    {
      "id": "ec_3740b5b1e06ec7a0d1df70ea",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167600",
      "rating": "5",
      "name": "JD Don",
      "text": "⭐⭐⭐⭐⭐\nHighland Park Apartment is one of the best communities managed by Price Brothers. The leasing office staff is professional, respectful, and always willing to help.\n\nI had a few situations where I was late on rent and received notices, but the management team worked with me and helped me resolve everything. They genuinely care about residents and try to find solutions rather than just pushing people out.\n\nThe maintenance team is also outstanding—very responsive, professional, and reliable. Even after hours and on weekends, they handle issues quickly, which is something you don’t see often. The landscaping is always well maintained and the property overall looks clean, organized, and well cared for.\n\nOverall, excellent management, great communication, and a strong sense of community. I definitely recommend this property.",
      "date": "2026-04-17",
      "title": "false"
    },
    {
      "id": "ec_e0b31d14356d0441d6d42bfb",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167600",
      "rating": "5",
      "name": "Ali Thabta",
      "text": "I really love living here. The management team is incredibly kind and professional, and the maintenance staff is excellent and very responsive. I currently live in a one-bedroom apartment and would love to move to a two-bedroom unit.\n\nUnfortunately, there are no two-bedroom units available at the moment. I understand that the apartments being returned are undergoing renovations, which has resulted in higher pricing. I truly hope that a two-bedroom unit becomes available at a more affordable rate, as I honestly can’t imagine living in a better place or with a better management team.\n\nThank you very much for your time and consideration.",
      "date": "2026-07-06",
      "title": "false"
    },
    {
      "id": "ec_55a1593a15c1e0085fcd5de0",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167600",
      "rating": "5",
      "name": "Jennifer Oliva",
      "text": "I’ve been living here for almost a month, when I came and toured in November, Vanessa did an amazing job at showing us around and showing us all the amenities of this complex. She really made us feel welcome and made this feel like home. I’m am so glad she was my tour guide and to see there is still leasing agents who do such an amazing job!",
      "date": "2026-01-20",
      "title": "false"
    },
    {
      "id": "ec_7991535b797603efd10b7c60",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167600",
      "rating": "5",
      "name": "Michelle Baker",
      "text": "We recently toured Highland Park Apartments in Overland Park, Kansas and had an excellent experience thanks to Hunter.\nHunter was also a pleasure to work with—friendly, professional, informative, and genuinely focused on helping us find the right fit. He represents the community so well, and we truly appreciated his time and attention.\nHighly recommend asking for Hunter if you’re considering Highland Park Apartments!",
      "date": "2026-04-24",
      "title": "false"
    }
  ],
  "virtual_tours": [
    {
      "id": "ec_3e2799c4fa31b880ec7b75c9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167600",
      "source": "yardi",
      "url_health_error": "false",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167600/01a01028-1a77-704a-b507-7eb41fff47f6.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "01a01028-1a77-704a-b507-7eb41fff47f6",
        "storage_key": "property/6767906449167600/01a01028-1a77-704a-b507-7eb41fff47f6.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "A1",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=pvjpSje6QfD"
    },
    {
      "id": "ec_2c1b6942fd6200f8ceae4956",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167600",
      "source": "yardi",
      "url_health_error": "false",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167600/01a01028-1a09-70cc-8267-1b05489821fa.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "01a01028-1a09-70cc-8267-1b05489821fa",
        "storage_key": "property/6767906449167600/01a01028-1a09-70cc-8267-1b05489821fa.webp",
        "width": 800,
        "height": 449
      },
      "virtual_tour_title": "A2",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=dFjzirAoQ5r"
    },
    {
      "id": "ec_5ff6dd6a7863dfc0d576e686",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167600",
      "source": "yardi",
      "url_health_error": "false",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167600/01a01028-1ae8-7669-b718-e1f9fca168b1.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "01a01028-1ae8-7669-b718-e1f9fca168b1",
        "storage_key": "property/6767906449167600/01a01028-1ae8-7669-b718-e1f9fca168b1.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "A3",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=PpqJTqu9BaF"
    },
    {
      "id": "ec_81cf8b197736cd1e260c7572",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167600",
      "source": "yardi",
      "url_health_error": "false",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167600/01a01028-1a0b-72bf-9fbe-57585336c3a6.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "01a01028-1a0b-72bf-9fbe-57585336c3a6",
        "storage_key": "property/6767906449167600/01a01028-1a0b-72bf-9fbe-57585336c3a6.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "A4",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=vbBuAKDr5wb"
    },
    {
      "id": "ec_ffda71362f4a6d4745943bb8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167600",
      "source": "yardi",
      "url_health_error": "false",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167600/01a01028-1c08-76be-94e0-6d09cda347e2.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "01a01028-1c08-76be-94e0-6d09cda347e2",
        "storage_key": "property/6767906449167600/01a01028-1c08-76be-94e0-6d09cda347e2.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "A5",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=WQcmqD3vZkS"
    },
    {
      "id": "ec_32827373a90fc0c4579fdba3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167600",
      "source": "yardi",
      "url_health_error": "false",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167600/01a01028-2188-719d-99cf-f5b3123de01c.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "01a01028-2188-719d-99cf-f5b3123de01c",
        "storage_key": "property/6767906449167600/01a01028-2188-719d-99cf-f5b3123de01c.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "B1",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=7RRdCSQNXsx"
    },
    {
      "id": "ec_2f44002a7250b055216a3ed7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167600",
      "source": "yardi",
      "url_health_error": "false",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167600/01a01028-2116-76b9-8391-95a52f834a9b.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "01a01028-2116-76b9-8391-95a52f834a9b",
        "storage_key": "property/6767906449167600/01a01028-2116-76b9-8391-95a52f834a9b.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "B2",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=yCrXCrLtRkq"
    }
  ],
  "faqs": [
    {
      "id": "custom_27cec481-1d32-4af2-98ea-ccc275e9fb4e",
      "question": "What are the qualifications for occupancy?",
      "answer": "Check our occupancy qualifications <a href=\"https://www.pricebrotherskc.com/ResidentialRentalQualifications/\">here</a>. We encourage everyone to apply, and hope to have you as a part of our community!",
      "category": "Rental Qualifications",
      "source": "custom"
    },
    {
      "id": "custom_4969d172-63a5-443a-85aa-fe6649ccb9f5",
      "question": "What is the application fee and is it refundable?",
      "answer": "Application fees are due for each person 18 and older occupying the apartment. All application fees are nonrefundable.",
      "category": "Admin",
      "source": "custom"
    },
    {
      "id": "custom_32dffac6-9e98-4b7b-a578-98fc45b39445",
      "question": "How do I apply?",
      "answer": "Click on the <a href=\"/apply-now\">Apply Now</a> button under the <a href=\"/floor-plans\">Floor Plans</a> tab of our community website.",
      "category": "Admin",
      "source": "custom"
    },
    {
      "id": "custom_f0868354-b34f-4691-88e3-96086d3a008d",
      "question": "What is a holding deposit or earnest money?",
      "answer": "A \"holding\" deposit or \"earnest money\" is another word for \"security\" deposit. Please <a href=\"/contact-us\">contact our leasing office</a> for more details.",
      "category": "Admin",
      "source": "custom"
    },
    {
      "id": "custom_1b004428-30e3-4779-a878-27b7815233d2",
      "question": "Are there different lease term options available?",
      "answer": "Yes, we offer various lease term options. Please <a href=\"/contact-us\">contact our office</a> for more details.",
      "category": "Admin",
      "source": "custom"
    },
    {
      "id": "custom_4af866e0-9fb1-48df-a7f5-ea76ac3cf854",
      "question": "Do I need an appointment to take a tour?",
      "answer": "No appointment is necessary to tour our community during business hours; however, it is always appreciated if you call ahead to make sure we are available to provide adequate time for you to tour and ask questions. It is recommended to arrive no later than one half hour prior to closing if you would like to tour the community. Everyone over 18 years of age must have a valid photo ID to tour. Valid forms of identification are decided by Price Brothers Management Company and may include items such as: US Driver’s License, US State Photo ID, US Military Photo ID, US Visa with Photo ID upon it, US Citizenship and Immigration Services Photo ID, Passport.",
      "category": "Admin",
      "source": "custom"
    },
    {
      "id": "custom_d9ddbdf4-696e-4ae2-8924-851475a538ed",
      "question": "Do you allow pets?",
      "answer": "Our community is happy to accept cats and dogs. Please refer to our pet section on the <a href=\"/pet-policy\">Pet Policy</a> page.",
      "category": "Admin",
      "source": "custom"
    },
    {
      "id": "custom_d4431920-cfd6-487c-8a83-d205c115cd2e",
      "question": "What utilities am I responsible to pay?",
      "answer": "Our residents are responsible to pay for water, trash, and electric.",
      "category": "Admin",
      "source": "custom"
    },
    {
      "id": "custom_0d7e8b7f-79cb-4010-8b47-66b1c379710a",
      "question": "Why does your pricing include ranges?",
      "answer": "The prices will range on each floor plan depending on finishes, views, and other features inside the apartment home.",
      "category": "Admin",
      "source": "custom"
    },
    {
      "id": "custom_e40c51f3-04ca-419e-be1c-e1b84e4b5e43",
      "question": "Do you require renters insurance?",
      "answer": "All residents are required to maintain a minimum of $100,000 in liability coverage as part of their lease agreement. For more details on coverage requirements and available options, please <a href=\"/contact-us\">contact our leasing office</a>.",
      "category": "Admin",
      "source": "custom"
    },
    {
      "id": "custom_b0c227c9-7ed5-4ea9-98a4-2caf0a4e33b8",
      "question": "How can I refer a friend?",
      "answer": "If you love living here and want to refer a friend, please let our office know! We offer resident referral programs throughout the year and would love for your friends and family to join our community.",
      "category": "Admin",
      "source": "custom"
    },
    {
      "id": "custom_cea052b6-028e-49d6-b43d-395bb7c7273d",
      "question": "How can I pay my rent?",
      "answer": "You can pay rent by accessing your <a href=\"/resident-access\">resident online account</a>. This allows you to use a bank account or credit card to make payments.",
      "category": "Admin",
      "source": "custom"
    },
    {
      "id": "custom_4462e44d-e782-48a0-9367-aa978022dfa5",
      "question": "Do you offer flexible rent payment options?",
      "answer": "Yes! We’ve partnered with Flex to make paying rent easier for our residents. Flex allows you to split your rent into smaller, more manageable payments throughout the month, giving you added financial flexibility. For more details or to sign up, <a href=\"/contact-us\">contact our leasing office</a> today!",
      "category": "Admin",
      "source": "custom"
    },
    {
      "id": "custom_df391322-fe5b-4e38-8c13-6743e6ba9313",
      "question": "Do you offer covered parking?",
      "answer": "Yes, we offer carports. Please <a href=\"/contact-us\">contact the office</a> for our most current carport pricing and availability.",
      "category": "Amenities",
      "source": "custom"
    },
    {
      "id": "custom_95bbc834-ce03-40c0-a424-3ca607bc2d9a",
      "question": "Do you host events at your property?",
      "answer": "Yes, we host events throughout the year with various activities to encourage community camaraderie.",
      "category": "Amenities",
      "source": "custom"
    },
    {
      "id": "custom_001a5bea-d35b-43fc-b909-61e79e1da12d",
      "question": "Do you accept packages on behalf of the residents?",
      "answer": "No, we do not offer this service at this time.",
      "category": "Amenities",
      "source": "custom"
    },
    {
      "id": "custom_09cc8b8d-e117-40f4-8da4-e636a07f2b2e",
      "question": "If something needs to be repaired in my apartment, how do I report it?",
      "answer": "You may call the office or submit work orders online by accessing your <a href=\"/resident-access\">resident account</a>. All emergency repairs should be reported by <a href=\"/contact-us\">contacting the office</a>. If the emergency is being reported after business hours, please follow the prompts to be connected to the answering service.",
      "category": "Maintenance",
      "source": "custom"
    }
  ],
  "fees": [],
  "pet_policies": [],
  "lead_collectors": [
    {
      "lead_collector_id": "01a0c9ac-371a-77d8-a1b3-ac44f76dd5f9",
      "lead_source": "PROPERTY_WEBSITE",
      "name": "Highland Park Apartment Homes Property Website",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167600"
    },
    {
      "lead_collector_id": "01a0c9ac-379d-76c3-a453-439a6bffa11c",
      "lead_source": "LANDING_PAGE",
      "name": "Highland Park Apartment Homes Landing Page",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167600"
    }
  ],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167600",
      "source": "custom",
      "page_item_url": "in-unit-laundry-apartments-overland-park",
      "search_query": "in unit laundry apartments overland park",
      "category": "Amenity",
      "h1_title": "In-Unit Laundry Apartments in Overland Park",
      "h2_subtitle": "Discover the convenience of in-unit laundry in Overland Park. Enjoy modern living with this essential amenity at Highland Park Apartment Homes.",
      "page_copy": "Experience the pinnacle of convenient living with in-unit laundry apartments in Overland Park at Highland Park Apartment Homes. Our thoughtfully renovated one- and two-bedroom apartment homes in the scenic Lincoln Highlands neighborhood offer exceptional in-home amenities designed for your comfort and convenience. \n\nIn addition to in-unit laundry, residents enjoy spacious interiors with walk-in closets and a touch of outdoor tranquility with private outdoor spaces. Beyond the comfort of your home, take advantage of our community features, including a sand volleyball court and dedicated package service. Choose Highland Park Apartment Homes in Johnson County for a lifestyle that prioritizes convenience.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167600/019fc97b-eeb4-75a8-8ebf-8f8f10a5511a.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of a community swimming pool and lounge area with apartment buildings in the background.",
        "public_id": "019fc97b-eeb4-75a8-8ebf-8f8f10a5511a",
        "storage_key": "property/6767906449167600/019fc97b-eeb4-75a8-8ebf-8f8f10a5511a.webp",
        "width": 1200,
        "height": 900
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "In-Unit Laundry Apartments Overland Park",
      "seo_description": "Explore Highland Park Apartment Homes in Overland Park, offering in-unit laundry, modern amenities, and a convenient lifestyle.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167600",
      "source": "custom",
      "page_item_url": "air-conditioned-apartments-lincoln-highlands",
      "search_query": "air conditioned apartments lincoln highlands",
      "category": "Amenity",
      "h1_title": "Air Conditioned Apartments in Lincoln Highlands",
      "h2_subtitle": "Stay cool in Lincoln Highlands with air-conditioned apartments. Experience relaxed living at Highland Park Apartment Homes.",
      "page_copy": "Embrace comfortable living with air-conditioned apartments in Lincoln Highlands at Highland Park Apartment Homes. Our renovated one- and two-bedroom apartments are designed to provide a cool and inviting environment, perfect for escaping the Kansas heat.\n\nSituated in the charming neighborhood of Lincoln Highlands, these homes feature not only in-home air conditioning but also walk-in closets, in-unit laundry, and private outdoor spaces. Community amenities like a sand volleyball court and reliable package service enhance the appeal, ensuring a vibrant and convenient lifestyle. Choose Highland Park Apartment Homes for a refreshing living experience in Overland Park, KS.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167600/019fc97b-eeb4-75a8-8ebf-8f8f10a5511a.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of a community swimming pool and lounge area with apartment buildings in the background.",
        "public_id": "019fc97b-eeb4-75a8-8ebf-8f8f10a5511a",
        "storage_key": "property/6767906449167600/019fc97b-eeb4-75a8-8ebf-8f8f10a5511a.webp",
        "width": 1200,
        "height": 900
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Air Conditioned Apartments Lincoln Highlands",
      "seo_description": "Discover air-conditioned apartments at Highland Park in Lincoln Highlands for comfortable living with modern amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167600",
      "source": "custom",
      "page_item_url": "apartments-with-pool-johnson-county",
      "search_query": "apartments with pool johnson county",
      "category": "Amenity",
      "h1_title": "Apartments with Pool in Johnson County",
      "h2_subtitle": "Enjoy leisure living with apartments featuring a pool in Johnson County. Highland Park Apartment Homes offers this and more.",
      "page_copy": "Discover the comfort of apartments with a pool in Johnson County at Highland Park Apartment Homes. Our community provides a lifestyle balanced with relaxation and enjoyment, ideal for those seeking a refreshing retreat.\n\nNestled in the Lincoln Highlands neighborhood, our one- and two-bedroom apartment homes offer not only access to a pool but also modern touches like in-unit laundry and private outdoor spaces. Enhance your living experience with community amenities such as a sand volleyball court and package services. Choose Highland Park Apartments and dive into a vibrant lifestyle in Overland Park, KS.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167600/019fc97b-eeb4-75a8-8ebf-8f8f10a5511a.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of a community swimming pool and lounge area with apartment buildings in the background.",
        "public_id": "019fc97b-eeb4-75a8-8ebf-8f8f10a5511a",
        "storage_key": "property/6767906449167600/019fc97b-eeb4-75a8-8ebf-8f8f10a5511a.webp",
        "width": 1200,
        "height": 900
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments with Pool Johnson County",
      "seo_description": "Find your next home with a pool at Highland Park Apartment Homes in Johnson County, offering modern living and community amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167600",
      "source": "custom",
      "page_item_url": "dishwasher-apartments-overland-park-ks",
      "search_query": "dishwasher apartments in overland park ks",
      "category": "Amenity",
      "h1_title": "Dishwasher Apartments in Overland Park, KS",
      "h2_subtitle": "Experience modern convenience with dishwasher-equipped apartments in Overland Park, KS. Welcome to Highland Park Apartment Homes.",
      "page_copy": "Streamline your everyday living with dishwasher-equipped apartments in Overland Park, KS, at Highland Park Apartment Homes. Our one- and two-bedroom residences come with a fully equipped kitchen that includes a dishwasher, making meal cleanup a breeze.\n\nSituated in the picturesque Lincoln Highlands, these homes offer more than just modern kitchens. Residents enjoy spacious walk-in closets, in-unit laundry, and private patios or balconies. Community amenities such as a sand volleyball court and efficient package services enhance the appeal of choosing Highland Park Apartment Homes as your next living destination in Johnson County.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167600/019fc97b-eeb4-75a8-8ebf-8f8f10a5511a.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of a community swimming pool and lounge area with apartment buildings in the background.",
        "public_id": "019fc97b-eeb4-75a8-8ebf-8f8f10a5511a",
        "storage_key": "property/6767906449167600/019fc97b-eeb4-75a8-8ebf-8f8f10a5511a.webp",
        "width": 1200,
        "height": 900
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Dishwasher Apartments Overland Park, KS",
      "seo_description": "Explore dishwasher-equipped apartments at Highland Park in Overland Park, KS, for modern living with convenient amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167600",
      "source": "custom",
      "page_item_url": "luxury-apartments-fitness-center-66214",
      "search_query": "luxury apartments with fitness center 66214",
      "category": "Amenity",
      "h1_title": "Luxury Apartments with Fitness Center 66214",
      "h2_subtitle": "Elevate your lifestyle with luxury apartments featuring a fitness center in the 66214 area. Discover Highland Park Apartment Homes today.",
      "page_copy": "Indulge in luxury living at Highland Park Apartment Homes, where our premium apartments in the 66214 area come with access to a state-of-the-art fitness center. Perfectly crafted for those who value health and wellness, our one- and two-bedroom homes provide a blend of style and convenience.\n\nLocated in the vibrant Lincoln Highlands neighborhood, these luxurious spaces are designed with features such as in-unit laundry, spacious walk-in closets, and private outdoor areas. Additional community amenities, including a sand volleyball court and efficient package service, add to the allure of choosing Highland Park as your new home base in Overland Park, KS.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167600/019fc97b-eeb4-75a8-8ebf-8f8f10a5511a.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of a community swimming pool and lounge area with apartment buildings in the background.",
        "public_id": "019fc97b-eeb4-75a8-8ebf-8f8f10a5511a",
        "storage_key": "property/6767906449167600/019fc97b-eeb4-75a8-8ebf-8f8f10a5511a.webp",
        "width": 1200,
        "height": 900
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Luxury Apartments with Fitness Center 66214",
      "seo_description": "Explore luxury apartments with a fitness center at Highland Park, located in the 66214 area, offering upscale living and premier amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167600",
      "source": "custom",
      "page_item_url": "one-bedroom-apartments-johnson-county",
      "search_query": "one bedroom apartments in Johnson County",
      "category": "Floorplan",
      "h1_title": "One Bedroom Apartments in Johnson County",
      "h2_subtitle": "Find the perfect one bedroom apartment in Johnson County at Highland Park. Enjoy renovated comfort in a prime location.",
      "page_copy": "Discover the ideal one bedroom apartment in Johnson County at Highland Park Apartment Homes. Our residences offer a blend of comfort and style, featuring thoughtful designs with modern finishes.\n\nLocated in the sought-after Lincoln Highlands neighborhood, our one bedroom apartments provide in-unit laundry, generous walk-in closets, and private patios or balconies. Residents can enjoy community amenities such as a sand volleyball court and reliable package service, making Highland Park Apartment Homes the perfect choice for those seeking cozy, modern living in Overland Park, KS.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167600/019fc97b-eeb4-75a8-8ebf-8f8f10a5511a.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of a community swimming pool and lounge area with apartment buildings in the background.",
        "public_id": "019fc97b-eeb4-75a8-8ebf-8f8f10a5511a",
        "storage_key": "property/6767906449167600/019fc97b-eeb4-75a8-8ebf-8f8f10a5511a.webp",
        "width": 1200,
        "height": 900
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "One Bedroom Apartments in Johnson County",
      "seo_description": "Explore Highland Park's one bedroom apartments in Johnson County, offering renovated comfort and community amenities in a prime Overland Park location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167600",
      "source": "custom",
      "page_item_url": "two-bedroom-floorplans-highland-park-ks",
      "search_query": "two bedroom floorplans Highland Park KS",
      "category": "Floorplan",
      "h1_title": "Two Bedroom Floorplans in Highland Park, KS",
      "h2_subtitle": "Explore spacious two bedroom floorplans at Highland Park Apartment Homes, KS. Perfect for your comfort and lifestyle.",
      "page_copy": "Highland Park Apartment Homes in Overland Park, KS, offer inviting two bedroom floorplans designed to meet your lifestyle needs. These well-thought-out spaces provide ample comfort with expansive layouts.\n\nNestled in the charming Lincoln Highlands area, our two bedroom apartments come equipped with in-home laundry, spacious walk-in closets, and private outdoor spaces. Enjoy the added benefits of community facilities like a sand volleyball court and on-site maintenance, ensuring a living experience as seamless as it is enjoyable in Johnson County.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167600/019fc97b-eeb4-75a8-8ebf-8f8f10a5511a.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of a community swimming pool and lounge area with apartment buildings in the background.",
        "public_id": "019fc97b-eeb4-75a8-8ebf-8f8f10a5511a",
        "storage_key": "property/6767906449167600/019fc97b-eeb4-75a8-8ebf-8f8f10a5511a.webp",
        "width": 1200,
        "height": 900
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Two Bedroom Floorplans Highland Park, KS",
      "seo_description": "Explore Highland Park's two bedroom floorplans in KS, offering spacious layouts with modern amenities in a desirable Overland Park location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167600",
      "source": "custom",
      "page_item_url": "apartments-near-apache-elementary-school-overland-park",
      "search_query": "apartments near Apache Elementary School Overland Park",
      "category": "School",
      "h1_title": "Apartments Near Apache Elementary School",
      "h2_subtitle": "Discover convenient living near Apache Elementary School in Overland Park with Highland Park Apartment Homes.",
      "page_copy": "Choosing Highland Park Apartment Homes places you conveniently near Apache Elementary School in Overland Park. Located in the welcoming Lincoln Highlands neighborhood, our community is perfect for those seeking quality education options close to home.\n\nOur spacious one- and two-bedroom apartments offer modern comforts such as in-home laundry facilities, ample walk-in closets, and private outdoor spaces. Community benefits like a sand volleyball court and efficient package service enhance the living experience, making Highland Park a superb choice in Johnson County.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167600/019fc97b-eeb4-75a8-8ebf-8f8f10a5511a.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of a community swimming pool and lounge area with apartment buildings in the background.",
        "public_id": "019fc97b-eeb4-75a8-8ebf-8f8f10a5511a",
        "storage_key": "property/6767906449167600/019fc97b-eeb4-75a8-8ebf-8f8f10a5511a.webp",
        "width": 1200,
        "height": 900
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Apache Elementary School",
      "seo_description": "Explore apartments near Apache Elementary School, Overland Park, at Highland Park, offering modern conveniences in a great location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167600",
      "source": "custom",
      "page_item_url": "highland-park-apartments-near-oak-park-carpenter-school",
      "search_query": "Highland Park apartments close to Oak Park-Carpenter Elementary School",
      "category": "School",
      "h1_title": "Highland Park Apartments Near Oak Park-Carpenter",
      "h2_subtitle": "Live conveniently near Oak Park-Carpenter Elementary School at Highland Park Apartment Homes in Overland Park, KS.",
      "page_copy": "Highland Park Apartment Homes offers a prime location close to Oak Park-Carpenter Elementary School in Overland Park. Our community is nestled in the serene Lincoln Highlands neighborhood, ensuring a peaceful yet accessible living experience.\n\nFeaturing spacious one- and two-bedroom homes with in-unit laundry, walk-in closets, and private balconies or patios, Highland Park provides the desirable combination of comfort and convenience. Alongside community amenities like a sand volleyball court and dedicated maintenance services, Highland Park caters to a range of lifestyle needs within Johnson County.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167600/019fc97b-eeb4-75a8-8ebf-8f8f10a5511a.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of a community swimming pool and lounge area with apartment buildings in the background.",
        "public_id": "019fc97b-eeb4-75a8-8ebf-8f8f10a5511a",
        "storage_key": "property/6767906449167600/019fc97b-eeb4-75a8-8ebf-8f8f10a5511a.webp",
        "width": 1200,
        "height": 900
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Highland Park Apts Near Oak Park-Carpenter School",
      "seo_description": "Discover Highland Park Apts, close to Oak Park-Carpenter Elementary, offering spacious living and amenities in Overland Park.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167600",
      "source": "custom",
      "page_item_url": "apartments-johnson-county-near-comanche-elementary",
      "search_query": "apartments in Johnson County near Comanche Elementary",
      "category": "School",
      "h1_title": "Apartments Near Comanche Elementary in Johnson Co",
      "h2_subtitle": "Find an ideal home in Johnson County near Comanche Elementary. Highland Park Apartment Homes offers convenience and comfort in Overland Park.",
      "page_copy": "Located in the heart of Johnson County, Highland Park Apartment Homes provides a convenient setting near Comanche Elementary. Nestled in the welcoming Lincoln Highlands neighborhood, residents enjoy a blend of tranquility and easy access to local amenities.\n\nOur one- and two-bedroom apartments feature modern comforts such as in-home laundry, spacious walk-in closets, and private balconies or patios. Community amenities like a sand volleyball court and responsive on-site maintenance further enhance the living experience, making Highland Park a superb choice in the Overland Park area.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167600/019fc97b-eeb4-75a8-8ebf-8f8f10a5511a.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of a community swimming pool and lounge area with apartment buildings in the background.",
        "public_id": "019fc97b-eeb4-75a8-8ebf-8f8f10a5511a",
        "storage_key": "property/6767906449167600/019fc97b-eeb4-75a8-8ebf-8f8f10a5511a.webp",
        "width": 1200,
        "height": 900
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apts in Johnson County Near Comanche Elementary",
      "seo_description": "Discover Highland Park apartments in Johnson County near Comanche Elementary, featuring spacious living and modern amenities in Overland Park.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167600",
      "source": "custom",
      "page_item_url": "apartments-near-westridge-middle-school-overland-park",
      "search_query": "apartments near Westridge Middle School Overland Park KS",
      "category": "School",
      "h1_title": "Apartments Near Westridge Middle School",
      "h2_subtitle": "Experience convenient living near Westridge Middle School in Overland Park, KS. Highland Park Apartment Homes offers comfort and accessibility.",
      "page_copy": "Choosing Highland Park Apartment Homes means enjoying the convenience of living near Westridge Middle School in Overland Park, KS. Situated in the welcoming community of Lincoln Highlands, our apartments offer the perfect balance of serene residential living and easy access to educational facilities.\n\nOur one- and two-bedroom apartments boast features like in-home laundry, expansive walk-in closets, and private outdoor spaces. Enhanced by amenities such as a sand volleyball court and attentive maintenance service, Highland Park Apartment Homes is a great fit for anyone looking for comfort and convenience in Johnson County.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167600/019fc97b-eeb4-75a8-8ebf-8f8f10a5511a.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of a community swimming pool and lounge area with apartment buildings in the background.",
        "public_id": "019fc97b-eeb4-75a8-8ebf-8f8f10a5511a",
        "storage_key": "property/6767906449167600/019fc97b-eeb4-75a8-8ebf-8f8f10a5511a.webp",
        "width": 1200,
        "height": 900
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Westridge Middle School, Overland Park",
      "seo_description": "Explore Highland Park apartments near Westridge Middle School, offering spacious living and desirable amenities in Overland Park, KS.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167600",
      "source": "custom",
      "page_item_url": "lincoln-highlands-apartments-near-indian-woods-middle",
      "search_query": "Lincoln Highlands apartments close to Indian Woods Middle School",
      "category": "School",
      "h1_title": "Lincoln Highlands Apts Near Indian Woods School",
      "h2_subtitle": "Discover comfortable living in Lincoln Highlands, conveniently located near Indian Woods Middle School in Overland Park, KS.",
      "page_copy": "Nestled within the charming Lincoln Highlands neighborhood, Highland Park Apartment Homes offers a prime location close to Indian Woods Middle School. Our community provides both comfort and convenient access to the school.\n\nChoose from our spacious one- and two-bedroom apartments, each designed with amenities like in-home laundry facilities, walk-in closets, and private outdoor spaces. Our community enhancements, including a sand volleyball court and on-site maintenance services, make Highland Park an excellent option for those seeking a well-rounded living experience in Johnson County.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167600/019fc97b-eeb4-75a8-8ebf-8f8f10a5511a.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of a community swimming pool and lounge area with apartment buildings in the background.",
        "public_id": "019fc97b-eeb4-75a8-8ebf-8f8f10a5511a",
        "storage_key": "property/6767906449167600/019fc97b-eeb4-75a8-8ebf-8f8f10a5511a.webp",
        "width": 1200,
        "height": 900
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Lincoln Highlands Apts Near Indian Woods Middle",
      "seo_description": "Explore Lincoln Highlands apts near Indian Woods Middle School, featuring spacious living and modern amenities in Overland Park, KS.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167600",
      "source": "custom",
      "page_item_url": "apartments-near-shawnee-mission-south-high-overland-park",
      "search_query": "apartments near Shawnee Mission South High School in Overland Park",
      "category": "School",
      "h1_title": "Apartments Near Shawnee Mission South High",
      "h2_subtitle": "Find your ideal apartment close to Shawnee Mission South High School. Enjoy modern comforts at Highland Park Apartment Homes in Overland Park, KS.",
      "page_copy": "Highland Park Apartment Homes provides an excellent option for those looking to live near Shawnee Mission South High School in Overland Park, KS. Located in the thriving Lincoln Highlands neighborhood, our community offers convenience and a peaceful residential setting.\n\nOur stylish one and two-bedroom apartments are designed with features like in-home laundry, walk-in closets, and private outdoor spaces. Residents benefit from a range of amenities, including a sand volleyball court and reliable on-site maintenance, ensuring a comfortable and convenient living experience in Johnson County.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167600/019fc97b-eeb4-75a8-8ebf-8f8f10a5511a.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of a community swimming pool and lounge area with apartment buildings in the background.",
        "public_id": "019fc97b-eeb4-75a8-8ebf-8f8f10a5511a",
        "storage_key": "property/6767906449167600/019fc97b-eeb4-75a8-8ebf-8f8f10a5511a.webp",
        "width": 1200,
        "height": 900
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apts Near Shawnee Mission South High, Overland Park",
      "seo_description": "Discover Highland Park apartments near Shawnee Mission South High School, offering spacious living and amenities in Overland Park, KS.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167600",
      "source": "custom",
      "page_item_url": "apartments-near-johnson-county-community-college-ks",
      "search_query": "apartments near Johnson County Community College KS",
      "category": "School",
      "h1_title": "Apts Near Johnson County Community College",
      "h2_subtitle": "Discover apartments near Johnson County Community College in KS. Highland Park offers convenience and comfort in Overland Park's Lincoln Highlands.",
      "page_copy": "Highland Park Apartment Homes provides an ideal living solution for those attending or working at Johnson County Community College in KS. Located in Overland Park's Lincoln Highlands, our community is just a short drive away, promising both convenience and a serene residential setting.\n\nChoose from our one and two-bedroom apartments, each designed to offer in-home laundry, roomy walk-in closets, and private outdoor spaces. Highland Park also provides premium community amenities, including a sand volleyball court and on-site maintenance, ensuring a supportive and vibrant living environment in Johnson County.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167600/019fc97b-eeb4-75a8-8ebf-8f8f10a5511a.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of a community swimming pool and lounge area with apartment buildings in the background.",
        "public_id": "019fc97b-eeb4-75a8-8ebf-8f8f10a5511a",
        "storage_key": "property/6767906449167600/019fc97b-eeb4-75a8-8ebf-8f8f10a5511a.webp",
        "width": 1200,
        "height": 900
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apts Near Johnson County Community College, KS",
      "seo_description": "Highland Park offers apts near Johnson County Community College in KS, with modern amenities in Overland Park's Lincoln Highlands.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167600",
      "source": "custom",
      "page_item_url": "highland-park-apartments-by-university-kansas-edwards-campus",
      "search_query": "Highland Park apartments by University of Kansas Edwards Campus",
      "category": "School",
      "h1_title": "Highland Park Apts by KU Edwards Campus",
      "h2_subtitle": "Explore Highland Park apartments near University of Kansas Edwards Campus. Enjoy easy access to education and amenities in Overland Park.",
      "page_copy": "Situated conveniently near the University of Kansas Edwards Campus, Highland Park Apartment Homes offers residents both proximity to educational opportunities and a comforting place to call home. Located in Lincoln Highlands, Overland Park, living here means access to both vibrant community life and peaceful residence.\n\nOur one and two-bedroom apartments are equipped with in-home laundry, spacious walk-in closets, and inviting private outdoor spaces. Residents can also enjoy community features like a sand volleyball court and dedicated on-site maintenance. Make Highland Park your base for both academic and personal growth in Johnson County.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167600/019fc97b-eeb4-75a8-8ebf-8f8f10a5511a.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of a community swimming pool and lounge area with apartment buildings in the background.",
        "public_id": "019fc97b-eeb4-75a8-8ebf-8f8f10a5511a",
        "storage_key": "property/6767906449167600/019fc97b-eeb4-75a8-8ebf-8f8f10a5511a.webp",
        "width": 1200,
        "height": 900
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Highland Park Apts by KU Edwards Campus",
      "seo_description": "Find Highland Park apartments by University of Kansas Edwards Campus, offering modern amenities and convenience in Overland Park.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167600",
      "source": "custom",
      "page_item_url": "apartments-near-overland-park-regional-medical-center",
      "search_query": "apartments near overland park regional medical center",
      "category": "Hospital",
      "h1_title": "Apts Near Overland Park Regional Medical Center",
      "h2_subtitle": "Discover apartments near Overland Park Regional Medical Center. Highland Park offers comfort and prime location in Johnson County.",
      "page_copy": "Highland Park Apartment Homes is the perfect choice for those seeking apartments near Overland Park Regional Medical Center. Set in the tranquil neighborhood of Lincoln Highlands, our community provides both serenity and quick access to the medical center.\n\nOur spacious one and two-bedroom homes include features like in-home laundry and walk-in closets, ensuring day-to-day convenience. The community offers a sand volleyball court and on-site maintenance services to support an active and stress-free lifestyle. Enjoy the best of both city and suburban living in Overland Park, KS.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167600/019fc97b-eeb4-75a8-8ebf-8f8f10a5511a.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of a community swimming pool and lounge area with apartment buildings in the background.",
        "public_id": "019fc97b-eeb4-75a8-8ebf-8f8f10a5511a",
        "storage_key": "property/6767906449167600/019fc97b-eeb4-75a8-8ebf-8f8f10a5511a.webp",
        "width": 1200,
        "height": 900
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apts Near Overland Park Regional Medical Center",
      "seo_description": "Find apartments near Overland Park Regional Medical Center at Highland Park, offering modern amenities and a convenient location in Johnson County.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167600",
      "source": "custom",
      "page_item_url": "apartments-close-to-childrens-mercy-kansas-johnson-county",
      "search_query": "apartments close to children's mercy kansas johnson county",
      "category": "Hospital",
      "h1_title": "Apts Close to Children's Mercy Kansas",
      "h2_subtitle": "Find apartments close to Children's Mercy Kansas in Johnson County. Highland Park provides modern living with convenient access.",
      "page_copy": "For anyone seeking apartments close to Children's Mercy Kansas in Johnson County, Highland Park Apartment Homes offers an ideal location. Nestled in Overland Park's Lincoln Highlands, our community provides a peaceful atmosphere while ensuring easy access to the hospital.\n\nOur one- and two-bedroom apartments feature in-home laundry facilities, walk-in closets, and private outdoor areas. Highland Park amenities include a sand volleyball court and reliable on-site maintenance, catering to both relaxation and convenience. Make Highland Park your home base in Johnson County today.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167600/019fc97b-eeb4-75a8-8ebf-8f8f10a5511a.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of a community swimming pool and lounge area with apartment buildings in the background.",
        "public_id": "019fc97b-eeb4-75a8-8ebf-8f8f10a5511a",
        "storage_key": "property/6767906449167600/019fc97b-eeb4-75a8-8ebf-8f8f10a5511a.webp",
        "width": 1200,
        "height": 900
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apts Close to Children's Mercy Kansas",
      "seo_description": "Discover apartments close to Children's Mercy Kansas at Highland Park, offering modern amenities and convenient living in Johnson County.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167600",
      "source": "custom",
      "page_item_url": "apartments-near-adventhealth-south-overland-park-hospital",
      "search_query": "apartments near adventhealth south overland park hospital",
      "category": "Hospital",
      "h1_title": "Apts Near AdventHealth South Overland Park",
      "h2_subtitle": "Explore apartments near AdventHealth South Overland Park Hospital. Highland Park offers comfort and location in Lincoln Highlands.",
      "page_copy": "Looking for apartments near AdventHealth South Overland Park Hospital? Highland Park Apartment Homes offers the perfect blend of location and lifestyle convenience. Nestled in the serene Lincoln Highlands neighborhood of Overland Park, our community is just a short drive from the hospital.\n\nOur one and two-bedroom apartments come complete with modern features such as in-home laundry, walk-in closets, and private outdoor spaces. Residents can also enjoy community perks like a sand volleyball court and dedicated maintenance team. Experience a peaceful yet connected living environment at Highland Park in Johnson County.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167600/019fc97b-eeb4-75a8-8ebf-8f8f10a5511a.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of a community swimming pool and lounge area with apartment buildings in the background.",
        "public_id": "019fc97b-eeb4-75a8-8ebf-8f8f10a5511a",
        "storage_key": "property/6767906449167600/019fc97b-eeb4-75a8-8ebf-8f8f10a5511a.webp",
        "width": 1200,
        "height": 900
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apts Near AdventHealth South Overland Park",
      "seo_description": "Find apartments near AdventHealth South Overland Park Hospital at Highland Park, offering modern amenities and a prime location in Overland Park.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167600",
      "source": "custom",
      "page_item_url": "apartments-close-to-adventhealth-shawnee-mission-lincoln-highlands",
      "search_query": "apartments close to adventhealth shawnee mission lincoln highlands",
      "category": "Hospital",
      "h1_title": "Apts Close to AdventHealth Shawnee Mission",
      "h2_subtitle": "Find apartments close to AdventHealth Shawnee Mission. Highland Park offers convenience and comfort in Lincoln Highlands.",
      "page_copy": "Highland Park Apartment Homes is the go-to destination for those seeking apartments close to AdventHealth Shawnee Mission. Positioned within the peaceful atmosphere of Lincoln Highlands, our community ensures easy commuting to the hospital.\n\nOffering one and two-bedroom homes, our apartments feature amenities that include in-home laundry and walk-in closets, making everyday living convenient and enjoyable. Residents also appreciate our sand volleyball court and reliable on-site maintenance services. Experience the balance of comfort and practicality at Highland Park, just a short journey from AdventHealth Shawnee Mission.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167600/019fc97b-eeb4-75a8-8ebf-8f8f10a5511a.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of a community swimming pool and lounge area with apartment buildings in the background.",
        "public_id": "019fc97b-eeb4-75a8-8ebf-8f8f10a5511a",
        "storage_key": "property/6767906449167600/019fc97b-eeb4-75a8-8ebf-8f8f10a5511a.webp",
        "width": 1200,
        "height": 900
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apts Close to AdventHealth Shawnee Mission",
      "seo_description": "Discover apartments close to AdventHealth Shawnee Mission at Highland Park, offering modern amenities and convenience in Lincoln Highlands.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167600",
      "source": "custom",
      "page_item_url": "apartments-near-overland-park-arboretum-and-botanical-gardens",
      "search_query": "apartments near overland park arboretum and botanical gardens",
      "category": "Park",
      "h1_title": "Apts Near Overland Park Arboretum",
      "h2_subtitle": "Explore apartments near Overland Park Arboretum and Botanical Gardens. Highland Park offers serene living close by.",
      "page_copy": "Located just a short drive from the Overland Park Arboretum and Botanical Gardens, Highland Park Apartment Homes offers the perfect escape for nature lovers. Situated in the picturesque Lincoln Highlands neighborhood, our community provides easy access to lush trails and scenic beauty.\n\nOur one and two-bedroom apartments are designed with comfort in mind, featuring modern amenities like in-home laundry and spacious walk-in closets. Enjoy community perks such as a sand volleyball court and attentive on-site maintenance. Embrace a lifestyle enriched by nature at Highland Park, near the Arboretum.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167600/019fc97b-eeb4-75a8-8ebf-8f8f10a5511a.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of a community swimming pool and lounge area with apartment buildings in the background.",
        "public_id": "019fc97b-eeb4-75a8-8ebf-8f8f10a5511a",
        "storage_key": "property/6767906449167600/019fc97b-eeb4-75a8-8ebf-8f8f10a5511a.webp",
        "width": 1200,
        "height": 900
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apts Near Overland Park Arboretum",
      "seo_description": "Find serene apartments near Overland Park Arboretum and Botanical Gardens at Highland Park, with modern amenities in a prime location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167600",
      "source": "custom",
      "page_item_url": "highland-park-apartment-homes-by-bluejacket-park",
      "search_query": "highland park apartment homes by bluejacket park",
      "category": "Park",
      "h1_title": "Highland Park Apts by Bluejacket Park",
      "h2_subtitle": "Discover Highland Park Apartment Homes by Bluejacket Park. Enjoy renovated comfort and nearby recreational opportunities in Lincoln Highlands.",
      "page_copy": "Highland Park Apartment Homes offers a convenient location by Bluejacket Park, providing residents with easy access to lush green spaces and recreational activities. Located in the peaceful Lincoln Highlands neighborhood, our community combines the tranquility of nature with the conveniences of modern living.\n\nOur one and two-bedroom homes feature renovations such as in-home laundry, expansive walk-in closets, and private outdoor areas. Residents can also take advantage of our community amenities, including a sand volleyball court and reliable on-site maintenance. Experience the perfect blend of comfort and location at Highland Park.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167600/019fc97b-eeb4-75a8-8ebf-8f8f10a5511a.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of a community swimming pool and lounge area with apartment buildings in the background.",
        "public_id": "019fc97b-eeb4-75a8-8ebf-8f8f10a5511a",
        "storage_key": "property/6767906449167600/019fc97b-eeb4-75a8-8ebf-8f8f10a5511a.webp",
        "width": 1200,
        "height": 900
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Highland Park Apts by Bluejacket Park",
      "seo_description": "Explore Highland Park Apartment Homes by Bluejacket Park, offering modern living and easy access to parks in Lincoln Highlands.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167600",
      "source": "custom",
      "page_item_url": "lincoln-highlands-apts-near-oak-park",
      "search_query": "lincoln highlands apts near oak park",
      "category": "Park",
      "h1_title": "Lincoln Highlands Apts Near Oak Park",
      "h2_subtitle": "Find Lincoln Highlands apartments near Oak Park. Highland Park offers comfort and convenience in a charming neighborhood setting.",
      "page_copy": "Highland Park Apartment Homes offers a prime location near Oak Park, ideal for those looking for Lincoln Highlands apartments. Nestled in a serene neighborhood, our community allows residents to enjoy shopping and nature excursions with ease.\n\nOur renovated one and two-bedroom apartments come equipped with modern amenities like in-home laundry and spacious walk-in closets. Community features include a sand volleyball court and dependable on-site maintenance. Discover the ideal blend of accessible, urban living with neighborhood charm at Highland Park, conveniently close to Oak Park.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167600/019fc97b-eeb4-75a8-8ebf-8f8f10a5511a.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of a community swimming pool and lounge area with apartment buildings in the background.",
        "public_id": "019fc97b-eeb4-75a8-8ebf-8f8f10a5511a",
        "storage_key": "property/6767906449167600/019fc97b-eeb4-75a8-8ebf-8f8f10a5511a.webp",
        "width": 1200,
        "height": 900
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Lincoln Highlands Apts Near Oak Park",
      "seo_description": "Explore Lincoln Highlands apartments near Oak Park at Highland Park Apartment Homes, offering modern amenities in a charming neighborhood.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167600",
      "source": "custom",
      "page_item_url": "overland-park-apartments-close-to-brookridge-park",
      "search_query": "overland park apartments close to brookridge park",
      "category": "Park",
      "h1_title": "Overland Park Apts Near Brookridge Park",
      "h2_subtitle": "Explore Overland Park apartments close to Brookridge Park. Highland Park Apartment Homes offers comfort and nearby recreation.",
      "page_copy": "Nestled just a short distance from Brookridge Park, Highland Park Apartment Homes provides residents with prime access to both nature and urban amenities in Overland Park. Our community, situated in the welcoming Lincoln Highlands neighborhood, is perfect for those who enjoy outdoor activities and the tranquility of nearby parks.\n\nOur thoughtfully renovated one and two-bedroom apartments feature amenities such as in-home laundry and generous walk-in closets, catering to a modern lifestyle. Residents can benefit from on-site amenities like a sand volleyball court and prompt maintenance service. Experience vibrant living combined with easy park access at Highland Park.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167600/019fc97b-eeb4-75a8-8ebf-8f8f10a5511a.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of a community swimming pool and lounge area with apartment buildings in the background.",
        "public_id": "019fc97b-eeb4-75a8-8ebf-8f8f10a5511a",
        "storage_key": "property/6767906449167600/019fc97b-eeb4-75a8-8ebf-8f8f10a5511a.webp",
        "width": 1200,
        "height": 900
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Overland Park Apts Near Brookridge Park",
      "seo_description": "Find Overland Park apartments close to Brookridge Park at Highland Park, offering modern living with nearby recreational options.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167600",
      "source": "custom",
      "page_item_url": "highland-park-apartment-homes-near-indian-creek-recreation",
      "search_query": "highland park apartment homes near indian creek recreation center",
      "category": "Park",
      "h1_title": "Highland Park Apts Near Indian Creek Rec Center",
      "h2_subtitle": "Discover Highland Park Apartment Homes near Indian Creek Recreation Center. Enjoy renovated living spaces and vibrant community amenities.",
      "page_copy": "Highland Park Apartment Homes, located conveniently near the Indian Creek Recreation Center, offers an ideal spot for residents seeking both dynamic activities and comfortable living. Situated within the charming neighborhood of Lincoln Highlands, our community offers easy access to one of the area's most popular recreational centers.\n\nResidents can choose from our one and two-bedroom floor plans that offer modern conveniences like in-home laundry and expansive walk-in closets. The community's amenities, such as a sand volleyball court and attentive on-site maintenance, further enhance the experience. Join us at Highland Park, where the perks of recreation and renovated comfort await.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167600/019fc97b-eeb4-75a8-8ebf-8f8f10a5511a.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of a community swimming pool and lounge area with apartment buildings in the background.",
        "public_id": "019fc97b-eeb4-75a8-8ebf-8f8f10a5511a",
        "storage_key": "property/6767906449167600/019fc97b-eeb4-75a8-8ebf-8f8f10a5511a.webp",
        "width": 1200,
        "height": 900
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Highland Park Apts Near Indian Creek Rec Center",
      "seo_description": "Explore Highland Park Apartment Homes near Indian Creek Recreation Center, offering a lively and comfortable living experience.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167600",
      "source": "custom",
      "page_item_url": "overland-park-apts-by-roe-park",
      "search_query": "overland park apts by roe park",
      "category": "Park",
      "h1_title": "Overland Park Apts by Roe Park",
      "h2_subtitle": "Discover Overland Park apartments located by Roe Park. Highland Park Apartment Homes offers modern amenities and a relaxed lifestyle.",
      "page_copy": "Situated close to the scenic Roe Park, Highland Park Apartment Homes offers residents a fantastic living experience in Overland Park. Located in the welcoming Lincoln Highlands neighborhood, our apartment community provides the perfect blend of natural beauty and modern conveniences.\n\nChoose from our one and two-bedroom apartments featuring amenities like in-home laundry and spacious walk-in closets. Community features such as a sand volleyball court and on-site maintenance add to the convenience and enjoyment of living here. Discover the lifestyle that combines both comfort and recreation at Highland Park, conveniently situated near Roe Park.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167600/019fc97b-eeb4-75a8-8ebf-8f8f10a5511a.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of a community swimming pool and lounge area with apartment buildings in the background.",
        "public_id": "019fc97b-eeb4-75a8-8ebf-8f8f10a5511a",
        "storage_key": "property/6767906449167600/019fc97b-eeb4-75a8-8ebf-8f8f10a5511a.webp",
        "width": 1200,
        "height": 900
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Overland Park Apts by Roe Park",
      "seo_description": "Find overland park apartments by Roe Park at Highland Park, offering modern living spaces and great amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167600",
      "source": "custom",
      "page_item_url": "lincoln-highlands-apartments-near-pinehurst-east-park",
      "search_query": "lincoln highlands apartments near pinehurst east park",
      "category": "Park",
      "h1_title": "Lincoln Highlands Apts Near Pinehurst East Park",
      "h2_subtitle": "Explore Lincoln Highlands apartments located near Pinehurst East Park. Highland Park Apartment Homes offers comfort with nature at your doorstep.",
      "page_copy": "Highland Park Apartment Homes, situated in the lovely Lincoln Highlands, provides an ideal living experience close to Pinehurst East Park. This location offers a perfect balance of useful amenities and the beauty of nature, ideal for those who appreciate outdoor leisure.\n\nOur renovated one and two-bedroom apartments feature convenient amenities such as in-home laundry and ample walk-in closets. Within the community, you'll find features like a sand volleyball court and dedicated maintenance services. Embrace a lifestyle of comfort and accessibility at Highland Park, where the tranquility of Pinehurst East Park is just moments away.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167600/019fc97b-eeb4-75a8-8ebf-8f8f10a5511a.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of a community swimming pool and lounge area with apartment buildings in the background.",
        "public_id": "019fc97b-eeb4-75a8-8ebf-8f8f10a5511a",
        "storage_key": "property/6767906449167600/019fc97b-eeb4-75a8-8ebf-8f8f10a5511a.webp",
        "width": 1200,
        "height": 900
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Lincoln Highlands Apts Near Pinehurst East Park",
      "seo_description": "Discover Lincoln Highlands apartments near Pinehurst East Park at Highland Park, offering modern amenities and close natural beauty.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167600",
      "source": "custom",
      "page_item_url": "highland-park-apts-close-to-james-place-park",
      "search_query": "highland park apts close to james place park",
      "category": "Park",
      "h1_title": "Highland Park Apts Near James Place Park",
      "h2_subtitle": "Find Highland Park apartments close to James Place Park. Enjoy a balanced lifestyle with modern amenities and park access.",
      "page_copy": "Nestled in the vibrant Lincoln Highlands area, Highland Park Apartment Homes offers an excellent living experience close to James Place Park. This prime location is perfect for those who enjoy easy access to outdoor activities and nature.\n\nChoose from our thoughtfully designed one and two-bedroom layouts, all featuring practical amenities like in-home laundry and large walk-in closets. Community perks include a sand volleyball court and a commitment to quality maintenance on site. Discover the harmonious blend of convenience and tranquil park views at Highland Park, where James Place Park is just a stone's throw away.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167600/019fc97b-eeb4-75a8-8ebf-8f8f10a5511a.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of a community swimming pool and lounge area with apartment buildings in the background.",
        "public_id": "019fc97b-eeb4-75a8-8ebf-8f8f10a5511a",
        "storage_key": "property/6767906449167600/019fc97b-eeb4-75a8-8ebf-8f8f10a5511a.webp",
        "width": 1200,
        "height": 900
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Highland Park Apts Near James Place Park",
      "seo_description": "Experience Highland Park apartments close to James Place Park, offering modern living and natural access.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167600",
      "source": "custom",
      "page_item_url": "overland-park-apartment-homes-near-strang-park",
      "search_query": "overland park apartment homes near strang park",
      "category": "Park",
      "h1_title": "Overland Park Apartment Homes by Strang Park",
      "h2_subtitle": "Discover Overland Park apartment homes conveniently located near Strang Park. Enjoy community and nature hand in hand at Highland Park.",
      "page_copy": "Highland Park Apartment Homes offers an exceptional lifestyle in Overland Park, sitting just a short distance from the lovely Strang Park. This location is ideal for those who love being close to recreational spaces while enjoying modern living.\n\nChoose from our spacious one and two-bedroom apartments that feature must-haves like in-home laundry and walk-in closets. The community is equipped with amenities such as a sand volleyball court and reliable maintenance services. Experience the perfect balance of comfort and convenience at Highland Park, where the beauty of Strang Park is only moments away.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167600/019fc97b-eeb4-75a8-8ebf-8f8f10a5511a.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of a community swimming pool and lounge area with apartment buildings in the background.",
        "public_id": "019fc97b-eeb4-75a8-8ebf-8f8f10a5511a",
        "storage_key": "property/6767906449167600/019fc97b-eeb4-75a8-8ebf-8f8f10a5511a.webp",
        "width": 1200,
        "height": 900
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Overland Park Apartment Homes by Strang Park",
      "seo_description": "Live near Strang Park at Highland Park Apartment Homes in Overland Park, offering nature access and modern amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167600",
      "source": "custom",
      "page_item_url": "lincoln-highlands-homes-close-to-south-lake-park",
      "search_query": "lincoln highlands homes close to south lake park",
      "category": "Park",
      "h1_title": "Lincoln Highlands Homes Near South Lake Park",
      "h2_subtitle": "Explore Lincoln Highlands homes located near South Lake Park. Highland Park Apartment Homes offers serene living with park access.",
      "page_copy": "Located in the charming Lincoln Highlands neighborhood, Highland Park Apartment Homes is just steps away from the serene South Lake Park. This perfect location is ideal for residents who cherish the tranquility of nature and the vibrancy of community life.\n\nOur one and two-bedroom homes are designed with modern comforts like in-home laundry and spacious walk-in closets. The community boasts amenities including a sand volleyball court and dedicated maintenance support. At Highland Park, you can enjoy spacious living, with the natural beauty of South Lake Park right at your doorstep.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167600/019fc97b-eeb4-75a8-8ebf-8f8f10a5511a.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of a community swimming pool and lounge area with apartment buildings in the background.",
        "public_id": "019fc97b-eeb4-75a8-8ebf-8f8f10a5511a",
        "storage_key": "property/6767906449167600/019fc97b-eeb4-75a8-8ebf-8f8f10a5511a.webp",
        "width": 1200,
        "height": 900
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Lincoln Highlands Homes Near South Lake Park",
      "seo_description": "Find Lincoln Highlands homes near South Lake Park at Highland Park, offering convenient modern living and park access.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167600",
      "source": "custom",
      "page_item_url": "highland-park-apts-near-overland-park-city-hall",
      "search_query": "highland park apts apartments near overland park city hall",
      "category": "Park",
      "h1_title": "Highland Park Apts Near Overland Park City Hall",
      "h2_subtitle": "Highland Park Apartments are conveniently near Overland Park City Hall. Enjoy urban conveniences with residential amenities close by.",
      "page_copy": "Highland Park Apartment Homes in Overland Park offer the perfect blend of convenience and comfort for city dwellers. Located conveniently close to the Overland Park City Hall, residents can enjoy quick access to civic amenities and city conveniences while relishing the calm atmosphere of their home.\n\nOur thoughtfully designed one and two-bedroom apartments include modern amenities such as in-home laundry and spacious walk-in closets. Community features like a sand volleyball court and attentive maintenance services enhance your living experience. At Highland Park, urban lifestyle meets suburban comfort, just a short distance from Overland Park City Hall.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167600/019fc97b-eeb4-75a8-8ebf-8f8f10a5511a.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of a community swimming pool and lounge area with apartment buildings in the background.",
        "public_id": "019fc97b-eeb4-75a8-8ebf-8f8f10a5511a",
        "storage_key": "property/6767906449167600/019fc97b-eeb4-75a8-8ebf-8f8f10a5511a.webp",
        "width": 1200,
        "height": 900
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Highland Park Apts Near Overland Park City Hall",
      "seo_description": "Live near Overland Park City Hall at Highland Park Apartments, where comfort meets city access.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167600",
      "source": "custom",
      "page_item_url": "apartments-near-kansas-city-international-airport-ks",
      "search_query": "apartments near kansas city international airport ks",
      "category": "Transit",
      "h1_title": "Apartments Near Kansas City International Airport",
      "h2_subtitle": "Find apartments conveniently located near Kansas City International Airport in KS. Highland Park offers proximity and comfort.",
      "page_copy": "Highland Park Apartment Homes provide a great living solution for those seeking proximity to Kansas City International Airport, KS. Located in Overland Park, these apartments offer easy airport access while ensuring a peaceful residential environment.\n\nOur one- and two-bedroom homes come equipped with features like in-home laundry facilities and generous walk-in closets. The community is enriched with amenities such as a sand volleyball court and a package service. These make Highland Park an ideal choice for anyone looking for convenience and modern living, within reach of the airport.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167600/019fc97b-eeb4-75a8-8ebf-8f8f10a5511a.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of a community swimming pool and lounge area with apartment buildings in the background.",
        "public_id": "019fc97b-eeb4-75a8-8ebf-8f8f10a5511a",
        "storage_key": "property/6767906449167600/019fc97b-eeb4-75a8-8ebf-8f8f10a5511a.webp",
        "width": 1200,
        "height": 900
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Kansas City International Airport",
      "seo_description": "Highland Park Apartments in Overland Park, KS, near Kansas City International Airport, blend convenience with comfort.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_csm",
      "type": "STRING",
      "value": "bobbi@repli360.com"
    },
    {
      "ID": "custom_repli_id",
      "type": "STRING",
      "value": "12701831789"
    },
    {
      "ID": "custom_google_gtm_id",
      "type": "STRING",
      "value": "GTM-WM7QB6ST"
    },
    {
      "ID": "custom_rollout_phase",
      "type": "STRING",
      "value": "Batch 7"
    },
    {
      "ID": "custom_vibesites_theme",
      "type": "STRING",
      "value": "Rise"
    },
    {
      "ID": "custom_ads_subscription",
      "type": "STRING",
      "value": "essential"
    },
    {
      "ID": "custom_rentcafe_chatbot",
      "type": "STRING",
      "value": "<script type=\"text/javascript\" src=\"//webchat.omni.cafe/webchatjs/a64dfae6-fe01-49ea-8709-1aafebd6d5e3/app.js?nocache=1&gaTracking=GT-MJKRKDNF&buttonbgcolor=000000&buttontextcolor=ffffff&chatheader=0&embed=false\"></script>"
    },
    {
      "ID": "custom_seo_subscription",
      "type": "STRING",
      "value": "essential"
    },
    {
      "ID": "custom_social_subscription",
      "type": "STRING",
      "value": "none"
    },
    {
      "ID": "custom_website_subscription",
      "type": "STRING",
      "value": "turnkey"
    },
    {
      "ID": "custom_ppc_tracking_phone_number",
      "type": "STRING",
      "value": "913-513-1945"
    },
    {
      "ID": "custom_apartmentsync_javascript_id",
      "type": "STRING",
      "value": "eyJpdiI6Iks5NFlISE5mOG02SjA3aldjNHlteFE9PSIsInZhbHVlIjoiTFBWbERpQkg4alQ4Q3p2bG1pSG9qQT09IiwibWFjIjoiZTA5YjIyZTU5YWNkZjc4OWE1MDMzMzZjMzVhNzBjMTJhYzYwZDJkMjVhNDc1MzFlZjJkMGVjMWYzYzcxODM4MCJ9"
    }
  ],
  "custom_csm": "bobbi@repli360.com",
  "custom_repli_id": "12701831789",
  "custom_google_gtm_id": "GTM-WM7QB6ST",
  "custom_rollout_phase": "Batch 7",
  "custom_vibesites_theme": "Rise",
  "custom_ads_subscription": "essential",
  "custom_rentcafe_chatbot": "<script type=\"text/javascript\" src=\"//webchat.omni.cafe/webchatjs/a64dfae6-fe01-49ea-8709-1aafebd6d5e3/app.js?nocache=1&gaTracking=GT-MJKRKDNF&buttonbgcolor=000000&buttontextcolor=ffffff&chatheader=0&embed=false\"></script>",
  "custom_seo_subscription": "essential",
  "custom_social_subscription": "none",
  "custom_website_subscription": "turnkey",
  "custom_ppc_tracking_phone_number": "913-513-1945",
  "custom_apartmentsync_javascript_id": "eyJpdiI6Iks5NFlISE5mOG02SjA3aldjNHlteFE9PSIsInZhbHVlIjoiTFBWbERpQkg4alQ4Q3p2bG1pSG9qQT09IiwibWFjIjoiZTA5YjIyZTU5YWNkZjc4OWE1MDMzMzZjMzVhNzBjMTJhYzYwZDJkMjVhNDc1MzFlZjJkMGVjMWYzYzcxODM4MCJ9",
  "custom_audioeye_site_id": "97372e41-8770-478e-b2bc-48299b3d0dc8",
  "custom_audioeye_site_hash": "697517cb1a2289b02b1ba2d0ca0bae23"
};

export const generatedAt = '2026-11-03T23:01:16.078Z';
